module.exports = {
	"cs": {
		"moet-core": {
			"select_language": {
				"title": "Vyberte jazyk",
				"paragraph": "Vybraný jazyk bude nastaven jako výchozí.",
				"submit": "OK"
			},
			"products": {
				"mandatory": "Vždy zahrnuto",
				"kco": {
					"name": {
						"default": "Pokladna"
					},
					"description": {
						"default": "Nabídněte všechny naše způsoby platby."
					},
					"options": {
						"kco-pay-now": {
							"name": {
								"default": "Zaplatit hned"
							},
							"description": {
								"default": "Nabídka okamžitých plateb kartou nebo bankovním převodem."
							}
						},
						"kco-pay-later": {
							"name": {
								"default": "Platba do 30 dnů"
							},
							"description": {
								"default": "Nabídněte 30 dnů na zaplacení. Žádné úroky."
							}
						},
						"kco-slice-it": {
							"name": {
								"default": "Financování"
							},
							"description": {
								"default": "Nabídněte splácení po dobu 6–36 měsíců.",
								"DE": "Nabídněte splácení po dobu 6–24 měsíců.",
								"AT": "Nabídněte splácení po dobu 6–24 měsíců."
							}
						},
						"kco-slice-it-in-3": {
							"name": {
								"default": "Splátky"
							},
							"description": {
								"default": "Nabídněte 3 bezúročné splátky.",
								"GB": "Nabídněte 3 bezúročné splátky."
							}
						},
						"kco-slice-it-in-4": {
							"name": {
								"default": "Rozdělte na 4",
								"US": "splátky",
								"AU": "Platba ve 4 splátkách"
							},
							"description": {
								"default": "Nabídněte 4 bezúročné splátky.",
								"GB": "Nabídněte 4 bezúročné splátky."
							}
						}
					}
				},
				"kp": {
					"name": {
						"default": "Způsoby platby"
					},
					"description": {
						"default": "Vybírejte z našich samostatných platebních řešení. Vyberte si jednu nebo jich zkombinujte několik. Jednoduchá, jednorázová integrace bez ohledu na to, co si vyberete."
					},
					"options": {
						"kp-pay-now": {
							"name": {
								"default": "Zaplatit hned"
							},
							"description": {
								"default": "Nabídka okamžitých plateb kartou nebo bankovním převodem."
							}
						},
						"kp-pay-later": {
							"name": {
								"default": "Platba do 30 dnů"
							},
							"description": {
								"default": "Nabídněte 30 dnů na zaplacení. Žádné úroky."
							}
						},
						"kp-slice-it": {
							"name": {
								"default": "Financování"
							},
							"description": {
								"default": "Nabídněte splácení po dobu 6–36 měsíců.",
								"DE": "Nabídněte splácení po dobu 6–24 měsíců.",
								"AT": "Nabídněte splácení po dobu 6–24 měsíců."
							}
						},
						"kp-slice-it-in-3": {
							"name": {
								"default": "Splátky"
							},
							"description": {
								"default": "Nabídněte 3 bezúročné splátky.",
								"GB": "Nabídněte 3 bezúročné splátky."
							}
						},
						"kp-slice-it-in-4": {
							"name": {
								"default": "Rozdělte na 4",
								"US": "4 splátky",
								"CA": "4 splátky",
								"AU": "Platba ve 4 splátkách"
							},
							"description": {
								"default": "Nabídněte 4 bezúročné splátky.",
								"GB": "Nabídněte 4 bezúročné splátky.",
								"US": "Objednávky od 35 do 1 000 USD lze rozdělit do 4 bezúročných splátek splatných každé 2 týdny.",
								"CA": "Objednávky od 35 do 1 000 USD lze rozdělit do 4 bezúročných splátek splatných každé 2 týdny."
							}
						}
					}
				},
				"kco_one": {
					"name": {
						"default": "Pokladna"
					},
					"description": {
						"default": "Nahraďte pokladnu svého obchodu kompletními pokladními službami Klarna."
					},
					"description_expanded": {
						"default": "Nahraďte pokladnu svého obchodu kompletními pokladními službami Klarna."
					}
				},
				"kp_one": {
					"name": {
						"default": "Způsob platby"
					},
					"description": {
						"default": "Přidání způsobů platby Klarna do stávající pokladny"
					},
					"description_expanded": {
						"default": "Nabídka způsobů platby Klarna vede k průměrnému zvýšení konverze o 30 %, AOV o 41 % a frekvence nákupů o 36 %."
					}
				}
			}
		},
		"products-fe": {
			"error_messages": {
				"validation": {
					"required": "Toto pole je nutné pro pokračování",
					"generic": "Zadaná hodnota je neplatná",
					"required_suffix": "je nutná pro pokračování",
					"generic_suffix": "je neplatná",
					"min_one": "Musíte vybrat nejméně jeden prvek",
					"min": "Musíte vybrat nejméně jeden {min} prvků",
					"max": "Nelze vybrat více než {max} prvků",
					"given_name": "Chybí jméno",
					"family_name": {
						"general": "Chybí příjmení",
						"too_short": "Uveďte prosím platné příjmení"
					},
					"date_of_birth": {
						"general": {
							"default": "Uveďte prosím platné datum narození (DD/MM/RRRR).",
							"US": "Uveďte prosím platné datum narození (MM/DD/RRRR)."
						},
						"too_young": "Všechny zúčastněné strany musí být starší 16 let",
						"too_young_eighteen": "Musíte být starší 18 let"
					},
					"street_address": "Uveďte prosím adresu",
					"street_address2": "Uveďte prosím platný řádek 2 adresy",
					"postal_code": "Uveďte prosím PSČ",
					"country": "Uveďte prosím zemi",
					"region": "Uveďte prosím region",
					"state": "Uveďte prosím stát",
					"iban": "Uveďte prosím číslo účtu (IBAN)",
					"companyName": "Uveďte prosím název společnosti",
					"email": "Uveďte prosím platný e-mail",
					"contact_email": "Uveďte prosím platný kontaktní e-mail",
					"support_email": "Uveďte prosím platný e-mail zákaznické podpory",
					"support_phone": "Uveďte prosím platné telefonní číslo podpory",
					"selling_countries": "Musíte vybrat nejméně jednu zemi",
					"store_category": "Musíte vybrat jednu z možností",
					"name": "Uveďte prosím název obchodu",
					"legal_form": "Vyberte si prosím jeden z uvedených typů podnikání",
					"generic_toggle_undefined": "Vyberte prosím jednu z možností",
					"website": "Uveďte prosím platnou adresu URL webu",
					"bankAccounts": "Uveďte prosím nejméně jeden bankovní účet",
					"product": "Vyberte prosím produkt",
					"platform": "Vyberte prosím platformu",
					"password": "Vytvořte si prosím silné heslo",
					"currency_code": "Uveďte prosím kód měny",
					"account_holder": "Uveďte prosím platného majitele bankovního účtu",
					"account_type": "Uveďte prosím platný typ bankovního účtu",
					"routing_number": "Uveďte prosím platné směrové číslo",
					"account_number": {
						"first": "Uveďte prosím platné číslo výchozího bankovního účtu",
						"second": "Uveďte prosím platné číslo účtu pro první dodatečný bankovní účet",
						"third": "Uveďte prosím platné číslo účtu pro druhý dodatečný bankovní účet",
						"fourth": "Uveďte prosím platné číslo účtu pro třetí dodatečný bankovní účet",
						"general": "Uveďte prosím platné číslo účtu"
					},
					"role": "Uveďte prosím roli",
					"address": "Uveďte prosím adresu",
					"political_exposed_person": "Uveďte prosím informace o PEP",
					"pep_position": "Uveďte prosím informace o pozici",
					"pep_relationship": "Uveďte prosím informace o vztahu k osobě PEP",
					"goodsCategory": "Uveďte prosím kategorii zboží",
					"registered": "Uveďte prosím informace o registraci vaší firmy",
					"subjectToVat": "Uveďte prosím DIČ",
					"registrationCourt": "Uveďte prosím registrační soud",
					"registrationId": {
						"general": {
							"default": "Zadejte platné registrační číslo",
							"AT": "Zadejte platné registrační číslo",
							"AU": "Zadat platný ACN",
							"ES": "Zadejte platný NIF/NIE/DNI společnosti",
							"GB": "Zadejte platné číslo organizace",
							"GR": "Zadejte platné číslo G.E.MI. (Γ.Ε.ΜΗ.)",
							"CA": "Zadejte platné číslo firmy",
							"NZ": "Zadejte prosím platné číslo firmy",
							"US": "Zadejte platné identifikační číslo zaměstnavatele"
						},
						"missing_leading_0_GB": "Uveďte prosím osmimístné číslo organizace. V čísle vaší organizace může chybět počáteční 0 (např. 03452678).",
						"invalid": {
							"default": "Zadejte prosím platné registrační číslo",
							"AT": "Registrační číslo by mělo mít 5 až 11 znaků. Vezměte prosím na vědomí, že toto není vaše DPH ani vaše ID obchodníka.",
							"AU": "ACN by mělo mít 9 číslic, bez mezery. Příklad: 123456789",
							"BE": "Registrační číslo by mělo mít 10 číslic. Příklad: 1234567890",
							"CA": "Číslo firmy by mělo mít 9 číslic. Příklad: 123456789",
							"CZ": "Registrační číslo by mělo mít 8 číslic. Příklad: 12345678",
							"DE": "Registrační číslo musí mít 6 až 11 znaků a musí začínat písmeny HRA, HRB, GnR, VR nebo PR, za nimiž následuje mezera. Vezměte prosím na vědomí, že toto není vaše DPH ani vaše ID obchodníka.",
							"ES": "NIF/NIE/DNI by měl mít 8 nebo 9 znaků začínajících 1 písmenem/číslicí, po nichž následuje 6 nebo 7 číslic a 1 písmeno/číslice.",
							"FI": "Registrační číslo by mělo mít 8 číslic s pomlčkou před poslední číslicí, bez mezery. Příklad: 1234567-8",
							"FR": "Registrační číslo by mělo mít 9 číslic, například 123 456 789 nebo 123456789 (SIREN), nebo 14 číslic, například 123 456 789 12345 nebo 12345678912345 (SIRET).",
							"IE": "Registrační číslo by mělo obsahovat 2 písmena a 6 číslic nebo pouze 6 číslic, pokud jste živnostník (např. AB123456).",
							"IT": "Registrační číslo by mělo mít 11 číslic (např. 01234567890) nebo kombinaci 16 číslic a velkých písmen (např. ABCABC12A12A123A).",
							"GB": "Číslo organizace by mělo mít 8 číslic. Příklad: 12345678 nebo dvě písmena následovaná 6 číslicemi (SC123456) nebo 1 písmeno následované 7 číslicemi (S1234567).",
							"GR": "Číslo G.E.MI. by mělo mít 12 číslic, např. 012345678901.",
							"NL": "Registrační číslo by mělo mít 8 číslic. Příklad: 12345678",
							"NO": "Registrační číslo by mělo mít 9 číslic bez mezer. Příklad: 123456789",
							"NZ": "Číslo firmy by mělo mít 13 číslic. Příklad: 1234567890123",
							"PL": "Registrační číslo by mělo mít 10 číslic bez mezer. Příklad: 1234561234",
							"PT": "Registrační číslo by mělo mít 9 číslic bez mezer. Příklad: 123123123",
							"SE": "Registrační číslo by mělo mít 10 číslic s pomlčkou, bez mezer. Příklad: 123456-1234",
							"US": "Identifikační číslo zaměstnavatele by mělo mít 9 číslic a za prvními dvěma číslicemi by měl být znak „-“. Příklad: 12-3456789",
							"MX": "RFC by měl mít 12 znaků, počínaje iniciálami společnosti, šestimístným datem založení a kontrolní hodnotou. Příklad: ABC921010H20"
						}
					},
					"tocLink": "Se smluvními podmínkami něco není v pořádku. Zkuste to prosím znovu nebo kontaktujte naši zákaznickou podporu na {supportEmail}",
					"vat": {
						"general": {
							"default": "Zadejte platné DIČ",
							"AU": "Zadejte platný ABN",
							"ES": "Zadejte prosím platný NIF/NIE/DNI společnosti",
							"NZ": "Zadejte platné číslo GST"
						},
						"invalid": {
							"default": "Neplatné DIČ",
							"AT": "DIČ by mělo být ATU následované 8 číslicemi. Příklad: ATU12345678",
							"AU": "Číslo ABN by mělo mít 11 číslic.",
							"CZ": "DIČ by mělo být CZ následované 8, 9 nebo 10 číslicemi. Příklad: CZ123456789",
							"GR": "Číslo DPH musí mít 9 číslic a musí začínat písmenem EL. Například: EL123456789",
							"DE": "DIČ by mělo být ATU následované 9 číslicemi. Příklad: DE123456789",
							"ES": "NIF/NIE/DNI by měl mít 8 nebo 9 znaků začínajících 1 písmenem/číslicí, po nichž následuje 6 nebo 7 číslic a 1 písmeno/číslice.",
							"FR": "DIČ by mělo být FR následované 2 písmeny/číslicemi a 9 číslicemi (SIREN), např. FRXX123456789.",
							"GB": "DIČ by mělo mít 6 až 15 znaků.",
							"IE": "DIČ by mělo být IE následované 8 nebo 9 znaky, které obsahují 1 nebo 2 písmena. Příklad: IE1234567WA, IE1234567A",
							"IT": "DIČ by mělo být IT následované 11 číslicemi. Příklad: IT12345678912",
							"NL": "DIČ by mělo být NL následované 9 číslicemi, po nichž následuje B a 2 číslice. Příklad: NL123456789B12",
							"NZ": "Číslo GST by mělo být osmimístné (12345678) nebo devítimístné, s pomlčkami nebo bez pomlček po třech číslicích (123-123-123 nebo 123123123).",
							"PL": "DIČ by mělo být PL následované 10 číslicemi. Příklad: PL1234567890",
							"PT": "DIČ by mělo být PT následované 9 číslicemi. Příklad: PT123123123",
							"MX": "RFC by měl začínat iniciálami společnosti, šestimístným datem založení a kontrolní hodnotou. Příklad: ABC921010H20"
						}
					},
					"personal_id": {
						"US": {
							"general": "Uveďte prosím poslední 4 číslice vašeho SSN.",
							"format": "Zadejte prosím poslední 4 číslice vašeho SSN."
						},
						"US_FULL_SSN": {
							"general": "Uveďte prosím celé (devítimístné) číslo SSN",
							"format": "Zadejte prosím celé (9 číslic) své číslo SSN."
						},
						"CA": {
							"general": "Uveďte prosím platné číslo SIN nebo číslo pasu.",
							"format": "SIN: XXX-XXX-XXX / Číslo pasu: ABXXXXXX"
						},
						"SE": {
							"general": "Zadejte prosím platné osobní identifikační číslo (PNO).",
							"format": "Zadejte prosím PNO ve formátu: RRRRMMDD-XXXX"
						},
						"FI": {
							"general": "Zadejte prosím platný osobní identifikační kód (HETU).",
							"format": "Zadejte prosím HETU ve formátu: DDMMYYSXXXX"
						},
						"NO": {
							"general": "Uveďte prosím platné národní identifikační číslo",
							"format": "Zadejte je prosím ve formátu: DDMMYYXXXXX"
						},
						"DK": {
							"general": "Zadejte prosím platné osobní identifikační číslo (CPR).",
							"format": "Zadejte prosím CPR ve formátu: RRMMYY-XXXX"
						},
						"IT": {
							"general": "Zadejte prosím platný fiskální kód",
							"format": "Zadejte prosím fiskální kód ve formátu: CLDNRG84L58H501R"
						},
						"ES": {
							"general": "Zadejte prosím platné osobní identifikační číslo (DNI nebo NIE).",
							"format": "Zadejte prosím DNI nebo NIE, např. 12345678A"
						},
						"PL": {
							"general": "Zadejte prosím platný osobní identifikační kód (PESEL)",
							"format": "Zadejte prosím PESEL ve formátu: YYMMDDZZZXQ"
						},
						"default": {
							"general": "Uveďte prosím platné číslo pasu"
						}
					},
					"store_name": "Uveďte prosím název obchodu"
				},
				"errors_keys": {
					"correlationIdLabel": "ID korelace: {correlationId}",
					"decisionTaken": "Rozhodnutí o předběžném posouzení již bylo přijato. Načtěte prosím stránku znovu.",
					"maintenanceMode": "Naše aplikace je momentálně mimo provoz z důvodu údržby. Podívejte se prosím brzy znovu.",
					"validation": {
						"storeName": {
							"invalidType": "Uveďte prosím platný název prodejny."
						},
						"email": {
							"invalidType": "Uveďte prosím platný e-mail."
						},
						"goodsCategory": {
							"invalidType": "Uveďte prosím kategorii zboží."
						},
						"website": {
							"invalidType": "Uveďte prosím platný web."
						}
					}
				}
			},
			"general": {
				"yes": "Ano",
				"no": "Ne",
				"encrypted_text": "*******",
				"pricing_link_eu": "Zobrazit všechny ceny podle země",
				"pricing_link_us": "Zobrazit ceny",
				"formFieldOptional": "volitelné",
				"buttons": {
					"next": "Další",
					"back": "Zpět",
					"continue": "Pokračovat",
					"submit_application": {
						"default": "Pusťte se do toho",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Pusťte se do toho"
					},
					"add_aditional_item": "+ Přidat další položku"
				},
				"unknown_step_title": "Zadejte prosím povinné údaje",
				"selected": "Vybrané",
				"clear_all": "Vymazat vše"
			},
			"errors": {
				"general": "Došlo k chybě. Obraťte se prosím na naši podporu.",
				"salesforce": "Zkuste prosím obnovit stránku. Pokud chyba stále trvá, pošlete prosím ID chyby do nevytíženého kanálu #smooothforce-support a my vám pomůžeme.",
				"managed_kyc": "Zkuste prosím obnovit stránku. Pokud chyba potrvá, obraťte se prosím na naši podporu obchodníka nebo na kontaktní osobu pro prodej.",
				"copy": "Zkopírovat",
				"noTermsAccepted": "Přečtěte si a přijměte prosím všechny naše uvedené smlouvy",
				"termsAlreadyAccepted": "Všechny uvedené smlouvy jste již přijali",
				"mandatoryField": " je povinné"
			},
			"options": {
				"entity_types": {
					"SOLE_TRADER": "Živnostník",
					"PARTNERSHIP": "Partnerská spolupráce",
					"PUBLIC_LISTED_COMPANY": "Veřejně obchodovaná společnost",
					"PRIVATE_COMPANY": "Soukromá firma"
				},
				"organization_entity_types": {
					"C_CORP": "C korporace",
					"S_CORP": "S korporace",
					"PARTNERSHIP": "Partnerská spolupráce",
					"TRUST_ESTATE": "Svěřenský fond/pozůstalost",
					"INDIVIDUAL": "OSVČ",
					"SOLE_PROPRIETORSHIP": "Výhradní vlastník",
					"SOLE_TRADER": "Živnostník",
					"LIMITED_LIABILITY_COMPANY": "Společnost s ručením omezeným",
					"SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": "Jednočlenná společnost s ručením omezeným"
				},
				"goods_categories": {
					"ADULT_SHOES_AND_CLOTHING": "Oblečení a obuv – Obuv a oblečení pro dospělé",
					"AUTOMOTIVE_PARTS_AND_ACCESSORIES": "Výrobky pro automobilový průmysl – Automobilové díly a příslušenství",
					"BAGS_AND_WALLETS": "Šperky a doplňky – Tašky a peněženky",
					"BODY_AND_HAIR_CARE": "Zdraví a krása – Péče o tělo a vlasy",
					"BOOK_AND_MAGAZINES": "Zábava – Knihy a časopisy",
					"CANDY": "Jídlo a pití – Cukrovinky",
					"CAR_ELECTRONICS": "Elektronika – Automobilová elektronika",
					"CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS": "Dětské zboží – Dětské oblečení a výrobky pro péči",
					"CHILDREN_TOYS": "Dětské zboží – Dětské hračky",
					"CLEANING_AND_SANITARY": "Dům a zahrada – Úklidové a hygienické přípravky",
					"COLLECTIBLES": "Volný čas, sport a koníčky – Sběratelství",
					"CONCEPT_STORES_AND_MISCELLANEOUS": "Volný čas, sport a koníčky – Koncepční obchody a různé zboží",
					"COSMETICS": "Zdraví a krása – Kosmetika",
					"COSTUMES_AND_PARTY_SUPPLIES": "Volný čas, sport a koníčky – Kostýmy a párty potřeby",
					"DATING_SERVICES": "Nehmotné produkty – Seznamovací služby",
					"DECORATION_AND_ART": "Dům a zahrada – Dekorace a umění",
					"DIETARY_SUPPLEMENTS": "Zdraví a krása – Doplňky stravy",
					"DIGITAL_SERVICES": "Nehmotné produkty – Digitální služby",
					"DIVERSIFIED_CHILDREN_PRODUCTS": "Dětské produkty – Různorodé dětské produkty",
					"DIVERSIFIED_ELECTRONICS": "Elektronika – Různorodá elektronika",
					"DIVERSIFIED_ENTERTAINMENT": "Zábava – Různorodá zábava",
					"DIVERSIFIED_EROTIC_MATERIAL": "Erotické materiály – Různorodé erotické materiály",
					"DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS": "Zdraví a krása – Různorodé produkty pro zdraví a krásu",
					"DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS": "Dům a zahrada – Různorodé produkty pro dům a zahradu",
					"DIVERSIFIED_JEWELRY_AND_ACCESSORIES": "Šperky a doplňky – Různorodé šperky a doplňky",
					"EDUCATION": "Nehmotné produkty – Vzdělávání",
					"ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES": "Elektronika – Elektronická zařízení a související příslušenství",
					"EROTIC_CLOTHING_AND_ACCESSORIES": "Erotické materiály – Erotické oblečení a doplňky",
					"EVENT_TICKETS": "Nehmotné produkty – Vstupenky na akce",
					"FOOD_AND_BEVERAGE": "Potraviny a nápoje – Potraviny a nápoje",
					"FRAGRANCES": "Zdraví a krása – Vůně",
					"FURNITURE": "Dům a zahrada – Nábytek",
					"GENERAL_SHOES_AND_CLOTHING": "Oblečení a obuv – Obuv a oblečení obecně",
					"HOBBY_ARTICLES": "Volný čas, sport a koníčky – Zboží pro koníčky",
					"HOUSEHOLD_ELECTRONICS": "Elektronika – Domácí elektronika",
					"JEWELRY_AND_WATCHES": "Šperky a doplňky – Šperky a hodinky",
					"KITCHENWARE": "Dům a zahrada – Kuchyňské potřeby",
					"MARKETPLACES": "Nehmotné produkty – Tržnice",
					"MUSIC_AND_MOVIES": "Zábava – Hudba a filmy",
					"MUSICAL_INSTRUMENTS_AND_EQUIPMENT": "Volný čas, sport a koníčky – Hudební nástroje a vybavení",
					"NON_PRESCRIPTION_SUNGLASSES_AND_LENSES": "Šperky a doplňky – Sluneční brýle a čočky bez předpisu",
					"OFFICE_MACHINES_AND_RELATED_ACCESSORIES": "Elektronika – Kancelářské stroje a související příslušenství",
					"OTHER_SERVICES": "Nehmotné produkty – Ostatní služby",
					"PERSONAL_CARE_AND_BODY_IMPROVEMENT": "Zdraví a krása – Osobní péče a vylepšování těla",
					"PET_SUPPLIES": "Dům a zahrada – Potřeby pro domácí mazlíčky",
					"PHARMACEUTICAL_PRODUCTS": "Zdraví a krása – Farmaceutické produkty",
					"PLANTS_AND_FLOWERS": "Dům a zahrada – Rostliny a květiny",
					"PRESCRIPTION_OPTICS": "Zdraví a krása – Optika na předpis",
					"PRINTS_AND_PHOTOS": "Volný čas, sport a koníčky – Tisk a fotografie",
					"SAFETY_PRODUCTS": "Dům a zahrada – Bezpečnostní produkty",
					"SEX_TOYS": "Erotické materiály – Sexuální hračky",
					"SPORTS_GEAR_AND_OUTDOOR": "Volný čas, sport a koníčky – Sportovní a outdoorové vybavení",
					"TOBACCO": "Potraviny a nápoje – Tabák",
					"TOOLS_AND_HOME_IMPROVEMENT": "Dům a zahrada – Nářadí a domácí kutilství",
					"TRAVEL_SERVICES": "Nehmotné produkty – Cestovní služby",
					"UNDERWEAR": "Oblečení a obuv – Spodní prádlo",
					"VIDEO_GAMES_AND_RELATED_ACCESSORIES": "Zábava – Videohry a související příslušenství",
					"WHEELS_AND_TIRES": "Výrobky pro automobilový průmysl – Kola a pneumatiky",
					"WINE_BEER_AND_LIQUOR": "Potraviny a nápoje – Víno, pivo a likéry",
					"YOUTHFUL_SHOES_AND_CLOTHING": "Oblečení a obuv – Obuv a oblečení pro mladé",
					"GAMBLING_BETTING_CASINOS_AND_LOTTERY": "Věkově omezené – Hazardní hry, sázky, kasina a loterie",
					"CHARITIES_AND_NGO": "Nehmotné produkty – Charitativní a nevládní služby",
					"EROTIC_SERVICES": "Erotické materiály – Erotické služby",
					"FINANCIAL_SERVICES_CRYPTO": "Finanční služby – Činnosti související s kryptoměnami",
					"FINANCIAL_SERVICES_MSB": "Finanční služby – Podnikání v oblasti peněžních služebi",
					"FINANCIAL_SERVICES_E_WALLETS": "Finanční služby  E-peněženky",
					"FINANCIAL_SERVICES_TRADING": "Finanční služby – Obchodování",
					"SOCIAL_PLATFORMS_COMMUNITIES": "Nehmotné produkty - Komunity sociálních platforem",
					"TRAVEL_AIR_TRAVEL_AND_CRUISE_OPERATORS": "Cestování – Letecká doprava a provozovatelé výletních plaveb",
					"TRAVEL_BROKER_AND_AGENCIES": "Cestování – zprostředkovatelé a agentury",
					"TRAVEL_GROUND_TRANSPORTATION": "Cestování – pozemní doprava",
					"TRAVEL_ACCOMMODATION_AND_RESORTS": "Cestování – Ubytování a letoviska",
					"EVENT_ORGANIZER": "Událost – Organizátor",
					"EVENT_BROKER_AND_AGENCIES": "Událost – Zprostředkovatelé a agentury"
				},
				"us_states": {
					"AL": "Alabama",
					"AK": "Aljaška",
					"AZ": "Arizona",
					"AR": "Arkansas",
					"CA": "Kalifornie",
					"CO": "Colorado",
					"CT": "Connecticut",
					"DC": "District of Columbia",
					"DE": "Delaware",
					"FL": "Florida",
					"GA": "Georgia",
					"HI": "Havaj",
					"ID": "Idaho",
					"IL": "Illinois",
					"IN": "Indiana",
					"IA": "Iowa",
					"KS": "Kansas",
					"KY": "Kentucky",
					"LA": "Louisiana",
					"ME": "Maine",
					"MD": "Maryland",
					"MA": "Massachusetts",
					"MI": "Michigan",
					"MN": "Minnesota",
					"MS": "Mississippi",
					"MO": "Missouri",
					"MT": "Montana",
					"NE": "Nebraska",
					"NV": "Nevada",
					"NH": "New Hampshire",
					"NJ": "New Jersey",
					"NM": "New Mexico",
					"NY": "New York",
					"NC": "Severní Karolína",
					"ND": "Severní Dakota",
					"OH": "Ohio",
					"OK": "Oklahoma",
					"OR": "Oregon",
					"PA": "Pensylvánie",
					"RI": "Rhode Island",
					"SC": "Jižní Karolína",
					"SD": "Jižní Dakota",
					"TN": "Tennessee",
					"TX": "Texas",
					"UT": "Utah",
					"VT": "Vermont",
					"VA": "Virginia",
					"WA": "Washington",
					"WV": "Západní Virginia",
					"WI": "Wisconsin",
					"WY": "Wyoming"
				},
				"stakeholder": {
					"types": {
						"PERSON": "Osoba",
						"COMPANY": "Společnost"
					},
					"roles": {
						"OWNER": "Majitel",
						"ULTIMATE_BENEFICIAL_OWNER": "Konečný skutečný vlastník",
						"CONTROL_OVER_MANAGEMENT": "Kontrola nad řízením",
						"APPLICANT": "Osoba s podpisovými právy",
						"SOLE_TRADER": "Živnostník",
						"PARTNER": "Partner"
					}
				},
				"payment_intervals": {
					"DAILY": "Denně",
					"WEEKLY": "Týdně"
				},
				"business_concepts": {
					"TRADITIONAL_SALE_OF_GOODS": {
						"label": "Tradiční prodej zboží",
						"description": "Obchodník prodává výrobky nebo služby tradičním způsobem: zboží se považuje za plně spotřebované při prvním dodání a obvykle neexistuje delší doba mezi objednávkou a dodáním."
					},
					"VOUCHER": {
						"label": "Poukaz",
						"description": "Více než 10 % prodejů tvoří poukazy a/nebo dárkové karty."
					},
					"MEMBERSHIP": {
						"label": "Členství",
						"description": "Více než 10 % prodejů sestává z členství"
					},
					"SUBSCRIPTION": {
						"label": "Předplatné",
						"description": "Více než 10 % prodejů sestává z předplatných"
					},
					"PHARMACIES": {
						"label": "Lékárny",
						"description": "Obchodník prodává léky na předpis nebo bez předpisu"
					},
					"US_PHARMACIES": {
						"label": "Lékárny v USA",
						"description": "Obchodník prodává léky na předpis nebo bez předpisu v USA"
					},
					"MEDICAL_SERVICES": {
						"label": "Zdravotnické služby",
						"description": "Obchodník prodává lékařské služby, jako je testování, vyšetření, ošetřovatelská péče."
					},
					"MARKETPLACES": {
						"label": "Trhy",
						"description": "Obchodník má vztah s dílčím obchodníkem"
					},
					"FIREARM_DEALERS": {
						"label": "Prodejci střelných zbraní",
						"description": "Obchodník prodává zbraně, střelivo vyžadující licenci"
					},
					"AUCTIONS": {
						"label": "Aukce",
						"description": "Obchodník je aukční síň"
					},
					"ALCOHOL": {
						"label": "Alkohol",
						"description": "Obchodník prodává alkohol"
					},
					"TOBACCO": {
						"label": "Tabák",
						"description": "Obchodník prodává tabákové výrobky včetně nebo bez nikotinu nebo obchodník prodává elektronické cigarety."
					},
					"HEMP_CBD_THC": {
						"label": "Konopí, CBD nebo THC",
						"description": "Obchodník prodává produkty obsahující konopí, CBD nebo THC"
					},
					"DONATIONS_CHARITY": {
						"label": "Dary a charita",
						"description": "Obchodník je příspěvková nebo charitativní organizace, která uplatňuje vyplacení po vypořádání"
					},
					"TRAVEL": {
						"label": "Cestování",
						"description": "Více než 10 % prodejů tvoří cestování"
					},
					"EVENTS": {
						"label": "Události",
						"description": "Více než 10 % prodejů tvoří události"
					},
					"COURSES": {
						"label": "Kurzy",
						"description": "Více než 10 % prodejů tvoří kurzy"
					},
					"EDUCATIONAL_COURSES": {
						"label": "Vzdělávací kurzy",
						"description": "Obchodník prodává vzdělávací kurzy trvající určitou dobu."
					},
					"FOOD_DELIVERY": {
						"label": "Rozvoz potravin",
						"description": "Obchodník poskytuje službu rozvozu jídel."
					},
					"CUSTOMISED_PRE_ORDER_FURNITURE": {
						"label": "Předobjednávka na míru/nábytek",
						"description": "Obchodník prodává výrobky na objednávku, například nábytek."
					},
					"DIGITAL_CONTENT": {
						"label": "Digitální obsah",
						"description": "Obchodník prodává digitální obsah, například elektronické knihy a online hry."
					},
					"GAMING_INDUSTRY": {
						"label": "Herní průmysl (hazardní hry, sázky, kasina, loterie)",
						"description": "Obchodník poskytuje služby související s herním průmyslem, jako jsou hazardní hry, sázky, kasina a loterie."
					}
				}
			},
			"pages": {
				"select_products_page": {
					"page_header": {
						"primary_title": "Dobrý den {firstName},",
						"primary_title_without_name": "Zdravíme tě,",
						"sub_title": "Více Klarny je více Klarny, řekl Shakespeare.",
						"sub_title_no_products": "Začněte své zkušenosti se společností Klarna výběrem produktu níže",
						"sub_title_kp_products": "Zvolte jiný produkt Klarna",
						"sub_title_ongoing_product": "Pokračujte v nastavování {productName}"
					},
					"sidebar_left": {
						"products": {
							"title": "Platební produkty",
							"text_blocks": [
								{
									"text": "Přidejte řešení k nastavení"
								}
							]
						}
					},
					"buttons": {
						"start": "Spustit",
						"continue": "Pokračovat",
						"view_summary": "Zobrazit souhrn",
						"add_another_product": "Přidat jiný produkt"
					},
					"goodie_bags": {
						"playground": {
							"title": "Playground",
							"text": "Přepněte do prostředí Playground a prozkoumejte a vygenerujte přihlašovací údaje do testovacího rozhraní API, abyste mohli otestovat svou platformu.",
							"link": "Playground"
						},
						"marketing_assets": {
							"title": "Marketingová aktiva",
							"text": "Používání Klarny znamená smoooth plavbu pro vaše zákazníky. Využijte naše marketingová aktiva, abyste je nadchli.",
							"link": "Získat aktiva"
						},
						"your_application": {
							"title": "Vaše žádost",
							"text": "Kliknutím sem dokončíte nastavení nebo si zobrazíte podrobnosti o žádosti včetně smluvních podmínek.",
							"link": "Otevřeno"
						},
						"invite_more_users": {
							"title": "Pozvat více uživatelů",
							"text": "Pozvěte své spolupracovníky na portál obchodníka a budete jim moci nastavit vlastní oprávnění!",
							"link": "Pozvat uživatele"
						}
					},
					"footer": {
						"title": "Vždy součást Klarny",
						"list": {
							"merchant_portal": {
								"title": "Portál obchodníka",
								"text_blocks": [
									{
										"text": "Spravujte vše s Klarnou s plným přístupem do backendu."
									}
								]
							},
							"global_products": {
								"title": "Globální produkty, místní tváře",
								"text_blocks": [
									{
										"text": "Všechny naše produkty jsou sestaveny tak, aby splňovaly místní požadavky a legislativu."
									}
								]
							},
							"local_support": {
								"title": "Místní podpora pro vás a vaše zákazníky",
								"text_blocks": [
									{
										"text": "Máme tisíce lidí připravených pomoci vašim zákazníkům, když potřebují lidský přístup."
									}
								]
							},
							"marketing_tool": {
								"title": "Klarna jako marketingový nástroj",
								"text_blocks": [
									{
										"text": "Poskytneme vám přístup k materiálům společnosti Klarna, které můžete použít ve svých marketingových iniciativách."
									}
								]
							},
							"single_integration": {
								"title": "Jednotná integrace, automatické aktualizace",
								"text_blocks": [
									{
										"text": "Jedna integrace, žádné aktualizace. Nikdy."
									},
									{
										"text": "Stačí jenom integrace v Klarně. Je vždy aktualizovaná – a vy nemusíte hnout prstem."
									}
								]
							},
							"no_risk": {
								"title": "Žádné riziko pro vás ani vaše zákazníky",
								"text_blocks": [
									{
										"text": "Vaše výplaty jsou vždy zaručeny a na vaše zákazníky se vztahuje ochrana kupujících Klarna."
									}
								]
							}
						}
					}
				},
				"credentials_page": {
					"sidebar_left": {
						"connection_key": {
							"title": "Přihlašovací údaje Klarna API",
							"text_blocks": [
								{
									"text": "Přihlašovací údaje Klarna API propojí náš produkt s vaším obchodem a vy můžete začít prodávat."
								}
							]
						},
						"toc_key": {
							"title": "Smluvní podmínky",
							"text_blocks": [
								{
									"text": "Musíte aktualizovat smluvní podmínky elektronického obchodu"
								}
							]
						},
						"connect_to_your_platform": {
							"title": "Pokyny k integraci",
							"text_blocks": [
								{
									"text": ""
								}
							]
						}
					},
					"main": {
						"how_to_use": {
							"title": "Jak používat Přihlašovací údaje Klarna API",
							"ordered_list": {
								"one": "Vygenerujte a stáhněte si své přihlašovací údaje",
								"two": "Vložte přihlašovací údaje (uživatelské jméno a heslo Klarna API) do své platformy, jak je vysvětleno v pokynech k integraci níže."
							}
						},
						"number_of_live_keys_in_total": {
							"title": "Celkem 5 přihlašovacích údajů Klarna API",
							"text": "Můžete si vygenerovat až pět přihlašovacích údajů Klarna API. První z nich získáte zde a ostatní vytvoříte v Nastavení.",
							"button": "Generovat přihlašovací údaje Klarna API"
						},
						"how_to_update_toc": {
							"title": "Jak aktualizovat smluvní podmínky",
							"ordered_list": {
								"one": "Navštívit odkaz",
								"two": "Přečtěte si pokyny a zkopírujte text",
								"three": "Zahrňte ho do smluvních podmínek svého internetového obchodu"
							}
						},
						"update_toc_link": {
							"title": "",
							"text": "Nezapomeňte prosím aktualizovat text s produkty, ke kterým jste se přihlásili.",
							"linkText": "Přejít na aktualizované smluvní podmínky >"
						},
						"buttons": {
							"back": "Zpět"
						}
					}
				},
				"whats_next_page": {
					"communication": {
						"TRANSACTIONS_REVIEW_AUTOMATED": "Vaše žádost se právě přezkoumává...",
						"TRANSACTION_DETAILS_STARTED": "Vaši žádost právě prověřuje náš tým. Ozveme se vám co nejdříve.",
						"TRANSACTIONS_REVIEW_MANUAL": "Vaši žádost právě prověřuje náš tým. Ozveme se vám co nejdříve.",
						"TRANSACTIONS_ENABLED": "Gratulujeme. Jste připravení prodávat s Klarnou.",
						"PAYOUTS_REVIEW_AUTOMATED": "Vaši žádost o výplatu prověřujeme...",
						"PAYOUTS_REVIEW_MANUAL": "Vaši žádost o výplatu prověřuje náš tým. Ozveme se vám co nejdříve.",
						"PAYOUTS_REVIEW_AWAITING_FIRST_TRANSACTION": "Čekáme na váš první prodej s Klarnou…",
						"TRANSACTIONS_DISABLED": "Váš účet je zablokován, dokud nedokončíte krok povolení výplat.",
						"SUSPENDED": "Váš účet je pozastaven.",
						"notice": "V současné době máme delší než průměrnou čekací dobu na posouzení vaší žádosti. Nemějte obavy, vaše žádost se nyní posuzuje a my vás budeme kontaktovat s dalšími informacemi o dalším postupu. Vážíme si vaší trpělivosti a děkujeme za pochopení."
					},
					"statuses": {
						"pending": "Čekající",
						"done": "Hotovo"
					},
					"in_review": {
						"title": "Kontrolujeme vaši žádost.",
						"subtitle": "V současné době provádíme závěrečnou kontrolu vaší žádosti v Klarně, abychom se ujistili, že vše ve smlouvě vypadá správně. Jedná se o ruční proces, takže doba vyřízení se může lišit, ale vyřídíme ji co nejrychleji.",
						"content": {
							"title": "Pro zajištění, že kontrola proběhne co nejrychleji, se ujistěte, že jsou na vašem webu viditelné následující údaje:",
							"list": {
								"default": {
									"item_1": "Registrovaný název společnosti",
									"item_2": "Registrované číslo společnosti",
									"item_3": "Registrovaná adresa společnosti",
									"item_4": "Zásady vracení zboží nejméně 14 dnů",
									"item_5": "E-mail nebo číslo zákaznického servisu"
								},
								"US": {
									"item_1": "Registrovaný název společnosti",
									"item_2": "Zásady vracení zboží",
									"irem_3": "E-mail nebo číslo zákaznického servisu"
								},
								"AU": {
									"item_1": "ABN (číslo společnosti) nebo registrované obchodní jméno.",
									"item_3": "Registrovaná adresa společnosti",
									"item_4": "Zásady vracení zboží nejméně 14 dnů",
									"item_5": "E-mail nebo číslo zákaznického servisu"
								}
							}
						},
						"footer": "Po dokončení kontroly nebo v případě, že od vás budeme potřebovat další informace, vám zašleme e-mail."
					},
					"suspended": {
						"title": "Bohužel…",
						"subtitle": "Po přezkoumání údajů o vaší smlouvě jsme museli vaši žádost zamítnout. Důvodů, proč vaše žádost nebyla schválena, může být několik. Níže jsou uvedeny některé z nejčastějších celkových faktorů:",
						"content": {
							"title": "",
							"list": {
								"item_1": "Váš obchod nesplňuje etické zásady společnosti Klarna.",
								"item_2": "Uvedená kontaktní osoba je nedostupná.",
								"item_3": "Jiné technické nebo administrativní faktory."
							}
						},
						"footer": "Děkujeme za váš zájem o Klarnu. Pokud máte jakékoli dotazy nebo se chcete v budoucnu zaregistrovat v jiném obchodě, kontaktujte nás."
					},
					"disabled": {
						"title": "Vaše žádost byla zablokována.",
						"subtitle": "Váš účet byl automaticky zablokován, protože v něm chybí zákonem požadované informace.",
						"content": {
							"title": "To se většinou stává, když vás společnost Klarna požádala o poskytnutí určitých informací a vy jste neodpověděli do stanoveného data."
						},
						"footer": "Pokud se domníváte, že se jedná o chybu, nebo chcete informace odeslat znovu, obraťte se na podporu obchodníka pomocí kontaktních údajů v zápatí této stránky."
					},
					"ready_to_connect": {
						"title": "Připojte svůj obchod",
						"subtitle": "Vaše smlouva je dokončena a vy nyní můžete integrovat Klarnu do svého obchodu. Integraci dokončíte podle následujících kroků.",
						"status_messsage": {
							"title": "Integrace dosud nebyla dokončena",
							"subtitle": "Podle pokynů k integraci připojte svůj obchod. Barva stavu se změní na zelenou, jakmile bude transakce provedena pomocí Klarny."
						},
						"content": {
							"title": "Pokyny",
							"options": {
								"label_1": "Vygenerujte a uložte přihlašovací údaje Klarna API",
								"description_1": "Vygenerujte nové přihlašovací údaje API a stáhněte je do počítače. Tyto přihlašovací údaje API budete potřebovat v následující části.",
								"label_2": "Instalace Klarny do obchodu Shopify"
							}
						}
					},
					"ready_to_connect_new_ig": {
						"title": "Téměř hotovo",
						"subtitle": "Jste o krok blíže k tomu, abyste svým zákazníkům nabídli hladký nákupní zážitek! Vaše smlouva je uzavřena a váš obchod je připraven k integraci.",
						"buttons": {
							"connect": "Připojte svůj obchod"
						},
						"additional_info": "Upozorňujeme, že integrace bude označena jako plně dokončená až po obdržení prvního nákupu, což může v závislosti na vaší platformě chvíli trvat."
					},
					"store_connected": {
						"title": "Váš obchod je připojen.",
						"subtitle": "Integrace vašeho obchodu s Klarnou je dokončena a vaši zákazníci mohou platit pomocí Klarny.",
						"status_messsage": {
							"title": "Úspěšná integrace",
							"subtitle": "Ve vašem obchodě byla úspěšně zpracována transakce Klarna.",
							"button_text": {
								"shown": "Zobrazit pokyny k integraci",
								"hidden": "Skrýt pokyny k integraci"
							}
						}
					},
					"actions": {
						"view_summary": {
							"title": "Vaše žádost",
							"subtitle": "Zkontrolujte si informace o své žádosti.",
							"button_text": "Zobrazit souhrn"
						},
						"connect_store": {
							"title": "Přihlašovací údaje Klarna API",
							"subtitle": "Vygenerujte si pověření Klarna API pro integraci svého obchodu.",
							"button_text": "Generovat přihlašovací údaje Klarna API"
						},
						"add_product": {
							"title": "Produkty",
							"subtitle": "Pokud chcete přidat produkt pro toto nastavení, klikněte sem.",
							"button_text": "Přidat produkty"
						}
					},
					"timeline": {
						"application": {
							"title": "Vaše žádost",
							"alert": {
								"view_summary": "Zobrazit souhrn",
								"rejected": "Vaši žádost jsme museli zamítnout.",
								"review": "Kliknutím na níže uvedený odkaz si prohlédněte informace o své žádosti."
							}
						},
						"payouts": {
							"title": "Výplaty povoleny"
						},
						"integration": {
							"title": "Integrace dosud nebyla dokončena",
							"alert": "Podle pokynů k integraci připojte svůj obchod."
						},
						"integration_complete": {
							"title": "Integrace dokončena"
						}
					}
				},
				"summary_page": {
					"header": {
						"title": "Gratulujeme, vaše nastavení je dokončeno!",
						"rejection": "Je nám líto, ale nepodařilo se nám dokončit vaše nastavení."
					},
					"header_new": {
						"title": "Vítejte, obchodníku Klarna",
						"subtitle": "Shrnutí",
						"rejection": "Žádost zamítnuta"
					},
					"joy_section": {
						"approved": {
							"title": "Schváleno!",
							"content": "Vaše žádost byla zkontrolována a schválena. Plný přístup ke službám společnosti Klarna máte nyní na dosah ruky. Jsme nadšení, že s vámi můžeme pracovat!",
							"button_title": "Zkontrolujte své objednávky",
							"link": "nebo naše marketingová aktiva"
						},
						"rejected": {
							"title": "Bohužel…",
							"content_1": "Po přezkoumání vaší žádosti nemůžeme vaši smlouvu s obchodníkem schválit.",
							"content_2": "V případě dotazů se můžete obrátit na náš tým podpory."
						}
					},
					"sidebar_left": {
						"application_details": "Podrobnosti o vaší žádosti",
						"store_details": {
							"title": "Podrobnosti o obchodě",
							"text_blocks": [
								{
									"text": "Shrnutí vašich podrobností"
								}
							]
						},
						"credentials": {
							"title": "Přihlašovací údaje Klarna API",
							"text_blocks": [
								{
									"text": "Vaše přihlašovací údaje Klarna API"
								}
							]
						},
						"payouts": {
							"title": "Vyplacené částky",
							"text_blocks": [
								{
									"text": "Vaše odeslané bankovní údaje"
								}
							]
						},
						"additional_bank_accounts": {
							"title": "Další bankovní účty",
							"text_block": null
						},
						"business_owners": {
							"title": "Majitelé firmy",
							"text_blocks": null
						},
						"material_influencers": {
							"title": "Významné vlivné osoby",
							"text_blocks": null
						},
						"stakeholders": {
							"title": "Zainteresované strany",
							"text_blocks": [
								{
									"text": "Vaše odeslané informace"
								}
							]
						}
					},
					"main": {
						"store_details": {
							"business_owners": {
								"title": "Majitelé firmy",
								"no_elements": "Neuvedli jste žádné majitele firmy"
							}
						},
						"payouts": {
							"default_bank_accounts": {
								"title": "Výchozí bankovní účet",
								"no_elements": "Není k dispozici žádný výchozí bankovní účet"
							},
							"additional_bank_accounts": {
								"title": "Další bankovní účty",
								"no_elements": "Neuvedli jste žádné další bankovní účty"
							}
						},
						"stakeholders": {
							"owners": {
								"title": "Majitelé",
								"no_elements": "Neuvedli jste žádné majitele"
							},
							"ultimate_beneficial_owner": {
								"title": "Skuteční vlastníci",
								"no_elements": "Neuvedli jste žádné skutečné vlastníky"
							},
							"applicant": {
								"title": "Žadatelé",
								"no_elements": "Neuvedli jste žádné žadatele"
							},
							"control_over_management": {
								"title": "Osoby s kontrolou nad řízením",
								"no_elements": "Neuvedli jste žádné zúčastněné strany s kontrolou nad řízením"
							}
						},
						"buttons": {
							"back": "Zpět",
							"next_step": "Další"
						}
					}
				},
				"additional_products_page": {
					"sidebar_left": {
						"we_have_your_data": {
							"title": "Již vaše údaje máme",
							"text_blocks": [
								{
									"text": "Toto jsou informace, které jste nám již dříve poskytli."
								}
							]
						}
					},
					"main": {
						"business_ownership": {
							"no_elements": "Neuvedli jste žádné majitele firmy"
						},
						"buttons": {
							"submit": "Odeslat",
							"back": "Zpět"
						}
					}
				},
				"checking_page": {
					"title": "Běžný",
					"subtitle": "Děkujeme za zaslání žádosti. Počkejte prosím, než to zkontrolujeme..."
				},
				"success_page": {
					"title": "Nyní můžete připojit svůj obchod",
					"subtitle": "Děkujeme vám za zaslání žádosti.",
					"buttons": {
						"next": "Další"
					}
				}
			},
			"components": {
				"split_image_container": {
					"timeline": {
						"basics": "Základy",
						"business": "Obchod",
						"stakeholders": "Zainteresované strany",
						"bank_accounts": "Bankovní účty"
					}
				},
				"app_error": {
					"title": "Aplikace Produkty není v současné době dostupná",
					"message": "Máme s aplikací problémy a již se jimi zabýváme. Problémy se snažíme řešit co nejdříve. Zkuste to znovu později."
				},
				"temporarily_down": {
					"title": "Máme technické potíže.",
					"message": "Omlouváme se za nepříjemnosti a ujišťujeme vás, že se snažíme problém vyřešit. Podívejte se sem prosím brzy znovu."
				},
				"maintenance_mode": {
					"title": {
						"products_app": "Naše aplikace Produkty je momentálně mimo provoz z důvodu údržby.",
						"signup_app": "Naše aplikace pro přihlášení je momentálně mimo provoz z důvodu údržby."
					},
					"message": "Pracujeme na zlepšení vašich zkušeností a doufáme, že se nám to podaří co nejdříve. Podívejte se sem prosím brzy znovu."
				},
				"unknown_merchant": {
					"before_link": "Pokud s námi již máte uzavřenou smlouvu, navštivte prosím",
					"link_text": "tuto stránku",
					"after_link": "abyste se o našich produktech dozvěděli více!"
				},
				"pre_assessment_error": {
					"title": {
						"invalid_flow_type": "Došlo k chybě.",
						"invalid_token": "Platnost tohoto odkazu vypršela."
					},
					"message": {
						"invalid_token_risk": " Kontaktujte prosím nevytížený kanál #smooothforce-support a my vám pomůžeme.",
						"invalid_token": "Obraťte se prosím na kontaktní osobu pro prodej.",
						"invalid_flow_type": "Typ a stav onboardingu tohoto obchodníka jsou nekompatibilní. Pokud se domníváte, že se jedná o chybu, obraťte se na Podporu obchodníka."
					}
				},
				"topbar": {
					"title": "Nastavení",
					"widget_type": {
						"MANAGED_KYC": "Kolekce KYC",
						"MANAGED_RISK": "Kolekce před hodnocením",
						"MANAGED_SME_RISK": "Kolekce SME před hodnocením"
					}
				},
				"product_card": {
					"incompatible_description": "Není k dispozici pro vaši zemi/platformu",
					"kco_footer_text": "Způsoby platby dostupné v Pokladně Klarna závisí na zemi vaší registrace a na zemi, do které prodáváte.",
					"products_link_text": "Více"
				},
				"product_prices_card": {
					"title": "Produkty",
					"subtitle": "{country}",
					"pricing": "Cena za {country}",
					"monthly_fee": "Měsíční poplatek",
					"transaction_fee": "Poplatek za transakci",
					"before_link": "Souhlasím se smluvními",
					"link_text": "Smluvní podmínky",
					"after_link_one_product": "pro tento produkt",
					"after_link_more_than_one_product": "pro tyto produkty",
					"product_not_available_in_your_country": "* Tento produkt není dostupný pro váš domácí trh, ale bude fungovat v jiných zemích.",
					"edit_link": "Upravit",
					"merchant_agreement": {
						"before_link": "Souhlasím se",
						"link_text": "smlouvou s obchodníkem",
						"after_link_one_product": "pro tento produkt",
						"after_link_more_than_one_product": "pro tyto produkty"
					},
					"pricing_annex": {
						"before_link": "Souhlasím s",
						"link_text": "cenovými podmínkami",
						"after_link_one_product": "pro tento produkt"
					}
				},
				"support_footer": {
					"text": "Podpora v angličtině",
					"copyright": {
						"eu": "Copyright © 2005–{currentYear} Klarna Bank AB (publ). Všechna práva vyhrazena.",
						"ap": "Copyright © 2005-{currentYear} Klarna Australia Pty Ltd, ABN # 82 635 912 579.",
						"us": "Copyright © 2005–{currentYear} Klarna Inc. NMLS #1353190, 629 N. High Street, Third Floor, Columbus, OH 43215."
					},
					"terms_and_conditions": "Smluvní podmínky",
					"privacy_policy": "Zásady ochrany osobních údajů",
					"merchant_id": "ID obchodníka {merchantId}",
					"email": "moa.support@klarna.com",
					"contact_number": "+46 (8) 123 45 67",
					"support_link": "Podpora obchodníka",
					"recaptcha": {
						"1_main_text": "Tento web je chráněn pomocí reCAPTCHA a platí",
						"2_privacy_policy": "Zásady ochrany osobních údajů",
						"3_and": "a",
						"4_terms_of_service": "Podmínky poskytování služby",
						"5_apply": "společnosti Google."
					}
				},
				"global_prices_dialog": {
					"title_eu": "Ceny pro všechny naše trhy",
					"title_us": "Ceny",
					"subtitle": "Je vám účtován poplatek jenom za transakci, to je smoooth!",
					"table": {
						"country": "Země",
						"price_column_heading": "Poplatek za transakci",
						"global": "Globální",
						"title": {
							"kp": "Způsoby platby",
							"kco": "Pokladna Klarna",
							"kco_one": "Pokladna Klarna",
							"kp_one": "Způsoby platby Klarna"
						},
						"headers": {
							"kp_one": "Poplatek za službu"
						}
					},
					"buttons": {
						"back": "Zpět"
					},
					"foot_notes": {
						"global_price": "* Jinak místní měna obchodníka "
					}
				},
				"fake_approval": {
					"first_transaction": {
						"title": "První transakce",
						"content": "Než budeme moci zkontrolovat vaše výplatní údaje, potřebujeme první objednávku. Nechcete plýtvat vlastními penězi? Žádný problém.",
						"button": "Předstírejte!"
					},
					"transactions": {
						"title": "Schválit transakce",
						"content": "Schválení transakce v systému Salesforce můžete jen předstírat.",
						"button": "Schválit"
					},
					"payouts": {
						"title": "Schválit výplaty",
						"content": "Schválení výplat zaměstnancům můžete jen předstírat",
						"button": "Schválit"
					}
				},
				"bank_account_summary": {
					"subtitle": {
						"default": "Výchozí bankovní účet",
						"additional": "Další bankovní účet {index}",
						"normal": "Bankovní účet {index}"
					},
					"currency_code": {
						"label": "Měna"
					},
					"country_of_bank_account": {
						"label": "Země"
					},
					"account_number": {
						"label": {
							"default": "Číslo účtu",
							"MX_LOCAL": "Číslo CLABE"
						}
					},
					"account_holder": {
						"label": "Jméno vlastníka účtu"
					},
					"routing_number": {
						"label": "Směrovací číslo"
					},
					"transit_number": {
						"label": "Tranzitní číslo"
					},
					"institution_number": {
						"label": "Číslo instituce"
					},
					"bic": {
						"label": {
							"default": "BIC",
							"AU": "BSB"
						}
					},
					"no_edit_button": "Informace o bankovním účtu můžete upravit po dokončení onboardingu."
				},
				"store_details_summary": {
					"legal_company_name": {
						"label": "Právní název společnosti"
					},
					"country": {
						"label": "Země"
					},
					"registrationId": {
						"label": {
							"default": "Evidenční číslo",
							"AT": "Evidenční číslo",
							"AU": "ACN",
							"CA": "Číslo firmy",
							"ES": "NIF/NIE/DNI společnosti",
							"GB": "Číslo organizace",
							"GR": "Číslo G.E.MI. (Γ.Ε.ΜΗ.)",
							"US": "Identifikační číslo zaměstnance"
						}
					},
					"organizationRegistrationAuthority": {
						"label": "Soud registrace"
					},
					"goodsCategory": {
						"label": "Kategorie zboží"
					},
					"registered": {
						"label": {
							"default": "Registrovaná společnost",
							"AU": "Společnost má ACN"
						}
					},
					"subjectToVat": {
						"label": {
							"default": "Společnost je plátcem DPH",
							"AU": "Společnost podléhá ABN",
							"ES": "Společnost má NIF/NIE/DNI"
						}
					},
					"vatId": {
						"label": {
							"default": "Daňové identifikační číslo",
							"AU": "ABN",
							"ES": "NIF/NIE/DNI společnosti"
						}
					},
					"storeName": {
						"label": "Název obchodu"
					},
					"website": {
						"label": "Webová stránka"
					},
					"email": {
						"label": "E-mail na zákaznickou podporu"
					},
					"entityType": {
						"label": "Typ entity"
					},
					"toc_data": {
						"label": "Smluvní podmínky",
						"toc_approval_text": {
							"before_link": "Vaše",
							"link_text": "podmínkami Klarna",
							"after_link": "přijaty dne {date}",
							"merchant_agreement": {
								"before_link": "Vaše",
								"link_text": "smlouvou s obchodníkem",
								"after_link": "přijatá dne {date}"
							},
							"pricing_annex": {
								"before_link": "Vaše",
								"link_text": "příloha ke stanovení ceny",
								"after_link": "přijatá dne {date}"
							}
						}
					},
					"companyName": {
						"label": "Název partnerství"
					},
					"registeredCompanyName": {
						"label": "Název společnosti"
					},
					"address": {
						"label": "Adresa"
					},
					"operatingAddress": {
						"label": "Provozní adresa"
					},
					"organizationEntityType": {
						"label": "Klasifikace daně"
					}
				},
				"api_key_dialog": {
					"title": "Přihlašovací údaje Klarna API byly vygenerovány",
					"subtitle": "Přihlašovací údaje se zobrazí jen jednou. Klikněte na tlačítko níže a stáhněte si přihlašovací údaje ještě před zavřením tohoto okna.",
					"key_box": {
						"username": {
							"label": "Uživatelské jméno Klarna API"
						},
						"password": {
							"label": "Heslo Klarna API"
						},
						"file_name": "Přihlašovací_údaje_Klarna"
					},
					"buttons": {
						"download": "Stáhnout jako .txt"
					}
				},
				"platform_instructions": {
					"step": "Krok {current}/{max}",
					"next": "Další",
					"back": "Zpět",
					"shopify": [
						{
							"title": "Vygenerujte a uložte přihlašovací údaje Klarna API",
							"step_instructions": [
								[
									{
										"text": "Vygenerujte nové přihlašovací údaje API a stáhněte si soubor do počítače. Soubor otevřete a nechte jej otevřený, protože v následující části budete potřebovat tyto přihlašovací údaje API."
									}
								]
							],
							"alternate": [
								{
									"text": "Podrobnější informace o integraci se službou Shopify najdete"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "v rozšířeném průvodci integrací."
								}
							]
						},
						{
							"title": "Instalace Klarny do obchodu Shopify",
							"step_instructions": [
								[
									{
										"text": "Přejděte do"
									},
									{
										"link": "https://www.klarnapayments.com/merchant_admin/guide/install_app/slice_it_pay_over_time_with_klarna/enter-your-shopify-store-name-here",
										"text": "Průvodce nastavením způsobů platby Klarna Shopify."
									}
								],
								[
									{
										"text": "Podle pokynů proveďte integraci."
									}
								]
							],
							"alternate": [
								{
									"text": "Podrobnější informace o integraci se službou Shopify najdete"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "v rozšířeném průvodci integrací."
								}
							]
						},
						{
							"title": "Provedení zkušebního nákupu",
							"step_instructions": [
								[
									{
										"text": "Chcete-li ověřit, zda je integrace správně nastavena, proveďte ve svém obchodě zkušební nákup."
									}
								],
								[
									{
										"text": "Po zadání objednávky přejděte na"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Objednávky na portálu obchodníka,"
									},
									{
										"text": "vyhledejte objednávku a zrušte ji, abyste za ni nemuseli sami platit."
									}
								],
								[
									{
										"text": "Jakmile bude integrace úspěšná, banner v horní části této stránky zezelená a zobrazí se „Integrace dokončena“."
									}
								]
							],
							"alternate": [
								{
									"text": "Podrobnější informace o integraci se službou Shopify najdete"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "v rozšířeném průvodci integrací."
								}
							]
						}
					],
					"plentymarkets": [
						{
							"title": "Povolení pluginu Způsoby platby Klarna pro Plentymarkets",
							"step_instructions": [
								[
									{
										"text": "Abyste mohli nainstalovat plugin Klarna, potřebujete mít spuštěný systém Plentymarkets CERES. Plugin"
									},
									{
										"link": "https://marketplace.plentymarkets.com/en/plugins/sales/online-shops/ceres_4697",
										"text": "Ceres"
									},
									{
										"text": "je k dispozici ke stažení na plentyMarketplace. Odtud také budete přesměrováni na"
									},
									{
										"link": "https://knowledge.plentymarkets.com/en/online-store/setting-up-ceres",
										"text": "pokyny k instalaci."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobné informace o integraci systému Klarna se systémem Plentymarkets Ceres naleznete"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "pod tímto odkazem."
									}
								]
							]
						},
						{
							"title": "Instalace a nastavení",
							"step_instructions": [
								[
									{
										"text": "Instalace pluginu Klarna se provádí prostřednictvím"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "plentyMarketplace."
									},
									{
										"text": "Na plentyMarketplace také budete přesměrováni z backendu systému plentymarkets. Postup"
									},
									{
										"link": "https://knowledge.plentymarkets.com/en/slp/plugins/plugins-system-hinzufuegen",
										"text": "instalace pluginů v plentymarkets"
									},
									{
										"text": "najdete na plentyKnowledge."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobné informace o integraci systému Klarna se systémem Plentymarkets Ceres naleznete"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "pod tímto odkazem."
									}
								]
							]
						},
						{
							"title": "Konfigurace pluginu",
							"step_instructions": [
								[
									{
										"text": "Plugin se konfiguruje přímo v příslušné sadě. Kliknutím na řádek"
									},
									{
										"bold": "pluginu Klarna"
									},
									{
										"text": "otevřete stránku konfigurace."
									}
								],
								[
									{
										"text": "Konfigurace se dělí do dvou oblastí:"
									},
									{
										"list": [
											[
												{
													"bold": "Ověření:"
												},
												{
													"text": "Tento režim slouží k určení, zda se jedná o testování nebo produktivní práci. V závislosti na režimu musí být uloženo uživatelské jméno a heslo."
												}
											],
											[
												{
													"bold": "Obecná nastavení:"
												},
												{
													"text": "Zde vyberete produkt, který chcete použít. Buď jednotlivé způsoby platby Klarna (platba Klarna), nebo celá pokladna Klarna (Pokladna Klarna). Při výběru pokladny bude pokladna v obchodě automaticky přepsána Pokladnou Klarna."
												}
											]
										]
									},
									{
										"text": "Nejsou potřeba žádná další nastavení a po deaktivaci pluginu se tato nastavení zruší."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobné informace o integraci systému Klarna se systémem Plentymarkets Ceres naleznete"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "pod tímto odkazem."
									}
								]
							]
						},
						{
							"title": "Závěrečné informace",
							"step_instructions": [
								[
									{
										"text": "Platí následující systémové požadavky:"
									},
									{
										"list": [
											{
												"text": "Plentymarkets verze 7"
											},
											{
												"text": "Nainstalované pluginy Ceres a IO"
											}
										]
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobné informace o integraci systému Klarna se systémem Plentymarkets Ceres naleznete"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "pod tímto odkazem."
									}
								]
							]
						}
					],
					"woocommerce_kco": [
						{
							"title": "Povolení pluginu Pokladna Klarna pro WooCommerce",
							"step_instructions": [
								[
									{
										"text": "Nejprve se ujistěte, že máte nainstalovaný plugin Pokladna Klarna pro WooCommerce. Pokud ho ještě nemáte, přejděte na"
									},
									{
										"link": "https://woocommerce.com/products/klarna-checkout/#",
										"text": "tuto stránku"
									},
									{
										"text": "a stáhněte si ho."
									}
								],
								[
									{
										"text": "Jakmile získáte přihlašovací údaje Klarna API, přejděte v panelu WooCommerce do části „Nastavení“ a poté do části „Pokladna“. Vyberte Pokladna Klarna."
									}
								],
								[
									{
										"text": "Povolte pokladnu Klarna zaškrtnutím políčka Povolit pokladnu Klarna."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci WooCommerce najdete v"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "rozšířeném průvodci."
									}
								]
							]
						},
						{
							"title": "Konfigurace nastavení",
							"step_instructions": [
								[
									{
										"text": "Konfigurujte nastavení pro Pokladnu Klarna. Všimněte si, že pole „Název“ slouží k nastavení názvu způsobu platby, který se zobrazuje v e-mailech při placení a potvrzení objednávky (např. Pokladna Klarna)."
									}
								],
								[
									{
										"text": "Pokud chcete vytvářet objednávky pomocí testovacích pověření, zaškrtněte políčko „Testovací režim“."
									}
								],
								[
									{
										"text": "Nyní je čas vyplnit nastavení země. Pokud se nacházíte v Evropě, klikněte na tlačítko „rozbalit“ v sekci Evropa. Pokud se nacházíte v USA, klikněte na tlačítko „rozbalit“ v sekci Spojené státy."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci WooCommerce najdete v"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "rozšířeném průvodci."
									}
								]
							]
						},
						{
							"title": "Přidejte své přihlašovací údaje Klarna API",
							"step_instructions": [
								[
									{
										"text": "Do polí Uživatelské jméno API Klarna a Heslo API Klarna přidejte své přihlašovací údaje Klarna API."
									}
								],
								[
									{
										"text": "Nastavení uložte."
									}
								],
								[
									{
										"text": "Nakonec nastavte Pokladnu Klarna jako výchozí způsob platby. Na panelu WooCommerce přejděte do části „Nastavení“ a poté do části „Platby“. Najděte oddíl „Způsoby platby“ a nastavte Pokladnu Klarna jako výchozí způsob platby."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci WooCommerce najdete v"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "rozšířeném průvodci."
									}
								]
							]
						},
						{
							"title": "Poslední kroky",
							"step_instructions": [
								[
									{
										"text": "Nezapomeňte nastavit"
									},
									{
										"link": "https://codex.wordpress.org/Using_Permalinks",
										"text": "permalinky pretty"
									},
									{
										"text": "v instalaci WordPress. V opačném případě nebude zpětné volání z Klarny do vašeho obchodu fungovat a objednávky nebudou aktualizovány se správným stavem/informacemi o objednávce."
									}
								],
								[
									{
										"text": "Pokud chcete zpracovávat objednávky Klarna přímo ve WooCommerce, musíte si nainstalovat plugin"
									},
									{
										"link": "https://wordpress.org/plugins/klarna-order-management-for-woocommerce/",
										"text": "Správa objednávek Klarna"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Ujistěte se, že se Pokladna Klarna zobrazí podle očekávání, přidáním položky do košíku a přechodem k pokladně (objednávku ve skutečnosti neprovádějte)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci WooCommerce najdete v"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "rozšířeném průvodci."
									}
								]
							]
						}
					],
					"woocommerce_kp": [
						{
							"title": "Vygenerujte a uložte přihlašovací údaje Klarna API",
							"step_instructions": [
								[
									{
										"text": "Vygenerujte nové přihlašovací údaje API a stáhněte si soubor do počítače. Soubor otevřete a nechte jej otevřený, protože v následující části budete potřebovat tyto přihlašovací údaje API."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci WooCommerce najdete"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "v rozšířeném průvodci integrací."
									}
								]
							]
						},
						{
							"title": "Instalace a povolení pluginu Způsoby platby Klarna",
							"step_instructions": [
								[
									{
										"text": "Nainstalujte"
									},
									{
										"link": "https://woocommerce.com/products/klarna-payments/",
										"text": "plugin Způsoby platby Klarna pro WooCommerce."
									}
								],
								[
									{
										"text": "V účtu WooCommerce přejděte na"
									},
									{
										"bold": "Nastavení→ Platby → Způsoby platby Klarna."
									}
								],
								[
									{
										"text": "Povolte Způsoby platby Klarna zaškrtnutím políčka Povolit způsoby platby Klarna."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci WooCommerce najdete"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "v rozšířeném průvodci integrací."
									}
								]
							]
						},
						{
							"title": "Konfigurace nastavení pro danou zemi",
							"step_instructions": [
								[
									{
										"text": "Vyplňte nastavení pro danou zemi. Každá země Klarny má svou vlastní sadu specifických nastavení. Přidáním pověření obchodníka pro určitou zemi zároveň povolíte Způsoby platby Klarna jako dostupný způsob platby pro danou zemi."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci WooCommerce najdete"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "v rozšířeném průvodci integrací."
									}
								]
							]
						},
						{
							"title": "Zadejte své přihlašovací údaje Klarna API",
							"step_instructions": [
								[
									{
										"text": "Do polí Uživatelské jméno API Klarna a Heslo API Klarna zadejte své přihlašovací údaje Klarna API."
									}
								],
								[
									{
										"text": "Nastavení uložte."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci WooCommerce najdete"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "v rozšířeném průvodci integrací."
									}
								]
							]
						},
						{
							"title": "Provedení zkušebního nákupu",
							"step_instructions": [
								[
									{
										"text": "Chcete-li ověřit, zda je integrace správně nastavena, proveďte ve svém obchodě zkušební nákup."
									}
								],
								[
									{
										"text": "Po zadání objednávky přejděte na"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Objednávky na portálu obchodníka,"
									},
									{
										"text": "vyhledejte objednávku a zrušte ji, abyste za ni nemuseli sami platit."
									}
								],
								[
									{
										"text": "Jakmile bude integrace úspěšná, banner v horní části této stránky zezelená a zobrazí se „Integrace dokončena“."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci WooCommerce najdete"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "v rozšířeném průvodci integrací."
									}
								]
							]
						}
					],
					"magento_kco": [
						{
							"title": "Konfigurace nastavení pro pokladnu Klarna",
							"step_instructions": [
								[
									{
										"text": "Nejprve se ujistěte, že máte nainstalovaný modul Pokladna Klarna pro WooCommerce. Pokud ho ještě nemáte, přejděte na"
									},
									{
										"link": "https://marketplace.magento.com/klarna-m2-checkout.html",
										"text": "tuto stránku"
									},
									{
										"text": "a stáhněte si ho."
									}
								],
								[
									{
										"text": "Jakmile budete mít přihlašovací údaje Klarna API, otevřete panel Magento. Jděte na „Obchody“ → „Konfigurace“ → „Prodej“ → „Způsoby platby“ → „Klarna“ → „Klarna API“."
									}
								],
								[
									{
										"text": "Rozbalte oddíl „Klarna API“ a vyplňte verzi API, uživatelské jméno Klarna API a heslo Klarna API. Pokud jste připraveni na ostrý provoz webu, nezapomeňte vypnout testovací režim."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci Magento najdete v"
									},
									{
										"link": "https://marketplace.magento.com/media/catalog/product/klarna-m2-checkout-6-2-0-ce/user_guides.pdf",
										"text": "rozšířeném průvodci."
									}
								]
							]
						},
						{
							"title": "Poslední kroky",
							"step_instructions": [
								[
									{
										"text": "Když je nastavení nakonfigurováno, musíte zkontrolovat, zda je Pokladna Klarna v možnostech pokladny nastavená jako povolená."
									}
								],
								[
									{
										"text": "Jděte na „Obchody“ → „Konfigurace“ → „Prodej“ → „Pokladna“ → „Možnosti pokladny Klarna“ na panelu Magento."
									}
								],
								[
									{
										"text": "Pokladna Klarna by měla být povolena jako výchozí. Pokud není, přejděte na"
									},
									{
										"bold": "Povolit"
									},
									{
										"text": "v části „Povolit pokladnu Klarna“:"
									}
								]
							]
						}
					],
					"magento_kp": [
						{
							"title": "Vygenerujte a uložte přihlašovací údaje Klarna API",
							"step_instructions": [
								[
									{
										"text": "Vygenerujte nové přihlašovací údaje API a stáhněte si soubor do počítače. Soubor otevřete a nechte jej otevřený, protože v následující části budete potřebovat tyto přihlašovací údaje API."
									}
								]
							]
						},
						{
							"title": "Instalace a aktivace modulu Způsoby platby Klarna",
							"step_instructions": [
								[
									{
										"text": "Přejděte na téma"
									},
									{
										"link": "https://docs.magento.com/user-guide/payment/klarna-setup.html#set-up-klarna-payments-in-magento",
										"text": "Nastavení Klarny v uživatelské příručce Magento"
									},
									{
										"text": "a podle pokynů nainstalujte a nakonfigurujte modul ve svém účtu Magento."
									}
								]
							]
						},
						{
							"title": "Provedení zkušebního nákupu",
							"step_instructions": [
								[
									{
										"text": "Chcete-li ověřit, zda je integrace správně nastavena, proveďte ve svém obchodě zkušební nákup."
									}
								],
								[
									{
										"text": "Po zadání objednávky přejděte na"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Objednávky na portálu obchodníka,"
									},
									{
										"text": "vyhledejte objednávku a zrušte ji, abyste za ni nemuseli sami platit."
									}
								],
								[
									{
										"text": "Jakmile bude integrace úspěšná, banner v horní části této stránky zezelená a zobrazí se „Integrace dokončena“."
									}
								]
							]
						}
					],
					"shopware_kp": [
						{
							"title": "Povolení pluginu Způsoby platby Klarna pro Shopware",
							"step_instructions": [
								[
									{
										"text": "Nejprve se ujistěte, že máte nainstalovaný plugin Způsoby platby Klarna pro Shopware. Pokud ho ještě nemáte, přejděte na"
									},
									{
										"link": "https://store.shopware.com/en/besti13231874259f/klarna-payments.html",
										"text": "tuto stránku"
									},
									{
										"text": "a stáhněte si ho."
									}
								],
								[
									{
										"text": "V dalším kroku je třeba importovat plugin Způsoby platby Klarna do aplikace Shopware kliknutím na položky"
									},
									{
										"bold": "Konfigurace → Správce pluginů → Nainstalováno → Nahrát plugin."
									},
									{
										"text": "Klikněte na"
									},
									{
										"bold": "Vybrat"
									},
									{
										"text": "a výběrem souboru ZIP pluginu Způsoby platby Klarna. Potvrďte kliknutím na"
									},
									{
										"bold": "Nahrát plugin."
									},
									{
										"text": "Plugin je nyní k dispozici ve správci pluginů."
									}
								],
								[
									{
										"text": "Nainstalujte plugin kliknutím na"
									},
									{
										"bold": "zelenou ikonu „+“"
									},
									{
										"text": "."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci Shopware najdete v"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "rozšířeném průvodci (v němčině)."
									}
								]
							]
						},
						{
							"title": "Konfigurace pluginu Způsoby platby Klarna pro Shopware",
							"step_instructions": [
								[
									{
										"text": "Přejděte na nastavení pluginu kliknutím na"
									},
									{
										"bold": "Konfigurace → Základní nastavení → Vyhledat Způsoby platby Klarna"
									}
								],
								[
									{
										"text": "Do příslušných polí zadejte své přihlašovací údaje Klarna API"
									},
									{
										"bold": "Uživatelské jméno Klarna API"
									},
									{
										"text": "a"
									},
									{
										"bold": "Heslo Klarna API"
									},
									{
										"text": "a uložte změny."
									}
								],
								[
									{
										"text": "Ujistěte se, že používáte živý režim a přihlašovací údaje Klarna API."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci Shopware najdete v"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "rozšířeném průvodci (v němčině)."
									}
								]
							]
						},
						{
							"title": "Konfigurace platební brány (bran) způsobů platby Klarna",
							"step_instructions": [
								[
									{
										"text": "Před použitím Klarny musíte aktivovat platební bránu (brány) způsobů platby Klarna Najdete je kliknutím na"
									},
									{
										"bold": "Konfigurace → Způsoby platby"
									}
								],
								[
									{
										"text": "Ve výchozím nastavení jsou nainstalovány všechny platební brány způsobů platby Klarna. Otevřete platební brány způsobů platby Klarna, ke kterým jste registrovaní, a aktivujte je zaškrtnutím políčka"
									},
									{
										"bold": "Aktivované"
									},
									{
										"text": ". Uložte změny."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci Shopware najdete v"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "rozšířeném průvodci (v němčině)."
									}
								]
							]
						},
						{
							"title": "Konfigurace nákladů na dopravu",
							"step_instructions": [
								[
									{
										"text": "Náklady na dopravu pro svou platební bránu (brány) způsobů platby Klarna nakonfigurujte kliknutím na"
									},
									{
										"bold": "Konfigurace → Náklady na dopravu"
									}
								],
								[
									{
										"text": "Kliknutím na ikonu tužky vyberte způsoby přepravy, které by měly být pro Klarnu"
									},
									{
										"bold": "k dispozici."
									}
								],
								[
									{
										"text": "Vyberte záložku Výběr způsobu platby a přesuňte platební bránu (brány) způsobů platby Klarna z nabídky"
									},
									{
										"bold": "Dostupné"
									},
									{
										"text": "do"
									},
									{
										"bold": "Vybrané."
									},
									{
										"text": "Nastavení uložte."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci Shopware najdete v"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "rozšířeném průvodci (v němčině)."
									}
								]
							]
						},
						{
							"title": "Aktivace pluginu Způsoby platby Klarna",
							"step_instructions": [
								[
									{
										"text": "Dále je třeba aktivovat plugin Způsoby platby Klarna. Přejděte do správce pluginů kliknutím na"
									},
									{
										"bold": "Konfigurace → Správce pluginů → Nainstalováno"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Aktivujte plugin kliknutím na"
									},
									{
										"bold": "červenou ikonu „X“"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Budete dotázáni, zda chcete vyprázdnit mezipaměť. Klikněte na"
									},
									{
										"bold": "Ano."
									},
									{
										"text": "Vezměte prosím na vědomí, že je třeba vymazat mezipaměť a zkompilovat témata pokaždé, když změníte něco v nastavení modulu nebo platebních metod z Klarny."
									}
								],
								[
									{
										"text": "Pro plnou aktivaci pluginu Způsoby platby Klarna je třeba znovu zkompilovat motiv obchodu. Klikněte na"
									},
									{
										"bold": "Kompilovat témata,"
									},
									{
										"text": "jakmile k tomu budete vyzváni."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci Shopware najdete v"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "rozšířeném průvodci (v němčině)."
									}
								]
							]
						},
						{
							"title": "Poslední kroky",
							"step_instructions": [
								[
									{
										"text": "Abyste se vyhnuli chybám při zaokrouhlování, ujistěte se, že máte na serveru nainstalováno rozšíření PHP bcmath. Průvodce najdete"
									},
									{
										"link": "http://php.net/manual/en/book.bc.php",
										"text": "tady."
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Jednou restartujte backend, abyste se ujistili, že jsou v obchodě k dispozici všechny konfigurace."
									}
								],
								[
									{
										"text": "Ujistěte se, že se produkt(y) Platby Klarna zobrazí podle očekávání, a to tak, že přidáte položku do košíku, jako způsob platby zvolíte Klarna a přejdete k pokladně (objednávku ve skutečnosti nezadávejte)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci Shopware najdete v"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "rozšířeném průvodci (v němčině)."
									}
								]
							]
						}
					],
					"shopware_kco": [
						{
							"title": "Povolení pluginu Pokladna Klarna pro Shopware",
							"step_instructions": [
								[
									{
										"text": "Nejprve se ujistěte, že máte nainstalovaný plugin Pokladna Klarna pro Shopware (verze 5.2.17 a novější). Pokud ho ještě nemáte, přejděte na"
									},
									{
										"link": "https://store.shopware.com/en/besti56121054232f/klarna-checkout.html",
										"text": "tuto stránku"
									},
									{
										"text": "a stáhněte si ho."
									}
								],
								[
									{
										"text": "V dalším kroku je třeba importovat plugin Pokladna Klarna do aplikace Shopware kliknutím na položky"
									},
									{
										"bold": "Konfigurace → Správce pluginů → Nainstalováno → Nahrát plugin."
									},
									{
										"text": "Klikněte na"
									},
									{
										"bold": "Vybrat"
									},
									{
										"text": "a vyberte soubor ZIP Plugin Pokladna Klarna. Potvrďte kliknutím na"
									},
									{
										"bold": "Nahrát plugin."
									},
									{
										"text": "Plugin je nyní k dispozici ve správci pluginů."
									}
								],
								[
									{
										"text": "Nainstalujte plugin kliknutím na"
									},
									{
										"bold": "zelenou ikonu „+“"
									},
									{
										"text": "."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci Shopware najdete v"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "rozšířeném průvodci (v němčině)."
									}
								]
							]
						},
						{
							"title": "Konfigurace pluginu Pokladna Klarna pro Shopware",
							"step_instructions": [
								[
									{
										"text": "Přejděte na nastavení pluginu kliknutím na"
									},
									{
										"bold": "Konfigurace → Základní nastavení → Vyhledat Pokladnu Klarna"
									}
								],
								[
									{
										"text": "Do příslušných polí zadejte své přihlašovací údaje Klarna API"
									},
									{
										"bold": "Uživatelské jméno Klarna API"
									},
									{
										"text": "a"
									},
									{
										"bold": "Heslo Klarna API"
									},
									{
										"text": "a uložte změny."
									}
								],
								[
									{
										"text": "Ujistěte se, že používáte živý režim a přihlašovací údaje Klarna API."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci Shopware najdete v"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "rozšířeném průvodci (v němčině)."
									}
								]
							]
						},
						{
							"title": "Aktivace platební brány Pokladna Klarna",
							"step_instructions": [
								[
									{
										"text": "Před použitím Klarny musíte aktivovat platební bránu (brány) Klarna. Najdete je kliknutím na"
									},
									{
										"bold": "Konfigurace → Způsoby platby"
									}
								],
								[
									{
										"text": "Otevřete bránu Pokladna Klarna a aktivujte ji zaškrtnutím políčka"
									},
									{
										"bold": "Aktivované"
									},
									{
										"text": ". Uložte změny."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci Shopware najdete v"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "rozšířeném průvodci (v němčině)."
									}
								]
							]
						},
						{
							"title": "Konfigurace nákladů na dopravu",
							"step_instructions": [
								[
									{
										"text": "Náklady na dopravu pro Pokladnu Klarna nakonfigurujte kliknutím na"
									},
									{
										"bold": "Konfigurace → Náklady na dopravu"
									}
								],
								[
									{
										"text": "Kliknutím na ikonu tužky vyberte způsoby přepravy, které by měly být pro Klarnu"
									},
									{
										"bold": "k dispozici."
									}
								],
								[
									{
										"text": "Vyberte záložku Výběr způsobu platby a přesuňte Pokladnu Klarna z nabídky"
									},
									{
										"bold": "Dostupné"
									},
									{
										"text": "do"
									},
									{
										"bold": "Vybrané."
									},
									{
										"text": "Nastavení uložte."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci Shopware najdete v"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "rozšířeném průvodci (v němčině)."
									}
								]
							]
						},
						{
							"title": "Aktivace pluginu Pokladna Klarna",
							"step_instructions": [
								[
									{
										"text": "Dále je třeba aktivovat plugin Pokladna Klarna. Přejděte do správce pluginů kliknutím na"
									},
									{
										"bold": "Konfigurace → Správce pluginů → Nainstalováno"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Aktivujte plugin kliknutím na"
									},
									{
										"bold": "červenou ikonu „X“"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Budete dotázáni, zda chcete vyprázdnit mezipaměť. Klikněte na"
									},
									{
										"bold": "Ano."
									}
								],
								[
									{
										"text": "Pro plnou aktivaci pluginu Pokladna Klarna je třeba znovu zkompilovat téma obchodu. Klikněte na"
									},
									{
										"bold": "Kompilovat témata,"
									},
									{
										"text": "jakmile k tomu budete vyzváni."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci Shopware najdete v"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "rozšířeném průvodci (v němčině)."
									}
								]
							]
						},
						{
							"title": "Poslední kroky",
							"step_instructions": [
								[
									{
										"text": "Abyste se vyhnuli chybám při zaokrouhlování, ujistěte se, že máte na serveru nainstalováno rozšíření PHP bcmath. Průvodce najdete"
									},
									{
										"link": "http://php.net/manual/en/book.bc.php",
										"text": "tady."
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Ujistěte se, že položky „Další řádek 1 adresy“ a „Další řádek 2 adresy“ nejsou označeny jako povinné."
									}
								],
								[
									{
										"text": "Jednou restartujte backend, abyste se ujistili, že jsou v obchodě k dispozici všechny konfigurace."
									}
								],
								[
									{
										"text": "Ujistěte se, že se produkt(y) Pokladna Klarna zobrazí podle očekávání, a to tak, že přidáte položku do košíku, jako způsob platby zvolíte Klarna a přejdete k pokladně (objednávku ve skutečnosti nezadávejte)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci Shopware najdete v"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "rozšířeném průvodci (v němčině)."
									}
								]
							]
						}
					],
					"shopware_6_kp": [
						{
							"title": "Povolení pluginu Způsoby platby Klarna pro Shopware",
							"step_instructions": [
								[
									{
										"text": "Abyste mohli nainstalovat plugin Klarna, potřebujete mít spuštěný systém Shopware 6. Pokyny k instalaci najdete"
									},
									{
										"link": "https://docs.shopware.com/en/shopware-6-en/first-steps/installing-shopware-6",
										"text": "tady."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci Shopware najdete v"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "rozšířeném průvodci (v němčině)."
									}
								]
							]
						},
						{
							"title": "Instalace a nastavení Plugin Klarna lze instalovat několika způsoby.",
							"step_instructions": [
								[
									{
										"text": "Nejprve spusťte průvodce."
									}
								],
								[
									{
										"text": "Instalace prostřednictvím správy."
									}
								],
								[
									{
										"text": "Instalace prostřednictvím služby Community Store Přímé stažení."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci Shopware najdete v"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "rozšířeném průvodci (v němčině)."
									}
								]
							]
						},
						{
							"title": "Aktivace pluginu Způsoby platby Klarna pro Shopware",
							"step_instructions": [
								[
									{
										"text": "Přejděte do přehledu svých pluginů v části Shopware Administration. Můžete sem přejít kliknutím na"
									},
									{
										"bold": "Nastavení > Systém > Pluginy."
									}
								],
								[
									{
										"text": "Vyberte"
									},
									{
										"bold": "Instalace"
									},
									{
										"text": "z místní nabídky („...“). Od společnosti Shopware obdržíte zprávu o úspěšné instalaci pluginu."
									}
								],
								[
									{
										"text": "Z bezpečnostních důvodů je nyní plugin nainstalován, ale ještě není aktivován. Nejprve jej musíte optimalizovat pomocí přístupových údajů a individuálních nastavení."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci Shopware najdete v"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "rozšířeném průvodci (v němčině)."
									}
								]
							]
						},
						{
							"title": "Průvodce",
							"step_instructions": [
								[
									{
										"text": "Po aktivaci pluginu prosím přejděte na"
									},
									{
										"bold": "Místní nabídka („...“) > průvodce.",
										"text": "Budete přesměrováni na rutinu."
									}
								],
								[
									{
										"text": "Rutina vás provede celým procesem nastavení a umožní vám zaregistrovat se u společnosti Klarna, pokud ještě nemáte účet obchodníka."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci Shopware najdete v"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "rozšířeném průvodci (v němčině)."
									}
								]
							]
						},
						{
							"title": "Konfigurace pluginu",
							"step_instructions": [
								[
									{
										"bold": "Prodejní kanály."
									},
									{
										"text": "Zde určíte, zda se následující nastavení pro „všechny prodejní kanály“ mají nebo by měly vztahovat pouze na určité jednotlivé prodejní kanály."
									}
								],
								[
									{
										"bold": "Nastavení API."
									},
									{
										"text": "Uživatelské jméno API a heslo API: Zde zadejte do příslušných oddílů přístupové údaje k rozhraní API pro živý a testovací režim."
									}
								],
								[
									{
										"text": "Přihlašovací údaje Klarna API můžete otestovat kliknutím na tlačítko"
									},
									{
										"bold": "Testovat přihlašovací údaje API,",
										"text": "které najdete v záhlaví. Poté se zobrazí zpráva o úspěchu nebo údaj o tom, které údaje se zdají být nesprávné."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci Shopware najdete v"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "rozšířeném průvodci (v němčině)."
									}
								]
							]
						},
						{
							"title": "Aktivace/deaktivace pluginu",
							"step_instructions": [
								[
									{
										"text": "Pokud chcete aktivovat/deaktivovat plugin Způsoby platby Klarna nebo se jen chcete podívat na aktuální stav aktivace, přejděte do části Správa Shopware a vyberte možnost"
									},
									{
										"bold": "Nastavení > Systém > Pluginy."
									}
								],
								[
									{
										"text": "Aktuální stav je zde uveden v tabulce v části"
									},
									{
										"bold": "„Moje pluginy“."
									}
								],
								[
									{
										"text": "Stav lze změnit kliknutím na posuvník."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci Shopware najdete v"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "rozšířeném průvodci (v němčině)."
									}
								]
							]
						},
						{
							"title": "Poslední kroky",
							"step_instructions": [
								[
									{
										"text": "Abyste předešli chybám při zaokrouhlování, ujistěte se, že máte verzi PHP >= 7.2."
									}
								],
								[
									{
										"text": "Dokončení instalace Shopware"
									},
									{
										"bold": "(Storefront + správa, nikoli bezhlavě)."
									}
								],
								[
									{
										"text": "Systém musí být přístupný zvenčí pro aktualizaci stavu platby."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci Shopware najdete v"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "rozšířeném průvodci (v němčině)."
									}
								]
							]
						}
					],
					"3dcart_kp": [
						{
							"title": "Vygenerujte a uložte přihlašovací údaje Klarna API",
							"step_instructions": [
								[
									{
										"text": "Vygenerujte nové přihlašovací údaje API a stáhněte si soubor do počítače. Soubor otevřete a nechte jej otevřený, protože v následující části budete potřebovat tyto přihlašovací údaje API."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci se službou 3dcart najdete"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "v rozšířeném průvodci integrací."
									}
								]
							]
						},
						{
							"title": "Aktivace Způsobů platby Klarna v nástroji Online Store Manager",
							"step_instructions": [
								[
									{
										"text": "Přihlaste se do"
									},
									{
										"link": "https://www.shift4shop.com/login-page.html",
										"text": "3dcart Online Store Manager"
									},
									{
										"text": "a přejděte na"
									},
									{
										"bold": "Nastavení → Platba."
									}
								],
								[
									{
										"text": "Na stránce Platba klikněte na tlačítko"
									},
									{
										"bold": "Vybrat způsoby platby"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Zobrazí se seznam předinstalovaných modulů. Vyhledejte modul Klarna a aktivujte jej přepínačem."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci se službou 3dcart najdete"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "v rozšířeném průvodci integrací."
									}
								]
							]
						},
						{
							"title": "Zadejte své přihlašovací údaje Klarna API",
							"step_instructions": [
								[
									{
										"text": "Po aktivaci modulu zadejte do příslušného pole své uživatelské jméno Klarna API (UID). Najdete ho v souboru s přihlašovacími údaji, který jste si stáhli dříve."
									}
								],
								[
									{
										"text": "Dále klikněte na odkaz"
									},
									{
										"bold": "Změna hesla"
									},
									{
										"text": "a do pole pro heslo zadejte své heslo Klarna API."
									}
								],
								[
									{
										"text": "V části"
									},
									{
										"bold": "Jazyk země"
									},
									{
										"text": "vyberte jazyk země, který se bude používat pro platební možnosti Klarna v obchodě."
									}
								],
								[
									{
										"text": "Nad polem pro uživatelské jméno je zaškrtávací políčko označené jako"
									},
									{
										"bold": "„Testovací režim“."
									},
									{
										"text": "Zaškrtnutím této možnosti aktivujete testovací režim, který vám umožní zadávat objednávky bez jakýchkoli poplatků nebo platebních akcí během testování modulu."
									}
								],
								[
									{
										"text": "Po dokončení konfigurace nastavení klikněte vpravo nahoře na tlačítko „Uložit“."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci se službou 3dcart najdete"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "v rozšířeném průvodci integrací."
									}
								]
							]
						},
						{
							"title": "Provedení zkušebního nákupu",
							"step_instructions": [
								[
									{
										"text": "Chcete-li ověřit, zda je integrace správně nastavena, proveďte ve svém obchodě zkušební nákup."
									}
								],
								[
									{
										"text": "Po zadání objednávky přejděte na"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Objednávky na portálu obchodníka,"
									},
									{
										"text": "vyhledejte objednávku a zrušte ji, abyste za ni nemuseli sami platit."
									}
								],
								[
									{
										"text": "Jakmile bude integrace úspěšná, banner v horní části této stránky zezelená a zobrazí se „Integrace dokončena“."
									}
								],
								[
									{
										"text": "Pokud jste v předchozím kroku zapnuli „Testovací režim“, vraťte se do oddílu S jistotou, zrušte jeho zaškrtnutí a uložte jej před spuštěním obchodu, aby vaše skutečné objednávky prošly správně."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Podrobnější informace o integraci se službou 3dcart najdete"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "v rozšířeném průvodci integrací."
									}
								]
							]
						}
					],
					"bigcommerce_kp": [
						{
							"title": "Vygenerujte a uložte přihlašovací údaje Klarna API",
							"step_instructions": [
								[
									{
										"text": "Vygenerujte nové přihlašovací údaje API a stáhněte si soubor do počítače. Soubor otevřete a nechte jej otevřený, protože v následující části budete potřebovat tyto přihlašovací údaje API."
									}
								]
							],
							"alternate": [
								{
									"text": "Podrobnější informace o integraci se službou BigCommerce najdete"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "v rozšířeném průvodci integrací."
								}
							]
						},
						{
							"title": "Konfigurace nastavení BigCommerce",
							"step_instructions": [
								[
									{
										"text": "V BigCommerce jděte na"
									},
									{
										"link": "http://login.bigcommerce.com/deep-links/settings/payment",
										"text": "Nastavení obchodu › Platby"
									},
									{
										"text": "a rozbalte oddíl Online způsoby platby. Pak klikněte"
									},
									{
										"bold": "na Nastavení"
									},
									{
										"text": "vedle způsobů platby Klarna."
									}
								],
								[
									{
										"text": "Budete přesměrováni na záložku Nastavení způsobů platby Klarna. Zadejte soubor přihlašovacích údajů API, který jste uložili v předchozí části, a zkopírujte uživatelské jméno a heslo do příslušných polí."
									}
								],
								[
									{
										"text": "Až budete připraveni, uložte změny."
									}
								]
							],
							"alternate": [
								{
									"text": "Podrobnější informace o integraci se službou BigCommerce najdete"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "v rozšířeném průvodci integrací."
								}
							]
						},
						{
							"title": "Provedení zkušebního nákupu",
							"step_instructions": [
								[
									{
										"text": "Chcete-li ověřit, zda je integrace správně nastavena, proveďte ve svém obchodě zkušební nákup."
									}
								],
								[
									{
										"text": "Po zadání objednávky přejděte na"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Objednávky na portálu obchodníka,"
									},
									{
										"text": "vyhledejte objednávku a zrušte ji, abyste za ni nemuseli sami platit."
									}
								],
								[
									{
										"text": "Jakmile bude integrace úspěšná, banner v horní části této stránky zezelená a zobrazí se „Integrace dokončena“."
									}
								]
							],
							"alternate": [
								{
									"text": "Podrobnější informace o integraci se službou BigCommerce najdete"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "v rozšířeném průvodci integrací."
								}
							]
						}
					],
					"prestashop_kco": [
						{
							"title": "Aktivace modulu Pokladna Klarna",
							"step_instructions": [
								[
									{
										"text": "Nejprve se ujistěte, že máte nainstalovaný oficiální modul Klarna pro Prestashop. Pokud ho ještě nemáte, přejděte na"
									},
									{
										"link": "https://addons.prestashop.com/en/express-checkout-process/90132-klarna-checkout.html?no_cache=1",
										"text": "tuto stránku"
									},
									{
										"text": "a stáhněte si ho."
									}
								],
								[
									{
										"text": "Od 1. ledna 2023 bohužel nebudou tyto moduly plug-in vyvinuté a vlastněné společností Prestasworks A.B (SI) distribuovány zdarma. Pokud máte o Klarnu zájem, můžete si zásuvný modul zakoupit nebo počkat na zásuvné moduly vlastněné společností Klarna, jejichž vydání se očekává ve 2. čtvrtletí roku 23."
									}
								],
								[
									{
										"text": "Přihlaste se na stránku pro správu Prestashop a přejděte na"
									},
									{
										"bold": "Moduly → Moduly."
									}
								],
								[
									{
										"text": "Modul Klarna od společnosti Prestaworks AB vyhledáte pomocí vyhledávacího panelu „Klarna“. Klikněte na"
									},
									{
										"bold": "Konfigurovat."
									}
								]
							]
						},
						{
							"title": "Konfigurace nastavení modulu Klarna",
							"step_instructions": [
								[
									{
										"text": "Nyní jste na stránce nastavení modulu. V horní části okna „Obecná nastavení“ najdete tlačítko nazvané"
									},
									{
										"bold": "Aktivovat KCO v tomto obchodě"
									},
									{
										"text": "(Pokladna Klarna V3). Vyberte"
									},
									{
										"bold": "Ano."
									}
								],
								[
									{
										"text": "Klikněte na"
									},
									{
										"bold": "Uložit"
									},
									{
										"text": "k uložení nastavení."
									}
								],
								[
									{
										"text": "Nyní klikněte na svou zemi prodeje v levé nabídce a zadejte své přihlašovací údaje Klarna API v části"
									},
									{
										"bold": "Uživatelské jméno Klarna API"
									},
									{
										"text": "a"
									},
									{
										"bold": "Heslo Klarna API."
									}
								],
								[
									{
										"text": "Klikněte na"
									},
									{
										"bold": "Uložit."
									}
								]
							]
						},
						{
							"title": "Poslední kroky",
							"step_instructions": [
								[
									{
										"text": "Pokud jste připraveni na spuštění webu, zkontrolujte, zda je testovací režim vypnutý. K tomu slouží záložka"
									},
									{
										"bold": "Běžná nastavení."
									},
									{
										"text": "Tlačítko"
									},
									{
										"bold": "Testdrive"
									},
									{
										"text": "by mělo být nastaveno na"
									},
									{
										"bold": "Ne."
									}
								],
								[
									{
										"text": "V části"
									},
									{
										"bold": "Běžná nastavení"
									},
									{
										"text": "si nezapomeňte nastavit, jak chcete zpracovávat objednávky, nastavení pro odesílání faktur atd."
									}
								],
								[
									{
										"text": "Ujistěte se, že se Pokladna Klarna zobrazí podle očekávání, přidáním položky do košíku a přechodem k pokladně (objednávku ve skutečnosti neprovádějte)."
									}
								]
							]
						}
					],
					"prestashop_kp": [
						{
							"title": "Vygenerujte a uložte přihlašovací údaje Klarna API",
							"step_instructions": [
								[
									{
										"text": "Vygenerujte nové přihlašovací údaje API a stáhněte si soubor do počítače. Soubor otevřete a nechte jej otevřený, protože v následující části budete potřebovat tyto přihlašovací údaje API."
									}
								]
							]
						},
						{
							"title": "Instalace a aktivace modulu Způsoby platby Klarna",
							"step_instructions": [
								[
									{
										"text": "Otevřete"
									},
									{
										"link": "https://addons.prestashop.com/en/payment-card-wallet/90140-klarna-payments.html?no_cache=1",
										"text": "Stránku s pokyny pro způsoby platby Klarna Prestashop"
									},
									{
										"text": "a podle pokynů nainstalujte a nakonfigurujte modul ve svém účtu Prestashop."
									}
								]
							]
						},
						{
							"title": "Provedení zkušebního nákupu",
							"step_instructions": [
								[
									{
										"text": "Chcete-li ověřit, zda je integrace správně nastavena, proveďte ve svém obchodě zkušební nákup."
									}
								],
								[
									{
										"text": "Po zadání objednávky přejděte na"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Objednávky na portálu obchodníka,"
									},
									{
										"text": "vyhledejte objednávku a zrušte ji, abyste za ni nemuseli sami platit."
									}
								],
								[
									{
										"text": "Jakmile bude integrace úspěšná, banner v horní části této stránky zezelená a zobrazí se „Integrace dokončena“."
									}
								]
							]
						}
					],
					"jumpseller": [
						{
							"title": "Vygenerujte své přihlašovací údaje Klarna API.",
							"step_instructions": [
								[
									{
										"text": "Tyto přihlašovací údaje jsou potřeba pro integraci Klarny ve vašem obchodě."
									}
								]
							]
						},
						{
							"title": "Přidejte Klarnu jako novou platební metodu.",
							"step_instructions": [
								[
									{
										"text": "Na panelu administrátora Jumpseller přejděte do nabídky Nastavení > Platby, v seznamu zaškrtávacích políček najděte položku Klarna a klikněte na tlačítko Přidat způsob."
									}
								]
							]
						},
						{
							"title": "Nakonfigurujte si náš nový způsob platby.",
							"step_instructions": [
								[
									{
										"text": "Na konfiguračním panelu Klarna (panel administrátora Jumpseller přejděte na Nastavení > Platby > Klarna) (i) přidejte přihlašovací údaje API Klarna vygenerované v prvním kroku, (ii) vyberte balíčky EMD, které chcete/potřebujete sdílet s Klarnou, a (iii) vyberte, zda potřebujete automaticky zachytit objednávky (výchozí nastavení je ne)."
									}
								]
							]
						}
					],
					"lightspeed": [
						{
							"title": "Integrace Lightspeed eCom",
							"step_instructions": [
								[
									{
										"text": "Viz průvodce integrací v těchto jazycích:"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/lightspeed/eng.pdf",
										"text": "Angličtina"
									},
									{
										"text": "a"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/lightspeed/nl.pdf",
										"text": "Holandština"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"shoper": [
						{
							"title": "Integrovat aplikaci Shoper",
							"step_instructions": [
								[
									{
										"text": "Viz průvodce integrací v"
									},
									{
										"link": "https://www.shoper.pl/help/artykul/klarna-platnosci-odroczone-konfiguracja",
										"text": "webové stránky Shoper"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"timma": [
						{
							"title": "Integrovat Timma",
							"step_instructions": [
								[
									{
										"text": "Viz průvodce integrací v"
									},
									{
										"link": "https://help.timma.fi/sv/articles/4990994-betalning-via-klarna",
										"text": "Web Timma"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"smartetailing": [
						{
							"title": "Vygenerujte a uložte přihlašovací údaje Klarna API",
							"step_instructions": [
								[
									{
										"text": "Vygenerujte nové přihlašovací údaje API a stáhněte si soubor do počítače. Soubor otevřete a nechte jej otevřený, protože v následující části budete potřebovat tyto přihlašovací údaje API."
									}
								]
							]
						},
						{
							"title": "Integrace se SmartEtailing",
							"step_instructions": [
								[
									{
										"text": "Postupujte podle pokynů na"
									},
									{
										"link": "https://www.smartetailing.com/help/financing-with-klarna",
										"text": "webu SmartEtailing."
									}
								]
							]
						}
					],
					"workstand": [
						{
							"title": "Vygenerujte a uložte přihlašovací údaje Klarna API",
							"step_instructions": [
								[
									{
										"text": "Vygenerujte nové přihlašovací údaje API a stáhněte si soubor do počítače. Soubor otevřete a nechte jej otevřený, protože v následující části budete potřebovat tyto přihlašovací údaje API."
									}
								]
							]
						},
						{
							"title": "Integrace se Workstand",
							"step_instructions": [
								[
									{
										"text": "Postupujte podle pokynů na"
									},
									{
										"link": "https://www.workstand.com/help/financing-with-klarna",
										"text": "webu Workstand"
									}
								]
							]
						}
					],
					"jtl5_kco": [
						{
							"title": "Přečtěte si dokumentaci k našemu pluginu",
							"step_instructions": [
								[
									{
										"text": "Přejděte na"
									},
									{
										"link": "https://solution360.atlassian.net/wiki/spaces/S360DOKU/pages/1518829612/Klarna+Zahlungsarten+JTL-Shop+5",
										"text": "stránka s dokumentací"
									}
								]
							]
						},
						{
							"title": "Aktivace modulu Klarna Checkout pro JTL-Shop 5",
							"step_instructions": [
								[
									{
										"text": "Ujistěte se, že máte nainstalováno oficiální rozšíření Klarna. Pokud ho ještě nemáte,"
									},
									{
										"text": "přejděte na"
									},
									{
										"link": "https://www.jtl-software.de/extension-store/klarna-payments-mehr-als-reine-zahlungsarten-jtl-shop-5",
										"text": "tuto stránku"
									},
									{
										"text": "a stáhněte si ho."
									}
								]
							]
						}
					],
					"jtl5_kp": [
						{
							"title": "Přečtěte si dokumentaci k našemu pluginu",
							"step_instructions": [
								[
									{
										"text": "Přejděte na"
									},
									{
										"link": "https://solution360.atlassian.net/wiki/spaces/S360DOKU/pages/1518829612/Klarna+Zahlungsarten+JTL-Shop+5",
										"text": "stránka s dokumentací"
									}
								]
							]
						},
						{
							"title": "Aktivace modulu Klarna Payments pro JTL-Shop 5",
							"step_instructions": [
								[
									{
										"text": "Ujistěte se, že máte nainstalováno oficiální rozšíření Klarna. Pokud ho ještě nemáte,"
									},
									{
										"text": "přejděte na"
									},
									{
										"link": "https://www.jtl-software.de/extension-store/klarna-payments-mehr-als-reine-zahlungsarten-jtl-shop-5",
										"text": "tuto stránku"
									},
									{
										"text": "a stáhněte si ho."
									}
								]
							]
						}
					],
					"no_instructions": [
						{
							"title": "Zde je další postup",
							"step_instructions": [
								[
									{
										"bold": "Vygenerujte své přihlašovací údaje Klarna API."
									},
									{
										"text": "Ty jsou potřeba pro integraci Klarny ve vašem obchodě."
									}
								],
								[
									{
										"bold": "Přidejte Přihlašovací údaje Klarna API do svého backendového systému k povolení Klarny."
									},
									{
										"text": "Podívejte se na náš"
									},
									{
										"link": "https://developers.klarna.com/",
										"text": "Portál pro vývojáře"
									},
									{
										"text": "s další podporou."
									}
								]
							]
						}
					]
				},
				"stakeholders": {
					"form": {
						"first_name": {
							"label": "Jméno",
							"error": "Zadejte prosím jméno"
						},
						"last_name": {
							"label": "Příjmení",
							"error": "Zadejte prosím příjmení"
						},
						"dateOfBirth": {
							"label": {
								"default": "Datum narození (DD/MM/RRRR)",
								"without_format": "Datum narození",
								"US": "Datum narození (MM/DD/RRRR)"
							},
							"error": "Zadejte platné datum",
							"error_too_young": "Abyste mohli prodávat s Klarnou, musí vám být alespoň 18 let."
						},
						"address": {
							"label": "Adresa bydliště",
							"error": "Zadejte prosím adresu"
						},
						"city": {
							"label": "Město",
							"error": "Zadejte prosím město"
						},
						"country": {
							"label": "Země",
							"error": "Vyberte prosím zemi"
						},
						"postal_code": {
							"label": {
								"default": "PSČ",
								"US": "Poštovní směrovací číslo"
							},
							"error": {
								"default": "Zadejte prosím platné poštovní směrovací číslo",
								"US": "Zadejte prosím platné PSČ"
							}
						},
						"region": {
							"label": "Stát/region (volitelné)",
							"label_summary": "Stát/region"
						},
						"state": {
							"label": "Stát",
							"error": "Zadejte prosím stát"
						},
						"role_question": {
							"OWNER": "Je tato osoba vlastníkem?",
							"BENEFICIAL_OWNER": "Ovládá tato osoba více než 25 % akcií nebo hlasovacích práv?",
							"ULTIMATE_BENEFICIAL_OWNER": "Tato osoba vlastní nebo ovládá více než 25 % akcií nebo hlasovacích práv."
						},
						"is_person_pep": [
							{
								"text": "Je tato osoba"
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "nejbližším příbuzným"
							},
							{
								"text": ","
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "nebo známým spolupracovníkem"
							},
							{
								"text": "politicky"
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "exponované"
							},
							{
								"text": "osoby?"
							}
						],
						"pep_relationship": {
							"label": "Vztah",
							"error": "Vyberte prosím, jaký vztah má tato osoba k PEP."
						},
						"pep_position": {
							"label": "Pozice PEP",
							"error": "Vyberte prosím pozici, kterou PEP zastává"
						},
						"personal_id_question": "Tato osoba nemá osobní identifikační číslo.",
						"personal_id": {
							"US": {
								"label": "Číslo sociálního pojištění (poslední 4 číslice)",
								"label_summary": "Číslo sociálního pojištění"
							},
							"US_FULL_SSN": {
								"label": "Číslo sociálního pojištění",
								"label_summary": "Číslo sociálního pojištění"
							},
							"CA": {
								"label": "Číslo sociálního pojištění (SIN) nebo číslo pasu",
								"label_summary": "Číslo sociálního pojištění (SIN) nebo číslo pasu"
							},
							"SE": {
								"label": "Osobní identifikační číslo (PNO)",
								"label_summary": "Osobní identifikační číslo (PNO)"
							},
							"FI": {
								"label": "Osobní identifikační kód (HETU)",
								"label_summary": "Osobní identifikační číslo (HETU)"
							},
							"NO": {
								"label": "Národní identifikační číslo",
								"label_summary": "Národní identifikační číslo"
							},
							"DK": {
								"label": "Osobní identifikační číslo",
								"label_summary": "Osobní identifikační číslo (CPR)"
							},
							"IT": {
								"label": "Fiskální kód",
								"label_summary": "Fiskální kód"
							},
							"ES": {
								"label": "Osobní identifikační číslo",
								"label_summary": "Osobní identifikační číslo (DNI)"
							},
							"PL": {
								"label": "Osobní identifikační číslo",
								"label_summary": "Osobní identifikační číslo (PESEL)"
							},
							"default": {
								"label": "Číslo pasu",
								"label_summary": "Číslo pasu"
							},
							"value": "Důvěrné"
						},
						"registration_number": {
							"label": "Identifikační číslo podniku",
							"error": "Zadejte prosím EIN ve formátu: XX-XXXXXXXXX"
						},
						"company_name": {
							"label": "Název obchodu",
							"error": "Uveďte prosím platný název společnosti"
						},
						"legal_company_name": {
							"label": "Právní název společnosti",
							"error_label": "Uveďte prosím právní název společnosti"
						},
						"add_person": "Přidat osobu",
						"remove": "Odebrat",
						"edit": "Upravit"
					}
				},
				"steps_headers": {
					"merchant": {
						"merchant_id": "ID obchodníka: {merchantId}"
					}
				},
				"goodie_bags": {
					"marketing_material": {
						"title": "Marketingový materiál",
						"text": "Nyní jste součástí rodiny Klarna. Zde je balíček materiálů a další materiály, které vám pomohou.",
						"link": "Stáhnout"
					},
					"invite_more_users": {
						"title": "Pozvat více uživatelů",
						"text": "Pozvěte své spolupracovníky na portál obchodníka a budete jim moci nastavit vlastní oprávnění!",
						"link": "Pozvat uživatele"
					}
				},
				"terms_and_conditions_confirmation": {
					"title": "Produkty a ceny",
					"subtitle": "{country}",
					"pricing": "Cena za {country}",
					"monthly_fee": "Měsíční poplatek",
					"transaction_fee": "Poplatek za transakci",
					"before_link": "Souhlasím se smluvními",
					"link_text": "podmínkami Klarna",
					"after_link_one_product": "pro tento produkt",
					"after_link_more_than_one_product": "pro tyto produkty",
					"product_not_available_in_your_country": "* Tento produkt není dostupný pro váš domácí trh, ale bude fungovat v jiných zemích."
				},
				"product_description": {
					"product_attributes": {
						"installed": {
							"text": "Instalováno"
						},
						"in_progress": {
							"text": "Probíhá"
						}
					}
				},
				"phone_collection_block": {
					"title": "Máte potíže s integrací Klarny?",
					"description": "Zanechte níže své telefonní číslo a některý z našich zástupců vám zavolá, aby vám pomohl přidat Klarnu do vašeho elektronického obchodu.",
					"success_banner": "Děkujeme! Náš tým se vám co nejdříve ozve.",
					"submit": "Odeslat",
					"fields": {
						"phone": {
							"label": "Telefonní číslo",
							"tooltip": "Je třeba uvést předvolbu země, např. +1 541 754 3010.",
							"errors": {
								"required": "Telefonní číslo je povinný údaj.",
								"invalid": "Neplatné telefonní číslo"
							}
						}
					}
				}
			},
			"containers": {
				"applicant": {
					"title": {
						"unmanaged": "Kdo podepisuje smlouvy za vaši společnost?",
						"managed": "Kdo podepisuje smlouvy za společnost?",
						"recollection": "Kdo je oprávněn podepisovat jménem vaší firmy?"
					},
					"subtitle": {
						"unmanaged": "Vaše společnost se chystá uzavřít smlouvu se společností Klarna. Musíme ověřit, kdo je legálně oprávněn podepisovat smlouvy.",
						"managed": "Uveďte prosím informace o všech oprávněných osobách s podpisovými právy společnosti, kteří smlouvu uzavírají. Ze zákona jsme povinni potvrdit podpisová práva těchto zástupců. Pokud nikdo ze seznamu smlouvu nepodepsal, klikněte na tlačítko „Přidat osobu“ a zadejte požadované informace.",
						"recollection": "Vzhledem k tomu, že vaše firma má aktivní smlouvu se společností Klarna, jsme ze zákona povinni shromažďovat a ověřovat informace o všech vašich zákonných zástupcích."
					},
					"form_title": "Zadejte prosím informace.",
					"robot_message": {
						"unmanaged": "Obvykle se jedná o členy představenstva nebo vedoucí pracovníky, jako je generální ředitel, finanční ředitel nebo provozní ředitel. Uvedení dvou nebo více osob může urychlit schválení smlouvy.",
						"managed": "Obvykle se jedná o členy představenstva nebo vedoucí pracovníky, jako je generální ředitel, finanční ředitel nebo provozní ředitel. Uvedení dvou nebo více osob může urychlit schválení smlouvy."
					},
					"error_tooltip": {
						"too_young": "Tato osoba nemůže žádost podat, protože ještě nedosáhla věku {minAge} let."
					},
					"alert_all_too_young": "Všechny osoby uzavírající smlouvu musí být starší {minAge} let. Chcete-li pokračovat, přidejte a vyberte žadatele staršího {minAge} let.",
					"buttons": {
						"next": "Další",
						"back": "Zpět",
						"add_person": "+ Přidat osobu"
					},
					"role": {
						"recollection": "Zákonný zástupce"
					}
				},
				"application_summary": {
					"title": "Zkontrolujte a odešlete žádost.",
					"subtitle": {
						"unmanaged": "Před odesláním se podívejte na své údaje.",
						"managed": "Před odesláním se podívejte na podrobnosti."
					},
					"stakeholders": {
						"title": "Řízení společnosti",
						"subtitle": "Zainteresovaná strana {index}"
					},
					"businessDetailsCard": {
						"title": "Podrobnosti o firmě"
					},
					"businessDetailsCardFields": {
						"companyName": "Název společnosti",
						"organizationEntityType": "Klasifikace daně",
						"organizationRegistrationAuthority": "Soud registrace",
						"goodsCategory": "Kategorie zboží",
						"registrationId": {
							"default": "Evidenční číslo",
							"AT": "Evidenční číslo",
							"AU": "ACN",
							"CA": "Číslo firmy",
							"ES": "NIF/NIE/DNI společnosti",
							"GB": "Číslo organizace",
							"GR": "Číslo G.E.MI. (Γ.Ε.ΜΗ.)",
							"NZ": "Číslo firmy",
							"US": "Identifikační číslo zaměstnance"
						},
						"registered": {
							"default": "Registrovaná společnost",
							"AU": "Společnost má ACN"
						},
						"subjectToVat": {
							"default": "Společnost je plátcem DPH",
							"AU": "Společnost podléhá ABN"
						},
						"vatId": {
							"default": "Daňové identifikační číslo",
							"AU": "ABN",
							"NZ": "Číslo GST",
							"ES": "NIF/NIE/DNI společnosti"
						},
						"storeName": "Název obchodu",
						"storeName_us": "Název značky / DBA",
						"website": "Webová stránka",
						"email": "E-mail na zákaznickou podporu",
						"entityType": "Typ entity"
					},
					"companyRegistrationAddressCard": {
						"title": "Adresa registrace firmy"
					},
					"companyAddressCard": {
						"title": "Adresa společnosti"
					},
					"operatingAddressCard": {
						"title": "Provozní adresa společnosti"
					},
					"documentsCard": {
						"title": "Nahrané doklady"
					},
					"buttons": {
						"edit": "Upravit",
						"back": "Zpět",
						"submit": "Odeslat"
					},
					"noTermsAccepted": "Přečtěte si prosím smluvní podmínky a přijměte je.",
					"noTermsAcceptedWithPricingAnnex": "Přečtěte si prosím smlouvu s obchodníkem a cenové podmínky a přijměte je."
				},
				"artificial_ultimate_beneficial_owner": {
					"title": {
						"default": "Kdo řídí společnost?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Shromažďování těchto informací nám ukládá směrnice EU ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") o boji proti praní špinavých peněz."
							}
						],
						"US": [
							{
								"text": "Jako finanční instituce jsme ze zákona povinni tyto informace shromažďovat."
							}
						],
						"CA": [
							{
								"text": "Jako finanční instituce jsme ze zákona povinni tyto informace shromažďovat."
							}
						],
						"AU": [
							{
								"text": "Jako finanční instituce jsme ze zákona povinni tyto informace shromažďovat."
							}
						]
					},
					"infobox": {
						"default": "Zadejte prosím osobní údaje a adresu bydliště generálního ředitele společnosti.",
						"US": "Zadejte prosím osobní údaje a adresu bydliště většinového vlastníka nebo vysoce postaveného manažera, jako je generální ředitel, finanční ředitel nebo provozní ředitel.",
						"CA": "Zadejte prosím osobní údaje a adresu bydliště většinového vlastníka nebo vysoce postaveného manažera, jako je generální ředitel, finanční ředitel nebo provozní ředitel."
					},
					"buttons": {
						"next": "Další",
						"back": "Zpět"
					}
				},
				"managed_artificial_ultimate_beneficial_owner": {
					"title": "Je tato firma veřejnou společností nebo je ve výhradním vlastnictví veřejné společnosti?",
					"title_stakeholder": "Kdo řídí společnost?",
					"subtitle": "Jako finanční instituce jsme ze zákona povinni tyto informace shromažďovat.",
					"subtitle_stakeholder": "Zadejte prosím osobní údaje a adresu bydliště generálního ředitele společnosti.",
					"buttons": {
						"next": "Další",
						"back": "Zpět"
					}
				},
				"bank_account": {
					"title": {
						"default": "Jaké jsou podrobnosti o vašem bankovním účtu?"
					},
					"subtitle": {
						"US": "Na tento bankovní účet se budou převádět transakce Klarna.",
						"default": "Tyto údaje o bankovním účtu použijeme k převodu plateb z vašich prodejů."
					},
					"no_more_bank_accounts": "Již jste přidali bankovní účty pro všechny podporované měny. Skvělá práce.",
					"robot_message_general": "Výchozí bankovní účet musí být veden u banky v zemi, kde je společnost registrována. Budete také muset přidat bankovní účet pro každou měnu, kterou plánujete přijímat.",
					"robot_message": "IBAN je zkratka pro mezinárodní číslo bankovního účtu, které poskytuje vaše banka pro váš účet. Příklad: GB98 MIDL 0700 9312 3456 78",
					"robot_message_account_number": {
						"AU": "Číslo účtu poskytuje vaše banka a má 6 až 10 číslic. Příklad: 12345678",
						"US": "Číslo účtu poskytuje vaše banka a má 5 až 17 číslic. Příklad: 12345678",
						"GB": "Číslo účtu poskytuje vaše banka a má 8 číslic. Například: 12345678. Některé banky ve Velké Británii nabízejí kratší čísla účtů (tj. 7 číslic). V takovém případě se na začátek vašeho čísla přidají nuly, aby jeho délka dosáhla 8."
					},
					"robot_message_revolut": "Na IBAN, který jste zadali, nelze přijímat tuzemské platby v GBP. Musíte se obrátit na svou banku a vyžádat si údaje o účtu, který podporuje vnitrostátní převody v GBP.",
					"robot_message_local": "IBAN, který jste zadali, je místní IBAN vaší banky, který nepodporujeme. Musíte se obrátit na svou banku a vyžádat si svůj osobní IBAN nebo použít jiný účet pro připojení ke Klarně.",
					"buttons": {
						"add_bank_account": "Přidat bankovní účet",
						"skip": "Prozatím přeskočit",
						"remove": "Odebrat",
						"submit": "Odeslat",
						"next": "Další",
						"back": "Zpět"
					},
					"fields": {
						"currency_code": {
							"label": "Měna",
							"disable_reason": {
								"account_in_merchant_currency_required": "Výchozí měna je {currency}, protože vaše společnost je registrována v této měně."
							},
							"errors": {
								"general": "Vyberte prosím měnu"
							}
						},
						"country_of_bankaccount": {
							"label": "Země",
							"errors": {
								"general": "Vyberte prosím zemi"
							}
						},
						"iban_account_number": {
							"label": "Číslo účtu (IBAN)",
							"errors": {
								"general": "Zadejte prosím číslo bankovního účtu (IBAN)"
							}
						},
						"use_as_default_bank_account": {
							"label": "Použijte tento účet pro nespecifikované měny",
							"tooltip": "Objednávky s měnami, které nejsou uvedeny na této stránce, budou vyplaceny na tento účet. Za některé měny může vaše banka účtovat dodatečný poplatek."
						},
						"local_account_number": {
							"label": {
								"default": "Číslo účtu",
								"MX": "Číslo CLABE"
							},
							"errors": {
								"general": {
									"default": "Zadejte prosím číslo bankovního účtu",
									"MX": "Zadejte prosím platné číslo CLABE"
								}
							}
						},
						"account_holder": {
							"label": "Jméno vlastníka účtu",
							"errors": {
								"general": "Zadejte prosím jméno držitele účtu (maximálně 70 znaků)."
							}
						},
						"transit_number": {
							"label": "Tranzitní číslo",
							"errors": {
								"general": "Zadejte prosím platné tranzitní číslo"
							}
						},
						"institution_number": {
							"label": "Číslo instituce",
							"errors": {
								"general": "Zadejte prosím platné číslo instituce"
							}
						},
						"bic": {
							"label": {
								"AU": "BSB"
							},
							"errors": {
								"general": {
									"AU": "Zadejte prosím platný kód BSB (bankovní pobočka státu)"
								}
							},
							"tooltip": {
								"AU": "Kód BSB by měl mít 6 číslic rozdělených znakem -. Příklad: 123-456"
							}
						},
						"routing_number": {
							"label": {
								"default": "Směrové číslo",
								"GB": "Kód třídění"
							},
							"errors": {
								"general": {
									"default": "Uveďte prosím platné směrové číslo",
									"GB": "Zadejte prosím platný kód třídění"
								}
							}
						}
					}
				},
				"control_over_management": {
					"title": {
						"default": "Kdo řídí společnost?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Shromažďování těchto informací nám ukládá směrnice EU ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") o boji proti praní špinavých peněz."
							}
						],
						"GB": [
							{
								"text": "Máme ze zákona povinnost tyto informace shromažďovat. Ujistěte se prosím, že váš záznam ve společnosti Companies House je aktuální."
							}
						]
					},
					"infobox": "Zadejte prosím osobní údaje a adresu bydliště osob, které vykonávají kontrolu nad řízením vaší společnosti, například generálního ředitele nebo členů představenstva.",
					"buttons": {
						"next": "Další",
						"back": "Zpět",
						"add_person": "+ Přidat osobu"
					},
					"messages": {
						"lookup": "Řídí tito lidé vaši společnost? Podívejte se prosím a potvrďte, zda je to správně."
					}
				},
				"de_registration_information": {
					"title": {
						"unmanaged": "Je vaše firma registrovanou společností?",
						"managed": "Je tato firma registrovanou společností?"
					},
					"subtitle": {
						"unmanaged": "K ověření vašich obchodních údajů potřebujeme vaše registrační číslo společnosti.",
						"managed": "K ověření obchodních údajů firmy potřebujeme vaše registrační číslo společnosti."
					},
					"question": {
						"title": {
							"unmanaged": "Zadejte prosím své evidenční číslo a soud registrace",
							"managed": "Zadejte prosím evidenční číslo a soud registrace"
						}
					},
					"fields": {
						"registration_number": {
							"label": "Evidenční číslo"
						},
						"registration_court": {
							"label": "Soud registrace",
							"errors": {
								"general": {
									"unmanaged": "Vyberte prosím soud registrace",
									"managed": "Vyberte prosím soud registrace"
								}
							}
						}
					},
					"buttons": {
						"next": "Další",
						"back": "Zpět"
					}
				},
				"documents": {
					"title": "Nahrajte doklady",
					"subtitle": "Požadujeme, abyste nám zaslali několik dalších dokladů, které potřebujeme k ověření vaší totožnosti. Nahrávejte pouze soubory <strong>JPG</strong>, <strong>PNG</strong> nebo <strong>PDF</strong> (maximální velikost souboru 10 MB).",
					"subheadline": {
						"default": "Jelikož je Klarna bankou se sídlem ve Švédsku, a tudíž podléhá kontrole švédského úřadu pro finanční dohled, musí dodržovat směrnici EU 2015/849. Abyste mohli začít využívat služby společnosti Klarna, musí společnost Klarna shromažďovat informace o osobách, které ji ovládají. Nahrávejte prosím pouze soubory ve formátu <strong>JPG, PNG nebo PDF</strong> (maximální velikost souboru 10 MB).",
						"US": "Vzhledem k tomu, že Klarna je bankou se sídlem ve Švédsku, a podléhá tedy kontrole švédského úřadu pro finanční dohled, musí dodržovat směrnici EU 2015/849. Společnost Klarna je povinna shromažďovat informace o osobách, které ji ovládají, abyste mohli začít využívat její služby. Poskytněte nám prosím následující dokumenty, abychom mohli ověřit vaši totožnost. Nahrávejte pouze soubory JPG, PNG nebo PDF (maximální velikost souboru 10 MB).",
						"IT": "Vzhledem k tomu, že Klarna je bankou se sídlem ve Švédsku, a podléhá tedy kontrole švédského úřadu pro finanční dohled, musí dodržovat směrnici EU 2015/849. Klarna potřebuje shromáždit informace o osobách, které společnost řídí, abyste mohli začít využívat její služby. Vezměte prosím na vědomí, že pro podání žádosti musí být vaše společnost registrována u obchodní komory. Nahrávejte jen soubory ve formátu JPG, PNG nebo PDF (max. velikost souboru je 10 MB)."
					},
					"header_title": "Dokumenty",
					"stakeholder": "Zainteresovaná strana",
					"business_documents": "Obchodní dokumenty",
					"browse_files": "Procházet soubory",
					"optional": "(volitelné)",
					"upload_area": {
						"title": {
							"before_link": "Sem přetáhněte soubory nebo",
							"link_text": "Vyberte soubory"
						},
						"description": "{acceptedFileFormats} - maximálně {maxFileSizeMB} MB/soubor"
					},
					"description": {
						"APPROVAL": "Nahrát <strong>schválení</strong>",
						"CONTRACT": "Nahrát <strong>smlouvu</strong>",
						"CORRECTION_NOTE": "Nahrát <strong>opravnou poznámku</strong>",
						"COUNTERSIGNED_CONTRACT": "Nahrát <strong>kontrasignovanou smlouvu</strong>",
						"ID_DOCUMENT": "Nahrát <strong>občanský průkaz</strong> nebo <strong>pas</strong>",
						"LICENSE": "Nahrát <strong>licenci</strong>",
						"PROOF_OF_ADDRESS": "Nahrát <strong>doklad s adresou</strong>",
						"SPECIAL_AGREEMENT": "Nahrát <strong>speciální smlouvu</strong>",
						"SUPPORTING_DOCUMENT": "Nahrát <strong>podpůrný doklad</strong>",
						"TAX_OFFICE_REGISTRATION": "Nahrát <strong>registraci daňového úřadu</strong>"
					},
					"explanation": {
						"APPROVAL": {
							"title": {
								"default": "Schválení"
							},
							"subtitle": {
								"default": null
							}
						},
						"CONTRACT": {
							"title": {
								"default": "Smlouva"
							},
							"subtitle": {
								"default": null
							}
						},
						"CORRECTION_NOTE": {
							"title": {
								"default": "Opravná položka"
							},
							"subtitle": {
								"default": null
							}
						},
						"COUNTERSIGNED_CONTRACT": {
							"title": {
								"default": "Kontrasignovaná smlouva"
							},
							"subtitle": {
								"default": null
							}
						},
						"ID_DOCUMENT": {
							"title": {
								"default": "Doklad totožnosti",
								"IT": "Průkaz totožnosti"
							},
							"subtitle": {
								"default": "Uveďte prosím obě strany průkazu totožnosti.",
								"AT": "Poskytněte nám prosím obě strany svého průkazu totožnosti. Pokud vaše adresa není uvedena v průkazu totožnosti, budeme k jejímu ověření potřebovat další dokumenty, například účet za služby.",
								"AU": "Abychom mohli rychleji posoudit vaši žádost, předložte prosím platnou kopii průkazu totožnosti s fotografií, například cestovní pas nebo australský řidičský průkaz, pro následující osoby spojené s podnikem: Jediný podnikatel/společnost s ručením omezeným – majitel/é. Společnost – zákonný zástupce, všichni členové představenstva a každý akcionář, který vlastní více než 25 % akcií.",
								"BE": "Poskytněte prosím obě strany průkazu totožnosti, ujistěte se, že kvalita obrazu je dostatečná a že všechny údaje jsou jasně čitelné.",
								"DE": "Poskytněte nám prosím obě strany svého průkazu totožnosti. Pokud vaše adresa není uvedena v průkazu totožnosti, budeme k jejímu ověření potřebovat další dokumenty, například účet za služby.",
								"FR": "Poskytněte prosím obě strany průkazu totožnosti, ujistěte se, že kvalita obrazu je dostatečná a že všechny údaje jsou jasně čitelné.",
								"GB": "Předložte prosím průkaz totožnosti, pokud se jedná o občanský průkaz, a to z obou stran.",
								"IT": "Platný průkaz totožnosti pro každou z osob uvedených v žádosti. Nelze akceptovat řidičský průkaz, cestovní pas ani kartu/číslo sociálního pojištění.",
								"NL": "Poskytněte prosím obě strany průkazu totožnosti, ujistěte se, že kvalita obrazu je dostatečná a že všechny údaje jsou jasně čitelné.",
								"US": "Řidičský průkaz nebo cestovní pas - předložte prosím obě strany průkazu totožnosti."
							}
						},
						"LICENSE": {
							"title": {
								"default": "Licence"
							},
							"subtitle": {
								"default": null
							}
						},
						"PROOF_OF_ADDRESS": {
							"title": {
								"default": "Doklad o bydlišti",
								"BE": "Doklad o bydlišti",
								"CZ": "Doklad o bydlišti",
								"ES": "Doklad o bydlišti",
								"FI": "Doklad o bydlišti",
								"FR": "Doklad o bydlišti",
								"GR": "Doklad o bydlišti",
								"IT": "Doklad o bydlišti",
								"NL": "Doklad o bydlišti",
								"PL": "Doklad o bydlišti",
								"PT": "Doklad o bydlišti"
							},
							"subtitle": {
								"default": "Jako doklad o adrese bydliště (ne starší než 3 měsíce) přijímáme následující doklady: Účty za elektřinu, vodu, plyn, Wi-Fi, daňové přiznání nebo nájemní smlouva. Pokud žádný z těchto dokumentů nemáte, nahrajte prosím jakýkoli jiný doklad o bydlišti a přidejte poznámku s uvedením důvodu.",
								"AU": "Abychom vaši žádost mohli rychleji posoudit, předložte prosím jeden z následujících dokladů z posledních 90 dnů k ověření adresy bydliště: Účet za komunální služby, účet za internet, daňové přiznání nebo nájemní smlouva. *Pokud jako doklad totožnosti předkládáte cestovní pas nebo pokud se vaše současná adresa neshoduje s adresou na předloženém dokladu totožnosti, je tento krok povinný.",
								"BE": "Jako doklad o adrese bydliště přijímáme následující dokumenty, které nejsou starší než 3 měsíce: Smlouva o odběru elektřiny, vody, plynu, daňové přiznání nebo nájemní smlouva. Pokud žádný z těchto dokladů nemáte, nahrajte prosím jakýkoli jiný doklad o bydlišti a připojte poznámku s uvedením důvodu.",
								"FR": "Jako doklad o adrese bydliště přijímáme následující dokumenty, které nejsou starší než 3 měsíce: Smlouva o odběru elektřiny, vody, plynu, daňové přiznání nebo nájemní smlouva. Pokud žádný z těchto dokladů nemáte, nahrajte prosím jakýkoli jiný doklad o bydlišti a připojte poznámku s uvedením důvodu.",
								"NL": "Jako doklad o adrese bydliště přijímáme následující dokumenty, které nejsou starší než 3 měsíce: Smlouva o odběru elektřiny, vody, plynu, daňové přiznání nebo nájemní smlouva. Pokud žádný z těchto dokladů nemáte, nahrajte prosím jakýkoli jiný doklad o bydlišti a připojte poznámku s uvedením důvodu.",
								"US": "Přijímáme účty za služby (plyn, voda, internet, telefon atd.), nájemní smlouvu nebo hypotéku s dokladem o adrese – nesmí být starší než 90 dní od data podání žádosti.",
								"IT": "Pokud je ve vašem průkazu totožnosti uvedena jiná adresa než adresa vašeho současného bydliště, budeme potřebovat další doklad k ověření vašeho současného bydliště. Jako doklad o adrese pobytu osob uvedených v žádosti přijímáme následující dokumenty ne starší než 3 měsíce:"
							},
							"list": {
								"IT": [
									{
										"text": "Potvrzení o pobytu vydané online (prostřednictvím SPID) nebo obcí v místě vašeho bydliště."
									},
									{
										"text": "Účty za elektřinu/vodu/plyn/Wi-fi"
									},
									{
										"text": "nájemní smlouva"
									}
								]
							}
						},
						"SPECIAL_AGREEMENT": {
							"title": {
								"default": "Speciální smlouva"
							},
							"subtitle": {
								"default": null
							}
						},
						"SUPPORTING_DOCUMENT": {
							"title": {
								"default": "Podpůrný dokument",
								"GB": "Autoportrét"
							},
							"subtitle": {
								"default": null,
								"AU": "Pokud prodáváte značkové zboží vysoké hodnoty, uveďte zde 2–3 dodavatelské faktury k těmto výrobkům. Dbejte prosím na to, aby na faktuře byly uvedeny zakoupené produkty, název dodavatele, jméno příjemce a dodací adresa.",
								"GB": "Přiložte prosím fotografii s autoportrétem, na které držíte průkaz totožnosti."
							}
						},
						"TAX_OFFICE_REGISTRATION": {
							"title": {
								"default": "Doklad o registraci u finančního úřadu",
								"AT": "Doklad o registraci u daňového úřadu",
								"AU": "Svěřenecká smlouva",
								"BE": "Číslo DPH povolené pro přeshraniční transakce (VIES).",
								"DE": "Doklad o registraci u daňového úřadu",
								"FR": "Číslo DPH povolené pro přeshraniční transakce (VIES).",
								"IT": "Číslo DPH povolené pro přeshraniční transakce (VIES).",
								"NL": "Číslo DPH povolené pro přeshraniční transakce (VIES).",
								"NO": "Registrace daňového úřadu",
								"US": "Dopis o EIN"
							},
							"subtitle": {
								"default": null,
								"AT": "Jako obchodní doklady přijímáme následující dokumenty: Výpis z obchodního rejstříku / živnostenské oprávnění",
								"AU": "Pokud je vaše ABN spojeno se svěřenským fondem, předložte kopii svěřenského dokumentu, včetně rozpisu svěřenského fondu. Upozorňujeme, že tento krok je pro svěřenské fondy povinný.",
								"BE": "Zkontrolujte, zda je vaše DIČ povoleno pro přeshraniční transakce. To je nutné i v případě, že obchodujete pouze ve své zemi, protože Klarna je zahraniční subjekt. https://ec.europa.eu/taxation_customs/vies/#/vat-validation . Můžete se obrátit na místní finanční úřad a požádat o bezplatnou aktivaci svého DIČ v systému VIES.",
								"CZ": "Jako obchodní dokumenty přijímáme následující dokumenty: Potvrzení o zápisu do obchodního rejstříku nebo výpis z rejstříku živnostenského podnikání",
								"DE": "Jako obchodní doklady přijímáme následující dokumenty: Výpis z obchodního rejstříku / živnostenské oprávnění",
								"ES": "Jako obchodní dokumenty přijímáme následující dokumenty: pro registrované podniky - Osvědčení o sčítání lidu / vzor 036 / vzor 037.",
								"FI": "Jako obchodní doklady přijímáme následující dokumenty: Zakladatelské listiny pro živnostníky – Osvědčení o sčítání lidu / vzor 036 / vzor 037",
								"FR": "Zkontrolujte, zda je vaše DIČ povoleno pro přeshraniční transakce. To je nutné i v případě, že obchodujete pouze ve své zemi, protože Klarna je zahraniční subjekt. https://ec.europa.eu/taxation_customs/vies/#/vat-validation . Můžete se obrátit na místní finanční úřad a požádat o bezplatnou aktivaci svého DIČ v systému VIES.",
								"GR": "Jako obchodní doklady přijímáme následující dokumenty: Registrace na finančním úřadě / Zahájení podnikání / Obchodní rejstřík Doklad vydaný příslušnou službou GEMI (Ústřední svaz komor)",
								"IT": "Můžete se obrátit na daňový úřad (Agenzia delle Entrate) a požádat o bezplatnou aktivaci čísla DPH VIES. To je nutné i v případě, že obchodujete pouze v Itálii, protože Klarna je zahraniční subjekt.",
								"NL": "Zkontrolujte, zda je vaše DIČ povoleno pro přeshraniční transakce. To je nutné i v případě, že obchodujete pouze ve své zemi, protože Klarna je zahraniční subjekt. https://ec.europa.eu/taxation_customs/vies/#/vat-validation . Můžete se obrátit na místní finanční úřad a požádat o bezplatnou aktivaci svého DIČ v systému VIES.",
								"NO": "Jako obchodní doklady přijímáme následující dokumenty: Firemní dokumenty",
								"PL": "Jako obchodní doklady přijímáme následující dokumenty: Potvrzení o zápisu do obchodního rejstříku CEIDG, výpis z Národního soudního rejstříku (KRS)",
								"PT": "Jako obchodní dokumenty přijímáme následující dokumenty:  Certidão Permanente (povinné), Osvědčení o registraci. U živnostníků registrace samostatné výdělečné činnosti (Declaração de Início de Atividade).",
								"US": "Jedná se o dopis, který jste obdrželi od finančního úřadu a který vám přidělil EIN (IRS CP575 EIN Letter). Pokud je vaše firma ve vašem výhradním vlastnictví a podáváte žádost se svým SSN, předložte místo toho kopii karty SSN."
							},
							"link": {
								"BE": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"FR": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"NL": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"GR": "https://www.businessregistry.gr/publicity/index"
							}
						},
						"CERTIFIED_ID": {
							"title": {
								"default": "Ověřený doklad totožnosti"
							},
							"subtitle": {
								"default": "Přijímáme následující doklady: Občanský průkaz, cestovní pas, řidičský průkaz. Doklady musí splňovat následující kritéria:"
							},
							"list": [
								{
									"text": "Ověřeno oprávněným ověřovatelem (např. notářem, přísežným komisařem, právníkem, advokátem a/nebo certifikovaným účetním)."
								},
								{
									"text": "Podepsáno a orazítkováno. Na razítku musí být uvedeny viditelné a ověřitelné údaje o ověřovateli, jako je celé jméno, adresa a případně registrační číslo."
								},
								{
									"text": "Opatřeno datem – datum certifikace ne starší než 6 měsíců."
								},
								{
									"text": "Ověřeno jako věrná kopie originálu s jasným uvedením, že byl předložen originál dokladu."
								}
							]
						}
					},
					"modal": {
						"title": "Proč vaše doklady potřebujeme?",
						"close": "Zavřít",
						"content": [
							{
								"title": "Popis procesu",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							},
							{
								"title": "Požadavky na soubory",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							},
							{
								"title": "Jak naskenovat doklady?",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							}
						]
					},
					"errors": {
						"general": "Nahrání se nezdařilo",
						"too_large_file": "Soubor je příliš velký <strong>(max {maxFileSizeMB} MB)</strong>",
						"max_num_files_exceeded": "Můžete nahrát pouze následující počet souborů: {number}.",
						"invalid_file_format": "Neplatný formát souboru. Jediné akceptované typy souborů jsou {acceptedFileFormats}",
						"duplicate_file_name": "Duplicitní název souboru. Všechny nahrané soubory musí mít jedinečné názvy.",
						"try_again": "Zkuste to znovu nebo <u>vyberte jiný soubor</u>"
					},
					"buttons": {
						"modal": "Proč vaše doklady potřebujeme?",
						"next": "Další",
						"back": "Zpět",
						"submit": "Odeslat dokumenty"
					}
				},
				"document_upload_success": {
					"title": "Nahrávání dokončeno",
					"message": "Děkujeme! Vaše doklady byly úspěšně nahrány."
				},
				"forced_registration_information": {
					"title": {
						"unmanaged": {
							"default": "Můžete prosím zadat své registrační číslo?",
							"AT": "Můžete prosím zadat své registrační číslo?",
							"CA": "Můžete prosím zadat svůj federální BN?",
							"GR": "Můžete prosím zadat své číslo G.E.MI. (Γ.Ε.ΜΗ.)?",
							"NZ": "Můžete prosím zadat číslo vaší firmy?"
						},
						"managed": {
							"default": "Můžete prosím zadat registrační číslo společnosti?",
							"AT": "Můžete prosím zadat registrační číslo společnosti?",
							"CA": "Můžete prosím zadat svůj federální BN?",
							"GR": "Můžete prosím uvést číslo G.E.MI. (Γ.Ε.ΜΗ.) společnosti?",
							"NZ": "Můžete prosím zadat obchodní číslo společnosti?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "K ověření vašich obchodních údajů potřebujeme vaše registrační číslo společnosti.",
							"AT": "K ověření vašich obchodních údajů potřebujeme vaše registrační číslo společnosti.",
							"CA": "K ověření vašich obchodních údajů potřebujeme vaše federální obchodní číslo, které vaší společnosti přidělila kanadská daňová agentura (CRA).",
							"GR": "Vaše číslo G.E.MI potřebujeme k ověření obchodních údajů.",
							"NZ": "K ověření obchodních údajů potřebujeme vaše firemní číslo."
						},
						"managed": {
							"default": "K ověření obchodních údajů firmy potřebujeme vaše registrační číslo společnosti.",
							"AT": "K ověření obchodních údajů firmy potřebujeme vaše registrační číslo společnosti.",
							"CA": "K ověření vašich obchodních údajů potřebujeme vaše federální obchodní číslo, které vaší společnosti přidělila kanadská daňová agentura (CRA).",
							"GR": "Vaše číslo G.E.MI potřebujeme k ověření obchodních údajů.",
							"NZ": "K ověření obchodních údajů potřebujeme vaše firemní číslo."
						}
					},
					"infobox": {
						"unmanaged": {
							"CA": "Vezměte prosím na vědomí, že Klarna v současné době nemůže poskytovat své platební služby pro kanadské živnostníky. Pokračování v žádosti povede k jejímu zamítnutí."
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Registrační číslo",
								"AT": "Registrační číslo",
								"CA": "Číslo firmy",
								"GR": "Číslo G.E.MI. (Γ.Ε.ΜΗ.)",
								"NZ": "Číslo firmy"
							}
						}
					},
					"buttons": {
						"next": "Další",
						"back": "Zpět"
					}
				},
				"tax_identification_number": {
					"title": {
						"unmanaged": "Jaká je vaše daňová klasifikace?",
						"managed": "Můžete prosím zadat daňovou klasifikaci společnosti?"
					},
					"subtitle": {
						"unmanaged": "V závislosti na právním statusu společnosti vás požádáme o různé informace.",
						"managed": "V závislosti na právním statusu společnosti vás požádáme o různé informace."
					},
					"info": {
						"unmanaged": "Identifikační číslo zaměstnavatele (EIN) pro vaši firmu najdete v daňových přiznáních, úvěrových zprávách, mzdových dokumentech nebo licencích a povoleních.",
						"managed": "Identifikační číslo zaměstnavatele (EIN) pro vaši společnost najdete v daňových přiznáních, úvěrových zprávách, mzdových dokladech nebo licencích a povoleních."
					},
					"fields": {
						"registration_number": {
							"label": "Identifikační číslo zaměstnance",
							"errors": {
								"general": "Zadejte platné identifikační číslo zaměstnavatele",
								"invalid": "Identifikační číslo zaměstnavatele by mělo mít 9 číslic a za prvními dvěma číslicemi by měl být znak „-“. Příklad: 12-3456789"
							}
						},
						"organization_entity": {
							"label": {
								"unmanaged": "Klasifikace federální daně",
								"managed": "Typ podnikání"
							},
							"errors": {
								"is_one_of": "Vyberte si prosím jeden z uvedených typů podnikání"
							}
						}
					},
					"buttons": {
						"next": "Další",
						"back": "Zpět"
					}
				},
				"forced_vat_registration": {
					"title": {
						"unmanaged": {
							"default": "Můžete prosím zadat své daňové identifikační číslo?",
							"AU": "Můžete prosím zadat své číslo ABN?",
							"ES": "Jaké je vaše daňové identifikační číslo?",
							"NZ": "Můžete prosím zadat své číslo GST?"
						},
						"managed": {
							"default": "Můžete prosím zadat daňové identifikační číslo?",
							"AU": "Můžete prosím zadat ABN?",
							"ES": "Jaké je vaše daňové identifikační číslo?",
							"NZ": "Můžete prosím zadat číslo GST?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Díky vašemu DIČ můžeme snadněji ověřit údaje o vaší společnosti.",
							"AU": "Díky vašemu ABN můžeme snadněji ověřit údaje o vaší společnosti.",
							"NZ": "Díky vašemu číslu GST můžeme snadněji ověřit údaje o vaší společnosti.",
							"ES": "Díky vašemu číslu NIF, NIE nebo DNI můžeme snadněji ověřit údaje o vaší společnosti."
						},
						"managed": {
							"default": "DIČ používáme k ověření údajů o společnosti.",
							"AU": "ABN používáme k ověření údajů o společnosti.",
							"NZ": "Číslo GST používáme k ověření údajů o společnosti.",
							"ES": "Číslo NIF, NIE nebo DNI používáme k ověření údajů o společnosti."
						}
					},
					"fields": {
						"vat_number": {
							"label": {
								"default": "Daňové identifikační číslo",
								"AU": "ABN",
								"NZ": "Číslo GST",
								"ES": "NIF/NIE/DNI"
							}
						}
					},
					"buttons": {
						"next": "Další",
						"back": "Zpět"
					}
				},
				"legal_entity_type": {
					"title": {
						"unmanaged": "Jaký typ podnikání máte?",
						"managed": "Jakým typem podnikání se zabývá tato společnost?"
					},
					"subtitle": {
						"unmanaged": "Na základě typu vašeho podnikání jsme povinni položit několik specifických otázek.",
						"managed": "Na základě typu podnikání jsme povinni položit několik specifických otázek."
					},
					"fields": {
						"legal_entity_type": {
							"label": "Typ právního subjektu",
							"errors": {
								"is_one_of": "Vyberte si prosím jeden z uvedených typů podnikání"
							}
						}
					},
					"buttons": {
						"next": "Další",
						"back": "Zpět"
					}
				},
				"optional_registration_information": {
					"title": {
						"unmanaged": {
							"default": "Je vaše firma registrovanou společností?",
							"AU": "Má vaše firma ACN?",
							"ES": "Je vaše společnost zapsána v Registro Mercantil?"
						},
						"managed": {
							"default": "Je tato firma registrovanou společností?",
							"AU": "Má tato firma ACN?",
							"ES": "Je vaše společnost zapsána v Registro Mercantil?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "K ověření vašich obchodních údajů potřebujeme vaše registrační číslo společnosti.",
							"AT": "K ověření vašich obchodních údajů potřebujeme vaše registrační číslo společnosti.",
							"AU": "Pokud máte ACN, zadejte ho, jinak vyberte ne a pokračujte dále.",
							"ES": "Odpovězte Ano, pokud jste SL, SA, SCP, ...atd. Odpovězte Ne, pokud jste OSVČ, ...atd.",
							"GB": "K ověření vašich obchodních údajů potřebujeme vaše organizační číslo společnosti.",
							"GR": "Vaše číslo G.E.MI potřebujeme k ověření obchodních údajů."
						},
						"managed": {
							"default": "K ověření obchodních údajů firmy potřebujeme vaše registrační číslo společnosti.",
							"AT": "K ověření obchodních údajů firmy potřebujeme vaše registrační číslo společnosti.",
							"AU": "Pokud má tato společnost ACN, zadejte ho, jinak vyberte ne a pokračujte dále.",
							"ES": "Odpovězte Ano, pokud jste SL, SA, SCP, ...atd. Odpovězte Ne, pokud jste OSVČ, ...atd.",
							"GB": "K ověření obchodních údajů firmy potřebujeme organizační číslo společnosti.",
							"GR": "Vaše firemní číslo G.E.MI potřebujeme k ověření obchodních údajů."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Zadejte prosím své registrační číslo",
							"AT": "Zadejte prosím své registrační číslo",
							"AU": "Zadejte prosím své ACN",
							"ES": "Zadejte prosím NIF/NIE/DNI společnosti",
							"GB": "Zadejte prosím číslo své organizace",
							"GR": "Zadejte prosím své číslo G.E.MI. (Γ.Ε.ΜΗ.)"
						},
						"managed": {
							"default": "Zadejte prosím registrační číslo",
							"AT": "Zadejte prosím registrační číslo",
							"AU": "Zadejte prosím ACN",
							"ES": "Zadejte prosím NIF/NIE/DNI společnosti",
							"GB": "Zadejte prosím číslo organizace",
							"GR": "Zadejte prosím číslo G.E.MI. (Γ.Ε.ΜΗ.)"
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Evidenční číslo",
								"AT": "Evidenční číslo",
								"AU": "Australské číslo společnosti (ACN)",
								"ES": "NIF/NIE/DNI společnosti",
								"GB": "Číslo organizace",
								"GR": "Číslo G.E.MI. (Γ.Ε.ΜΗ.)"
							},
							"errors": null
						}
					},
					"buttons": {
						"next": "Další",
						"back": "Zpět"
					}
				},
				"mid-selector": {
					"title": "Vyberte obchod",
					"subtitle": "Tento e-mail je spojen s více obchody. Vyberte prosím obchod, aby bylo možné pokračovat.",
					"mid-selector": "ID obchodníka / název obchodu",
					"buttons": {
						"next": "Pokračovat"
					}
				},
				"optional_registration_information_widget": {
					"title": {
						"unmanaged": "Je vaše firma registrovanou společností?",
						"managed": "Je tato firma registrovanou společností?"
					},
					"subtitle": {
						"unmanaged": {
							"default": "K ověření vašich obchodních údajů potřebujeme vaše registrační číslo společnosti.",
							"AT": "K ověření vašich obchodních údajů potřebujeme vaše registrační číslo společnosti."
						},
						"managed": {
							"default": "K ověření obchodních údajů firmy potřebujeme vaše registrační číslo společnosti.",
							"AT": "K ověření obchodních údajů firmy potřebujeme vaše registrační číslo společnosti."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Zadejte prosím své registrační číslo",
							"AT": "Zadejte prosím své registrační číslo"
						},
						"managed": {
							"default": "Zadejte prosím registrační číslo",
							"AT": "Zadejte prosím registrační číslo"
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Evidenční číslo",
								"AT": "Evidenční číslo"
							}
						}
					},
					"buttons": {
						"next": "Další",
						"back": "Zpět"
					}
				},
				"optional_vat_registration": {
					"title": {
						"unmanaged": {
							"default": "Je vaše firma registrovaným plátcem DPH?",
							"ES": "Má vaše společnost NIF/NIE/DNI?",
							"NZ": "Je vaše firma registrovaným plátcem daní za zboží a služby (GST)?"
						},
						"managed": {
							"default": "Je tato firma registrovaným plátcem DPH?",
							"ES": "Má vaše společnost NIF/NIE/DNI?",
							"NZ": "Je tato firma registrovaným plátcem daní za zboží a služby (GST)?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Pokud máte DIČ, můžeme snadněji ověřit údaje o vaší společnosti.",
							"ES": "Pokud má vaše společnost číslo NIF/NIE/DNI, můžeme snadněji ověřit údaje o vaší společnosti.",
							"NZ": "Pokud máte číslo GST, můžeme snadněji ověřit údaje o vaší společnosti."
						},
						"managed": {
							"default": "DIČ používáme k ověření údajů o společnosti.",
							"ES": "Pokud má vaše společnost číslo NIF/NIE/DNI, můžeme snadněji ověřit údaje o vaší společnosti.",
							"NZ": "Číslo GST používáme k ověření údajů o společnosti."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Zadejte prosím své daňové identifikační číslo",
							"ES": "Zadejte prosím NIF/NIE/DNI společnosti",
							"NZ": "Zadejte prosím své číslo GST"
						},
						"managed": {
							"default": "Zadejte prosím DIČ",
							"ES": "Zadejte prosím NIF/NIE/DNI společnosti",
							"NZ": "Zadejte prosím své číslo GST"
						}
					},
					"vat_id": {
						"label": {
							"default": "Daňové identifikační číslo",
							"ES": "NIF/NIE/DNI společnosti",
							"NZ": "Číslo GST"
						}
					},
					"buttons": {
						"next": "Další",
						"back": "Zpět"
					}
				},
				"optional_vat_registration_widget": {
					"title": {
						"unmanaged": "Je vaše firma registrovaným plátcem DPH?",
						"managed": "Je tato firma registrovaným plátcem DPH?"
					},
					"subtitle": {
						"unmanaged": "Pokud máte DIČ, můžeme snadněji ověřit údaje o vaší společnosti.",
						"managed": "DIČ používáme k ověření údajů o společnosti."
					},
					"form_title": {
						"unmanaged": "Zadejte prosím své daňové identifikační číslo",
						"managed": "Zadejte prosím DIČ"
					},
					"vat_id": {
						"label": {
							"default": "Daňové identifikační číslo",
							"NZ": "Číslo GST"
						}
					},
					"buttons": {
						"next": "Další",
						"back": "Zpět"
					}
				},
				"partnership_details": {
					"title": {
						"unmanaged": "Jaká je vaše obchodní adresa?",
						"managed": "Jaká je obchodní adresa společnosti?"
					},
					"subtitle": {
						"unmanaged": "Potřebujeme vědět, kde vaše firma sídlí.",
						"managed": "Potřebujeme vědět, kde firma sídlí."
					},
					"buttons": {
						"next": "Další",
						"back": "Zpět"
					},
					"fields": {
						"partnership_name": {
							"label": "Název partnerství",
							"errors": {
								"general": "Zadejte prosím název partnerství"
							}
						},
						"street": {
							"label": "Adresa",
							"errors": {
								"general": "Zadej prosím platnou adresu"
							}
						},
						"postal_code": {
							"label": "PSČ",
							"errors": {
								"general": "Zadejte prosím platné poštovní směrovací číslo"
							}
						},
						"city": {
							"label": "Město",
							"errors": {
								"general": "Zadejte prosím platné město"
							}
						},
						"country": {
							"label": "Země",
							"errors": {
								"general": "Zadejte prosím platnou zemi"
							}
						}
					}
				},
				"partners_and_principals": {
					"title": {
						"default": "Kdo společnost vlastní?",
						"GB": "Kdo řídí společnost?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Shromažďování těchto informací nám ukládá směrnice EU ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") o boji proti praní špinavých peněz."
							}
						],
						"AU": [
							{
								"text": "Jako finanční instituce jsme ze zákona povinni tyto informace shromažďovat."
							}
						]
					},
					"infobox": "Zadejte prosím osobní údaje a adresu bydliště všech společníků a ředitelů, kteří vykonávají kontrolu nad řízením vaší společnosti.",
					"buttons": {
						"add_person": "+ Přidat osobu",
						"next": "Další",
						"back": "Zpět"
					}
				},
				"payouts_summary": {
					"title": "Bankovní účty",
					"default_bank_accounts": {
						"no_elements": "Není k dispozici žádný výchozí bankovní účet"
					},
					"additional_bank_accounts": {
						"no_elements": "Neuvedli jste žádné další bankovní účty"
					}
				},
				"pre_assessment_company_details": {
					"title": "Vyplňte prosím další podrobnosti o příležitosti.",
					"subtitle": "Uveďte prosím podíl na objemu platebních karet a údaje o společnosti tohoto obchodníka. Také prosím uveďte, zda společnost působí na jiném trhu než v zemi registrace, protože to je nutné pro posouzení rizik.",
					"fields": {
						"volume_by_card": {
							"label": "Podíl objemu platebních karet na celkovém objemu (%)",
							"errors": {
								"invalid": "Objem karet by mělo být číslo mezi 0 a 100.",
								"invalid_hint": "Sečtěte prosím podíl objemu karetních transakcí z celkového objemu Klarny pro tuto příležitost. Pokud vaše příležitost nemá žádné platby kartou, zadejte prosím 0 %."
							}
						},
						"average_order_value": {
							"label": "Průměrná hodnota objednávky (v SEK)",
							"tooltip": "Měla by to být kladná částka v SEK",
							"errors": {
								"invalid": "Měla by to být kladná částka v SEK"
							}
						},
						"registration_country": {
							"label": "Země registrace",
							"errors": {
								"required": "Země registrace je povinný údaj"
							}
						},
						"operating_country": {
							"label": "Provozující země",
							"errors": {
								"required": "Provozující země je povinný údaj"
							}
						},
						"registration_number": {
							"label": {
								"default": "Registrační číslo (povinné pro registrované společnosti)",
								"AU": "ACN (povinné pro registrované společnosti)",
								"ES": "NIF/NIE/DNI společnosti (povinné pro registrované společnosti)",
								"GR": "Číslo G.E.MI. (Γ.Ε.ΜΗ.) (povinné pro registrované společnosti)",
								"NZ": "Číslo firmy (povinné pro registrované společnosti)",
								"US": "TIN/EIN (povinné pro registrované společnosti)"
							}
						},
						"vat_number": {
							"label": "ABN",
							"errors": {
								"required": "Uveďte prosím číslo ACN nebo ABN",
								"invalid": "Číslo ABN by mělo mít 11 číslic"
							}
						},
						"registration_authority": {
							"label": "Evidenční orgán",
							"errors": {
								"required": "Vyberte prosím evidenční orgán"
							}
						},
						"company_name": {
							"label": "Název právního subjektu",
							"errors": {
								"required": "Název právního subjektu je povinný údaj"
							}
						},
						"sales_contact": {
							"label": "E-mail obchodního zástupce",
							"errors": {
								"invalid": "Zadejte prosím platný e-mail"
							}
						},
						"store_url": {
							"label": "Adresa URL obchodu",
							"errors": {
								"required": "Adresa URL obchodu je povinný údaj",
								"invalid": "Zadejte prosím platnou adresu URL webu"
							}
						},
						"goods_category": {
							"label": "Hlavní kategorie prodávaného zboží",
							"errors": {
								"invalid": "Musíte vybrat jednu z možností"
							}
						},
						"is_managed": {
							"label": "Spravován po vyřízení všech náležitostí?"
						}
					},
					"buttons": {
						"next": "Další",
						"back": "Zpět"
					}
				},
				"pre_assessment_products": {
					"title": "Uveďte prosím všechny produkty",
					"subtitle": "Pro posouzení rizik jsou vyžadovány všechny výrobky podle země prodeje.",
					"select": {
						"label": "Hledat produkty"
					},
					"selected": {
						"label": "Vybrané produkty:"
					},
					"clear": "Vymazat vše",
					"errors": {
						"invalid": "Měl by být vybrán nejméně jeden produkt na zemi"
					},
					"channels": {
						"ONLINE": "Online",
						"IN_STORE": "V obchodě",
						"TELESALES": "Prodej přes internet",
						"SELLER_APP": "Aplikace pro prodejce"
					},
					"buttons": {
						"next": "Další",
						"back": "Zpět"
					}
				},
				"wrong_prefill_data": {
					"title": "Byly zadány neplatné údaje",
					"subtitle": "Neplatné nebo nekompatibilní předvyplněné údaje poskytnuté službou SalesForce.",
					"details": "Podrobnosti: ",
					"fields": {
						"goodsCategory": "Kategorie zboží",
						"paymentInterval": "Interval plateb",
						"paymentDelay": "Zpoždění platby",
						"registrationCountry": "Země registrace",
						"storeUrl": "Adresa URL obchodu",
						"mainSellingCountry": "Hlavní země prodeje",
						"products": "Produkty",
						"products_item": "Produkt {index}",
						"products_item_yearlyAcquiredVolume": "Roční objem nákupu produktu {index}",
						"products_item_sellingCountry": "Země prodeje produktu {index}",
						"products_item_productName": "Název produktu {index}",
						"products_item_channels": "Kanály produktu {index}",
						"products_item_channels_item": "Kanál produktu {index}"
					},
					"error_types": {
						"fallback": "je neplatná",
						"any": {
							"required": "je vyžadována a žádná nebyla poskytnuta"
						}
					}
				},
				"selling_countries": {
					"title": "Uveďte prosím seznam všech zemí prodeje",
					"subtitle": "Úplný seznam zemí je nutný pro posouzení rizik.",
					"select": {
						"label": "Vyhledat zemi"
					},
					"selected": {
						"label": "Vybrané země:"
					},
					"fields": {
						"selling_countries": {
							"label": "Vybrat zemi",
							"errors": {
								"invalid": "Musíte vybrat nejméně jednu zemi"
							}
						}
					},
					"clear": "Vymazat vše",
					"buttons": {
						"next": "Další",
						"back": "Zpět"
					}
				},
				"main_selling_country": {
					"title": "Jaký je hlavní trh Klarna pro obchodníka?",
					"subtitle": "Vyberte prosím trh s nejvyšším očekávaným objemem Klarna.",
					"errors": {
						"invalid": "Musíte vybrat zemi"
					},
					"buttons": {
						"next": "Další",
						"back": "Zpět"
					}
				},
				"fca_number": {
					"title": "Zadejte prosím číslo FCA",
					"subtitle": "Ze zákona jsme povinni ověřit licenci úvěrového zprostředkovatele.",
					"fields": {
						"fca_number": {
							"label": "Číslo FCA",
							"errors": {
								"general": "Zadejte platné číslo FCA"
							}
						}
					},
					"buttons": {
						"next": "Další",
						"back": "Zpět"
					}
				},
				"sole_trader": {
					"title": "Kdo společnost vlastní?",
					"subtitle": {
						"default": [
							{
								"text": "Shromažďování těchto informací nám ukládá směrnice EU ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") o boji proti praní špinavých peněz."
							}
						]
					},
					"infobox": {
						"unmanaged": "Zadejte prosím své osobní údaje a adresu bydliště.",
						"managed": "Zadejte prosím údaje o vlastníkovi a adresu bydliště."
					},
					"buttons": {
						"next": "Další",
						"back": "Zpět"
					},
					"fields": {
						"are_you_the_sole_trader": {
							"label": "Osoba, která podává žádost, je totožná s živnostníkem",
							"error": "Je nám líto, ale žádost můžete podat pouze v případě, že ji podáváte vy jako živnostník."
						}
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Působíte na jiné adrese?",
								"managed": "Působí tato společnost na jiné adrese?"
							},
							"subtitle": {
								"unmanaged": "Možnost Ano vyberte pouze v případě, že podnikáte na jiné adrese, než je adresa vašeho bydliště.",
								"managed": "Možnost Ano vyberte pouze v případě, že tato společnost provozuje svou činnost na jiné adrese, než je adresa bydliště živnostníka."
							}
						},
						"title": "Uveďte prosím adresu firmy",
						"fields": {
							"street": {
								"label": "Adresa",
								"errors": {
									"general": "Uveďte prosím platnou adresu"
								}
							},
							"postal_code": {
								"label": "PSČ",
								"errors": {
									"general": "Uveďte prosím platné PSČ"
								}
							},
							"city": {
								"label": "Město",
								"errors": {
									"general": "Uveďte prosím platné město"
								}
							},
							"country": {
								"label": "Země",
								"errors": {
									"general": "Uveďte prosím platnou zemi"
								}
							}
						}
					}
				},
				"sole_trader_confirmation": {
					"title": "Můžete prosím potvrdit ještě dvě věci?",
					"subtitle": "",
					"fields": {
						"are_you_the_sole_trader": {
							"title": "Jste živnostník",
							"label": "Osoba, která podává žádost, je totožná s živnostníkem"
						},
						"are_you_the_only_with_financial_control": {
							"title": "Finanční kontrolu máte pouze vy",
							"label": "Majitel je jedinou osobou, která má finanční kontrolu nad bankovním účtem (bankovními účty) vašeho podniku"
						}
					},
					"buttons": {
						"next": "Další",
						"back": "Zpět"
					},
					"robot_message": "Omlouváme se, ale potřebujeme potvrdit tyto dvě věci."
				},
				"underwriting_info": {
					"title": "Specifikujte prosím objem a zpoždění platby příležitosti",
					"subtitle": "Uveďte prosím celkový očekávaný roční objem Klarna pro tuto příležitost pro všechny trhy a zpoždění platby. Pokud se zpoždění platby v jednotlivých zemích liší, použijte zpoždění pro vybranou hlavní prodejní zemi.",
					"fields": {
						"yearly_acquired_volume": {
							"label": "Celkový roční objem trhu (v SEK)",
							"errors": {
								"invalid": "Celkový roční objem trhu by měl být kladný v SEK.",
								"too_long": "Celkový roční objem trhu nesmí mít více než 16 číslic."
							}
						},
						"payment_delay": {
							"label": "Zpoždění platby",
							"errors": {
								"general": "Uveďte prosím hodnotu zpoždění platby",
								"invalid": "Zpoždění platby by mělo mít hodnotu mezi {min} a {max}"
							}
						},
						"payment_interval": {
							"label": "Interval plateb",
							"errors": {
								"invalid": "Musíte vybrat jednu z možností"
							}
						},
						"volume_by_card": {
							"label": "Podíl na pokladně (%)",
							"errors": {
								"invalid": "Podíl na pokladně by mělo být číslo mezi 0 a 100.",
								"invalid_hint": "Sečtěte prosím podíl objemu karetních transakcí z celkového objemu Klarny pro tuto příležitost. Pokud vaše příležitost nemá žádné platby kartou, zadejte prosím 0 %."
							}
						},
						"average_order_value": {
							"label": "Průměrná hodnota objednávky (v SEK)"
						}
					},
					"buttons": {
						"back": "Zpět",
						"next": "Další"
					}
				},
				"store_details": {
					"title": {
						"unmanaged": {
							"default": "Jaké jsou údaje o vašem obchodě?"
						},
						"managed": "Jaké jsou údaje o obchodě?"
					},
					"subtitle": {
						"unmanaged": {
							"US": "Tyto informace použijeme k nastavení vašeho firemního účtu.",
							"default": "Poskytnuté údaje použijeme jako primární kontaktní údaje a k prohlídce vašeho obchodu."
						},
						"managed": "Poskytnuté údaje použijeme jako primární kontaktní údaje pro spotřebitele a pro nahlédnutí do obchodu."
					},
					"fields": {
						"store_name": {
							"label": {
								"CA": "Název značky / DBA",
								"MX": "Název značky / DBA",
								"US": "Název značky / DBA",
								"default": "Název obchodu"
							},
							"errors": {
								"required": "Název obchodu je povinný údaj",
								"required_us": "Název značky / DBA je povinný údaj",
								"invalid": "Zadejte prosím název obchodu o délce minimálně 2 znaky",
								"invalid_us": "Zadejte prosím název značky / DBA o délce minimálně 2 znaky",
								"invalid_characters": "Název obchodu nesmí obsahovat následující znaky: < >",
								"invalid_characters_us": "Název značky / DBA nesmí obsahovat následující znaky: < >"
							}
						},
						"website": {
							"label": "Web online obchodu",
							"errors": {
								"required": "Web je povinný údaj",
								"invalid": "Zadejte prosím platnou adresu URL webu"
							}
						},
						"goods_category": {
							"label": "Hlavní kategorie prodávaného zboží",
							"errors": {
								"required": "Kategorie zboží je povinný údaj"
							}
						},
						"email": {
							"label": "E-mail na zákaznickou podporu",
							"errors": {
								"required": "E-mail na zákaznickou podporu je povinný údaj",
								"invalid": "Zadejte prosím platný e-mail"
							}
						}
					},
					"buttons": {
						"next": "Další",
						"back": "Změnit produkty"
					}
				},
				"uk_company_details": {
					"title": {
						"unmanaged": "Jaká je vaše registrovaná obchodní adresa?",
						"managed": "Jaká je registrovaná obchodní adresa společnosti?"
					},
					"subtitle": {
						"unmanaged": "Potřebujeme vědět, na jaké adrese je vaše firma registrována.",
						"managed": "Potřebujeme vědět, na jaké adrese je firma registrována."
					},
					"question": {
						"title": {
							"unmanaged": "Působíte na jiné adrese?",
							"managed": "Působí tato společnost na jiné adrese?"
						},
						"subtitle": {
							"unmanaged": "Možnost Ano vyberte pouze v případě, že podnikáte na jiné adrese, než je registrovaná obchodní adresa.",
							"managed": "Možnost Ano vyberte pouze v případě, že tato společnost provozuje svou činnost na jiné adrese, než je registrovaná obchodní adresa."
						}
					},
					"toggle": {
						"title": "Přidejte adresu hlavního místa podnikání"
					},
					"fields": {
						"company_name": {
							"label": "Právní název společnosti",
							"errors": {
								"general": "Uveďte prosím název společnosti"
							}
						},
						"street": {
							"label": "Adresa",
							"errors": {
								"general": "Uveďte prosím adresu"
							}
						},
						"postal_code": {
							"label": "PSČ",
							"errors": {
								"general": "Uveďte prosím PSČ"
							}
						},
						"city": {
							"label": "Město",
							"errors": {
								"general": "Uveďte prosím město"
							}
						},
						"country": {
							"label": "Země",
							"errors": {
								"general": "Uveďte prosím zemi"
							}
						}
					},
					"buttons": {
						"next": "Další",
						"back": "Zpět"
					},
					"messages": {
						"lookup": "Je toto vaše společnost? Podívejte se prosím a potvrďte, zda je to správně."
					}
				},
				"uk_sole_trader": {
					"title": "Kdo tuto společnost vlastní?",
					"subtitle": {
						"unmanaged": "Chystáte se uzavřít smlouvu se společností Klarna. Proto musíme shromažďovat vaše osobní údaje.",
						"managed": "Jsme povinni shromažďovat a ověřovat osobní údaje vlastníka."
					},
					"buttons": {
						"next": "Další",
						"back": "Zpět"
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Působíte na jiné adrese?",
								"managed": "Působí tato společnost na jiné adrese?"
							},
							"subtitle": {
								"unmanaged": "Možnost Ano vyberte pouze v případě, že podnikáte na jiné adrese, než je adresa vašeho bydliště.",
								"managed": "Možnost Ano vyberte pouze v případě, že tato společnost provozuje svou činnost na jiné adrese, než je adresa bydliště živnostníka."
							}
						},
						"title": "Uveďte prosím adresu firmy",
						"fields": {
							"street": {
								"label": "Adresa",
								"errors": {
									"general": "Uveďte prosím platnou adresu"
								}
							},
							"postal_code": {
								"label": "PSČ",
								"errors": {
									"general": "Uveďte prosím platné PSČ"
								}
							},
							"city": {
								"label": "Město",
								"errors": {
									"general": "Uveďte prosím platné město"
								}
							},
							"country": {
								"label": "Země",
								"errors": {
									"general": "Uveďte prosím platnou zemi"
								}
							}
						}
					}
				},
				"us_sole_proprietorship": {
					"title": "Kdo společnost vlastní?",
					"subtitle": {
						"default": "Jako finanční instituce jsme ze zákona povinni tyto informace shromažďovat."
					},
					"infobox": {
						"unmanaged": "Zadejte prosím své osobní údaje a adresu bydliště.",
						"managed": "Zadejte prosím údaje o vlastníkovi a adresu bydliště."
					},
					"buttons": {
						"next": "Další",
						"back": "Zpět"
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Působíte na jiné adrese?",
								"managed": "Působí tato společnost na jiné adrese?"
							},
							"subtitle": {
								"unmanaged": "Možnost Ano vyberte pouze v případě, že podnikáte na jiné adrese, než je adresa vašeho bydliště.",
								"managed": "Možnost Ano vyberte pouze v případě, že tato společnost provozuje svou činnost na jiné adrese, než je adresa bydliště živnostníka."
							}
						},
						"title": "Uveďte prosím adresu firmy",
						"fields": {
							"street": {
								"label": "Adresa",
								"errors": {
									"general": "Uveďte prosím platnou adresu"
								}
							},
							"postal_code": {
								"label": "PSČ",
								"errors": {
									"general": "Uveďte prosím platné PSČ"
								}
							},
							"city": {
								"label": "Město",
								"errors": {
									"general": "Uveďte prosím platné město"
								}
							},
							"country": {
								"label": "Země",
								"errors": {
									"general": "Uveďte prosím platnou zemi"
								}
							},
							"region": {
								"label": "Stát",
								"errors": {
									"general": "Uveďte prosím stát"
								}
							}
						}
					}
				},
				"ultimate_beneficial_owner": {
					"title": {
						"default": "Vlastní někdo více než 25 % společnosti?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Jako finanční instituce jsme ze zákona povinni tyto informace shromažďovat."
							}
						],
						"default": [
							{
								"text": "Potřebujeme znát osoby, které vlastní více než 25 % akcií nebo hlasovacích práv společnosti nebo vykonávají podobnou kontrolu. Shromažďování těchto informací nám ukládá směrnice EU ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") o boji proti praní špinavých peněz."
							}
						]
					},
					"infobox": {
						"default": "Zadejte prosím osobní údaje a adresu bydliště každého jednotlivce.",
						"AU": "Zadejte prosím osobní údaje a adresu bydliště každého jednotlivce. V případě společností se složitou vlastnickou strukturou se musí jednat o fyzické osoby."
					},
					"buttons": {
						"next": "Další",
						"back": "Zpět",
						"add_person": "+ Přidat osobu"
					},
					"messages": {
						"lookup": "Vlastní tito lidé více než 25 % vaší společnosti? Podívejte se prosím a potvrďte, zda je to správně."
					}
				},
				"us_company_details": {
					"title": {
						"unmanaged": "Jaká je vaše obchodní adresa?",
						"managed": "Jaká je registrovaná obchodní adresa společnosti?"
					},
					"subtitle": {
						"unmanaged": "Je to místo, kde je vaše firma právně registrována a bude se zobrazovat na fakturách zákazníků společnosti Klarna.",
						"managed": "Potřebujeme vědět, na jaké adrese je firma registrována."
					},
					"question": {
						"title": {
							"unmanaged": "Působíte na jiné adrese?",
							"managed": "Působí tato společnost na jiné adrese?"
						},
						"subtitle": {
							"unmanaged": "Možnost Ano vyberte pouze v případě, že podnikáte na jiné adrese, než je registrovaná obchodní adresa.",
							"managed": "Možnost Ano vyberte pouze v případě, že tato společnost provozuje svou činnost na jiné adrese, než je registrovaná obchodní adresa."
						}
					},
					"toggle": {
						"title": "Přidejte adresu hlavního místa podnikání"
					},
					"fields": {
						"company_name": {
							"label": "Registrovaná společnost",
							"errors": {
								"general": "Uveďte prosím název společnosti"
							}
						},
						"street": {
							"label": "Adresa",
							"errors": {
								"general": "Uveďte prosím adresu"
							}
						},
						"postal_code": {
							"label": "PSČ",
							"errors": {
								"general": "Uveďte prosím PSČ"
							}
						},
						"city": {
							"label": "Město",
							"errors": {
								"general": "Uveďte prosím město"
							}
						},
						"country": {
							"label": "Země",
							"errors": {
								"general": "Uveďte prosím zemi"
							}
						},
						"state_of_incorporation": {
							"label": "Stát založení",
							"errors": {
								"general": "Uveďte prosím stát založení"
							}
						},
						"state": {
							"label": "Stát",
							"errors": {
								"general": "Uveďte prosím stát"
							}
						},
						"region": {
							"label": "Region",
							"errors": {
								"puerto_rico": "Portoriko není povoleno"
							}
						}
					},
					"buttons": {
						"next": "Další",
						"back": "Zpět"
					}
				},
				"select_products": {
					"title": "Naše služby",
					"title_kco_hidden": "Způsoby platby, které zvyšují prodeje.",
					"subtitle": "Vyberte služby, které vás zajímají.",
					"subtitle_kco_hidden": "Uvolněte kupní sílu svého zákazníka. Nabídněte více možností platby, aby se mohli rozhodnout, kdy a jak zaplatí.",
					"platform_alert": null,
					"buttons": {
						"next": "Další"
					}
				},
				"signup_products": {
					"title_line_1": "Produkty Klarna pro váš obchod.",
					"title_kco_hidden_line_1": "Způsoby platby, které",
					"title_kco_hidden_line_2": "zvyšují prodeje.",
					"subtitle": "Nabídka způsobů platby Klarna vede k průměrnému zvýšení konverze o 30 %, AOV o 41 % a frekvence nákupů o 36 %.",
					"subtitle_kco_hidden": "Uvolněte kupní sílu svého zákazníka. Nabídněte více možností platby, aby se mohli rozhodnout, kdy a jak zaplatí.",
					"info_block": "Zobrazují se dostupné produkty pro",
					"special_offer": "Speciální nabídka: {percentageFee}% + {fixedFee} na transakci Platí do {validUntil}.",
					"buttons": {
						"contact_sales": "Kontaktuj obchodní oddělení",
						"next": "Vytvořit účet",
						"back": "Zpět"
					}
				},
				"questionnaire": {
					"buttons": {
						"back": "Zpět",
						"next": "Další"
					}
				},
				"business_concepts": {
					"title": "Vyberte prosím příslušné koncepty podnikání.",
					"subtitle": "Vyberte prosím pouze ty, které se vás týkají. Může jich být více.",
					"errors": {
						"select_at_least_one": "Vyberte prosím alespoň jeden koncept podnikání."
					},
					"buttons": {
						"next": "Další",
						"back": "Zpět"
					}
				},
				"confirm_copy": {
					"title": "Potvrdit kopii",
					"disclaimer": "Veškeré existující informace v aktuálním MID budou přepsány údaji z ",
					"merchant_id": "{mid}",
					"buttons": {
						"skipCopy": "Nekopírovat",
						"confirmCopy": "Kopírovat data"
					}
				},
				"pre_assessment_summary": {
					"title": "Shrnutí",
					"subtitle": "Před odesláním údajů k upisování je pečlivě zkontrolujte.",
					"banner": {
						"mcc_deal": "Toto je dohoda MCC, postupujte prosím podle postupu eskalace MCC / ECC."
					},
					"selling_countries": {
						"title": "Vyberte prosím trh s nejvyšším očekávaným objemem.",
						"main_selling_country": "Hlavní země prodeje"
					},
					"pre_assessment_products": {
						"title": "Produkty"
					},
					"company_details": {
						"title": "Podrobnosti o společnosti"
					},
					"fca_number": {
						"title": "Číslo FCA"
					},
					"high_exposure_questionnaires": {
						"title": "Dotazníky s vysokou mírou expozice"
					},
					"mia_questionnaires": {
						"title": "Dotazníky MIA"
					},
					"buttons": {
						"back": "Zpět",
						"edit": "Upravit",
						"submit": "Odeslat"
					}
				},
				"pre_assessment_overview": {
					"title": "Přehled před posouzením",
					"subtitle_APPROVED": "Níže naleznete schválené podmínky pro tuto příležitost.",
					"subtitle_REJECTED": "Níže naleznete zamítnuté podmínky pro tuto příležitost.",
					"subtitle_UNRESOLVED": "V případě, že zjistíte chyby, můžete zadané údaje změnit. Tím se nevyvolá nový případ.",
					"status": {
						"APPROVED": "Případ byl schválen",
						"REJECTED": "Případ byl zamítnut",
						"UNRESOLVED": "Čeká se na rozhodnutí o upsání...",
						"UNRESOLVED_TIMED_OUT": "Případ projde ručním upisováním. Upozorňujeme, že to může trvat i několik dní.",
						"UNRESOLVED_TIMED_OUT_LINK_LABEL": "Zobrazení případu v grafickém uživatelském rozhraní kontroly obchodníka",
						"STARTED": "Případ je předložen k přezkoumání"
					},
					"buttons": {
						"change": "Změnit",
						"new_case": "Nový případ"
					}
				},
				"recollection_introduction": {
					"title": {
						"default": "Zdravíme tě!"
					},
					"subtitle": {
						"default": [
							{
								"text": "Vzhledem k tomu, že je Klarna regulovanou společností pod dohledem švédského Úřadu pro finanční dohled, je povinna předcházet praní špinavých peněz, jak je stanoveno ve směrnici EU 2015/849 (v platném znění). Pro vás jako obchodníka tato směrnice znamená, že společnost Klarna bude shromažďovat informace o osobách kontrolujících vaši společnost (skutečných majitelích), než budete moci začít využívat služby společnosti Klarna. Stávající obchodníci poskytují tyto informace pravidelně, aby byla zajištěna jejich aktuálnost. Více informací najdete ve směrnici EU "
							},
							{
								"text": "tady",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": "."
							}
						]
					},
					"buttons": {
						"next": "Další"
					}
				},
				"recollection_confirmation": {
					"title": "Potvrzení",
					"subtitle": "Před odesláním údajů k upisování je pečlivě zkontrolujte.",
					"stakeholder": "Zainteresovaná strana {index}",
					"buttons": {
						"back": "Zpět",
						"submit": "Odeslat"
					}
				},
				"recollection_overview": {
					"title": "Děkujeme!",
					"subtitle": "Zde je přehled informací, které jste odeslali.",
					"stakeholder": "Zainteresovaná strana {index}",
					"notice": "Vaše informace byly úspěšně odeslány."
				},
				"volume_separation": {
					"title_line_1": "Jaká je velikost vaší online firmy?",
					"subtitle": "Klarna disponuje těmi nejlepšími řešeními pro vaši firmu – bez ohledu na to, jak velká nebo malá je.",
					"selector_title": "Roční výnos",
					"below": "Pod {threshold}",
					"between": "Mezi {belowThreshold} a {aboveThreshold}",
					"over": "Nad {threshold}",
					"buttons": {
						"back": "Zpět"
					}
				},
				"basic_info": {
					"title_line_1": "Rozjeďte své podnikání",
					"title_line_2": "s Klarnou.",
					"subtitle": "Potřebujeme několik základních informací, abychom vás dostali na správné místo.",
					"fields": {
						"email": {
							"label": "Firemní e-mail",
							"field_link": "Nejste firma?",
							"errors": {
								"required": "E-mailová adresa je povinný údaj",
								"invalid": "Zadej prosím platnou e-mailovou adresu"
							}
						},
						"email_confirmation": {
							"label": "Potvrďte firemní e-mail",
							"tooltip": "Váš firemní e-mail bude hlavním komunikačním prostředkem se společností Klarna. Ujistěte se, že je správná",
							"errors": {
								"required": "Potvrzení e-mailové adresy je povinný údaj",
								"invalid": "Ujistěte se, že zadáváte stejný e-mail dvakrát"
							}
						},
						"website": {
							"label": "Adresa URL e-obchodování",
							"errors": {
								"required": "Adresa URL e-obchodování je povinný údaj",
								"invalid": "Zadejte prosím platnou adresu URL"
							}
						},
						"country": {
							"label": "Země registrace",
							"errors": {
								"general": "Vyberte prosím jednu z dostupných zemí"
							}
						}
					},
					"buttons": {
						"continue": "Pokračovat"
					}
				},
				"contact_details": {
					"title_line_1": "Pojďme chatovat.",
					"subtitle": "Vyplňte tento formulář a my se vám co nejdříve ozveme s řešeními šitými na míru vašemu podnikání.",
					"fields": {
						"full_name": {
							"label": "Celé jméno",
							"errors": {
								"required": "Celé jméno je povinný údaj"
							}
						},
						"phone": {
							"label": "Telefonní číslo",
							"tooltip": "Je třeba uvést předvolbu země, např. +1 541 754 3010.",
							"errors": {
								"required": "Telefonní číslo je povinný údaj.",
								"invalid": "Neplatné telefonní číslo"
							}
						},
						"tell_us_more": {
							"label": "Řekněte nám o vaší firmě něco více (volitelné)"
						}
					},
					"buttons": {
						"back": "Zpět",
						"submit": "Odeslat kontaktní údaje"
					}
				},
				"contact_received": {
					"title": "Brzy se ozveme!",
					"message_1": "Náš prodejní tým vás bude co nejdříve kontaktovat.",
					"message_2": "Náš tým vás bude co nejdříve kontaktovat. Odeslali jsme vám také potvrzení o odeslaných informacích. "
				},
				"we_are_sorry": {
					"title": "Omlouváme se. V tuto chvíli jsme nemohli vaši žádost přijmout.",
					"message_1_unsupported_country": "Klarna v současné době nepodporuje vybranou zemi:",
					"message_1_sensitive_goods": "Klarna nepodporuje zvolenou kategorii zboží:",
					"message_1_platform": "Klarna nepodporuje vámi vybranou platformu elektronického obchodu:",
					"message_2": "Neustále se snažíme vytvářet nová partnerství, takže se ozveme, jakmile budeme moci v budoucnu pokračovat ve vaší žádosti.",
					"platform_alert": {
						"jtl4": [
							{
								"text": "Stále můžete používat"
							},
							{
								"text": "plugin",
								"link": "https://www.mollie.com/de/integrations/jtl"
							},
							{
								"text": "od našeho partnera Mollie."
							}
						]
					}
				},
				"platform": {
					"title_line_1": "Na jaké platformě jste?",
					"subtitle": "Vyberte svou platformu e-obchodování a my vaši firmu za chvíli integrujeme.",
					"custom": "Pořiďte si zabudovanou integraci",
					"other_platform": "Další řešení integrace",
					"platform_search": {
						"label": "Platforma e-obchodování",
						"no_match": "Nenalezena žádná shoda pro „{input}“"
					},
					"buttons": {
						"back": "Zpět"
					}
				},
				"partner": {
					"title_line_1": "Kterého partnera platebních služeb byste rádi využili?",
					"subtitle": "Vyberte si partnera pro platební služby, který nejlépe vyhovuje vašim potřebám."
				},
				"account_creation_loading": {
					"title": "Vytváří se účet…",
					"message": "Nastavení obchodního ID..."
				},
				"application_checking": {
					"title": "Kontrolujeme vaši žádost…",
					"message": "Analýza údajů o obchodu"
				},
				"application_review": {
					"title": "Kontrolujeme vaši žádost.",
					"title_approved": "Vaše žádost byla schválena!",
					"message": "Jedná se o ruční proces, takže doba vyřízení se může lišit, ale vyřídíme ji co nejrychleji.",
					"email_info_1": "Poslali jsme vám e-mail s předmětem „{subject}“.",
					"email_info_2": "Pomocí uvedených kroků se přihlaste a sledujte stav své žádosti podle pokynů.",
					"email_info_2_approved": "Přihlaste se a integrujte Klarnu do svého e-obchodu podle následujících kroků.",
					"email_subject": "Vítá vás Portál obchodníka Klarna",
					"resend_email": "Znovu odeslat e-mail"
				},
				"user_already_exists": {
					"title": "Pokračujte po přihlášení na Portál obchodníka.",
					"message_1": "Tato e-mailová adresa je již spojena s účtem na portálu obchodníka. Chcete-li provést změny ve svém stávajícím účtu, přihlaste se prosím.",
					"log_in": "Přihlásit na Portál obchodníka",
					"forgot_password": "Zapomněli jste heslo?"
				},
				"otherPlatform": {
					"info": "Již máme integraci pro {platform}",
					"link": "Začít integraci zde",
					"title": "Smoooth, můžete integrovat přímo!",
					"info2": "Dobrá zpráva! Klarnu můžete do svého e-obchodování integrovat přímo z <strong>{platform}</strong>.",
					"link2": "Jděte na {platform} + Integrace Klarna"
				},
				"noLandingPagePlatform": {
					"text": {
						"one": {
							"default": "Obraťte se prosím přímo na náš prodejní tým",
							"SE": "Obraťte se prosím přímo na náš prodejní tým v"
						}
					}
				},
				"sensitive_goods": {
					"title_2": "Nabízíte některý z následujících produktů nebo služeb?",
					"subtitle_2": "Společnost Klarna může některé položky definovat jako omezené na základě trhu, zákonů, objemu prodeje, ochoty riskovat a dalších omezení, která mohou být povolena a nesmí být zpracována bez souhlasu společnosti Klarna.",
					"titleV2": "Vyberte, které z níže uvedených možností se týkají vaší firmy.",
					"goodsCategories": {
						"CBD_HEMP_TOBACCO_ECIGARETTES_VAPE": {
							"title_2": "Věkově omezené produkty",
							"description_2": "Tabák, e-cigarety, náplně do e-cigaret, konopné produkty, alkohol, obsah pro dospělé"
						},
						"EVENTS_TICKETS_TOURISM_TRAVEL_VOUCHERS": {
							"title_2": "Cestování, prohlídky a akce",
							"description_2": "Doprava, události, platforma pro prodej vstupenek, hotely nebo ubytování, pronájmy, cestovní kanceláře"
						},
						"WEAPONS_AMMUNITION": {
							"title_2": "Licencované zbraně",
							"description_2": "Munice, bojové nože, lovecké vybavení, obušky, pepřové spreje"
						},
						"MARKETPLACE": {
							"title_2": "Partnerský trh",
							"description_2": "Služby, které umožňují třetím stranám přeprodávat jejich zboží nebo nabízet služby prostřednictvím jejich online platformy"
						},
						"PHARMACEUTICALS": {
							"title_2": "Farmaceutické a lékařské služby",
							"description_2": "Distribuce léků na předpis, lékařské zákroky včetně estetických a tetování"
						},
						"SERVICES_SUBSCRIPTIONS_MEMBERSHIPS_RENTALS_CONTENT": {
							"title_2": "Členství, předplatné a služby",
							"description_2": "Předplatné fyzického zboží, digitální obsah, streamovací služby, seznamky atd."
						},
						"NONE": {
							"title_2": "Nabízím jiný typ produktu/služby"
						}
					},
					"link": "Více o zakázaných položkách",
					"buttons": {
						"next": "Další",
						"continue": "Pokračovat"
					}
				}
			},
			"address_form_component": {
				"postal_code": {
					"tooltip": {
						"default": "Zadejte své poštovní směrovací číslo, aby se automaticky vyplnily další části vaší adresy.",
						"US": "Zadejte své PSČ, aby se automaticky vyplnily další části vaší adresy."
					},
					"label": {
						"default": "PSČ",
						"US": "Poštovní směrovací číslo"
					},
					"error": {
						"default": "Zadejte prosím platné poštovní směrovací číslo",
						"US": "Zadejte prosím platné PSČ"
					}
				},
				"city": {
					"label": "Město",
					"error": "Zadejte prosím město"
				},
				"street": {
					"label": "Adresa",
					"error": "Zadejte prosím adresu",
					"tooltip": "Začněte psát a zobrazte další návrhy ulic",
					"no_suggestion_found": "Žádná shoda pro {input}"
				},
				"country": {
					"label": "Země",
					"error": "Vyberte prosím zemi"
				},
				"region": {
					"label": "Stát/region (volitelné)"
				},
				"state": {
					"label": "Stát",
					"error": "Zadejte prosím stát"
				}
			},
			"platforms": {
				"custom": "Integrace API",
				"other": "Nemůžu najít svou platformu"
			},
			"buttons": {
				"back": "Zpět"
			},
			"products": {
				"not_available": "Není k dispozici v {reason}",
				"not_available_country": "Není k dispozici ve vaší zemi",
				"not_available_platform": "Není k dispozici v {platform}",
				"why_product": "Proč zvolit Klarnu {name}",
				"kco_one": {
					"name": {
						"default": "Pokladna"
					},
					"description": {
						"default": "Nahraďte pokladnu svého obchodu kompletními pokladními službami Klarna."
					},
					"description_expanded": {
						"default": "Nahraďte pokladnu svého obchodu kompletními pokladními službami Klarna."
					},
					"options": {
						"kco_one-pay-now": {
							"name": {
								"default": "Zaplatit hned"
							},
							"description": {
								"default": "Nabídka okamžitých plateb kartou nebo bankovním převodem."
							}
						},
						"kco_one-pay-later": {
							"name": {
								"default": "Platba do 30 dnů"
							},
							"description": {
								"default": "Nabídněte 30 dnů na zaplacení. Žádné úroky."
							}
						},
						"kco_one-slice-it": {
							"name": {
								"default": "Financování"
							},
							"description": {
								"default": "Nabídněte splácení po dobu 6–36 měsíců.",
								"DE": "Nabídněte splácení po dobu 6–24 měsíců.",
								"AT": "Nabídněte splácení po dobu 6–24 měsíců."
							}
						},
						"kco_one-slice-it-in-3": {
							"name": {
								"default": "Splátky"
							},
							"description": {
								"default": "Nabídněte 3 bezúročné splátky.",
								"GB": "Nabídněte 3 bezúročné splátky."
							}
						},
						"kco_one-slice-it-in-4": {
							"name": {
								"default": "Rozdělte na 4",
								"US": "splátek",
								"AU": "Platba ve 4 splátkách"
							},
							"description": {
								"default": "Nabídněte 4 bezúročné splátky.",
								"GB": "Nabídněte 4 bezúročné splátky."
							}
						}
					},
					"features": {
						"other_payment_options": {
							"name": {
								"default": "Další možnosti platby"
							},
							"description": {
								"default": "Kreditní karty, debetní karty a další"
							}
						},
						"on_site_messaging": {
							"name": {
								"default": "Zasílání zpráv na místě"
							}
						},
						"billing": {
							"name": {
								"default": "Automatická identifikace a fakturace"
							}
						},
						"shipping": {
							"name": {
								"default": "Přizpůsobené možnosti zasílání"
							}
						},
						"post_purchase": {
							"name": {
								"default": "Podpora po nákupu"
							}
						}
					}
				},
				"kp_one": {
					"name": {
						"default": "Způsob platby"
					},
					"description": {
						"default": "Přidání způsobů platby Klarna do stávající pokladny"
					},
					"description_expanded": {
						"default": "Nabídka způsobů platby Klarna vede k průměrnému zvýšení konverze o 30 %, AOV o 41 % a frekvence nákupů o 36 %."
					},
					"options": {
						"kp_one-pay-now": {
							"name": {
								"default": "Zaplatit hned"
							},
							"description": {
								"default": "Nabídka okamžitých plateb kartou nebo bankovním převodem."
							}
						},
						"kp_one-pay-later": {
							"name": {
								"default": "Platba do 30 dnů"
							},
							"description": {
								"default": "Zákazníci platí 30 dní po nákupu bez úroků."
							}
						},
						"kp_one-slice-it": {
							"name": {
								"default": "Financování"
							},
							"description": {
								"default": "Zákazníci mohou splácet 6–36 měsíců.",
								"DE": "Zákazníci mohou splácet 6–24 měsíců.",
								"AT": "Zákazníci mohou splácet 6–24 měsíců."
							}
						},
						"kp_one-slice-it-in-3": {
							"name": {
								"default": "Splátky"
							},
							"description": {
								"default": "Nabídněte 3 bezúročné splátky.",
								"GB": "Nabídněte 3 bezúročné splátky."
							}
						},
						"kp_one-slice-it-in-4": {
							"name": {
								"default": "Rozdělte na 4",
								"US": "4 splátky",
								"CA": "4 splátky",
								"AU": "Platba ve 4 splátkách"
							},
							"description": {
								"default": "Nabídněte 4 bezúročné splátky.",
								"GB": "Nabídněte 4 bezúročné splátky.",
								"US": "Objednávky od 35 do 1 000 USD lze rozdělit do 4 bezúročných splátek splatných každé 2 týdny.",
								"CA": "Objednávky od 35 do 1 000 USD lze rozdělit do 4 bezúročných splátek splatných každé 2 týdny."
							}
						},
						"kp_one-pay-by-card": {
							"name": {
								"default": "Zaplatit kartou"
							},
							"description": {
								"default": "Nabídka okamžitých plateb kartou nebo bankovním převodem."
							}
						}
					}
				}
			}
		},
		"fields": {
			"enm": {
				"product_channel": {
					"label": "Jak máte v úmyslu prodávat?",
					"options": {
						"IN_STORE": "Fyzický obchod",
						"TELESALES": "Vzdálený prodej"
					},
					"description": {
						"IN_STORE": "Prodej probíhá především osobně a zákazník dostane zboží ihned.",
						"TELESALES": "Prodej se uskutečňuje především po telefonu na základě příchozích hovorů zákazníků. Zákazník nedostane zboží ihned."
					}
				},
				"country": {
					"label": "Země"
				},
				"organization_category": {
					"label": "Typ právního subjektu",
					"options": {
						"SOLE_TRADER": "Živnostník",
						"PARTNERSHIP": "Partnerská spolupráce",
						"UNDEFINED": "NEDEFINOVÁNO",
						"BV": "BV",
						"CV": "CV",
						"CVOA": "CVOA",
						"EEN": "EEN",
						"MTS": "MTS",
						"NV": "NV",
						"SE": "SE",
						"VOF": "VOF",
						"C_CORP": "C korporace",
						"S_CORP": "S korporace",
						"TRUST_ESTATE": "Svěřenský fond/pozůstalost",
						"INDIVIDUAL": "OSVČ",
						"SOLE_PROPRIETORSHIP": "Výhradní vlastník",
						"SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": "Jednočlenná společnost s ručením omezeným",
						"LIMITED_LIABILITY_COMPANY": "Společnost s ručením omezeným",
						"PUBLIC_LISTED_COMPANY": "Veřejně obchodovaná společnost",
						"PRIVATE_COMPANY": "PRIVATE_COMPANY"
					}
				},
				"store_category": {
					"label": "Hlavní kategorie prodávaného zboží",
					"options": {
						"ADULT_SHOES_AND_CLOTHING": "Oblečení a obuv – Obuv a oblečení pro dospělé",
						"AUTOMOTIVE_PARTS_AND_ACCESSORIES": "Výrobky pro automobilový průmysl – Automobilové díly a příslušenství",
						"BAGS_AND_WALLETS": "Šperky a doplňky – Tašky a peněženky",
						"BODY_AND_HAIR_CARE": "Zdraví a krása – Péče o tělo a vlasy",
						"BOOK_AND_MAGAZINES": "Zábava – Knihy a časopisy",
						"CANDY": "Jídlo a pití – Cukrovinky",
						"CAR_ELECTRONICS": "Elektronika – Automobilová elektronika",
						"CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS": "Dětské zboží – Dětské oblečení a výrobky pro péči",
						"CHILDREN_TOYS": "Dětské zboží – Dětské hračky",
						"CLEANING_AND_SANITARY": "Dům a zahrada – Úklidové a hygienické přípravky",
						"COLLECTIBLES": "Volný čas, sport a koníčky – Sběratelství",
						"CONCEPT_STORES_AND_MISCELLANEOUS": "Volný čas, sport a koníčky – Koncepční obchody a různé zboží",
						"COSMETICS": "Zdraví a krása – Kosmetika",
						"COSTUMES_AND_PARTY_SUPPLIES": "Volný čas, sport a koníčky – Kostýmy a párty potřeby",
						"DATING_SERVICES": "Nehmotné produkty – Seznamovací služby",
						"DECORATION_AND_ART": "Dům a zahrada – Dekorace a umění",
						"DIETARY_SUPPLEMENTS": "Zdraví a krása – Doplňky stravy",
						"DIGITAL_SERVICES": "Nehmotné produkty – Digitální služby",
						"DIVERSIFIED_CHILDREN_PRODUCTS": "Dětské produkty – Různorodé dětské produkty",
						"DIVERSIFIED_ELECTRONICS": "Elektronika – Různorodá elektronika",
						"DIVERSIFIED_ENTERTAINMENT": "Zábava – Různorodá zábava",
						"DIVERSIFIED_EROTIC_MATERIAL": "Erotické materiály – Různorodé erotické materiály",
						"DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS": "Zdraví a krása – Různorodé produkty pro zdraví a krásu",
						"DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS": "Dům a zahrada – Různorodé produkty pro dům a zahradu",
						"DIVERSIFIED_JEWELRY_AND_ACCESSORIES": "Šperky a doplňky – Různorodé šperky a doplňky",
						"EDUCATION": "Nehmotné produkty – Vzdělávání",
						"ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES": "Elektronika – Elektronická zařízení a související příslušenství",
						"EROTIC_CLOTHING_AND_ACCESSORIES": "Erotické materiály – Erotické oblečení a doplňky",
						"EVENT_TICKETS": "Nehmotné produkty – Vstupenky na akce",
						"FOOD_AND_BEVERAGE": "Potraviny a nápoje – Potraviny a nápoje",
						"FRAGRANCES": "Zdraví a krása – Vůně",
						"FURNITURE": "Dům a zahrada – Nábytek",
						"GENERAL_SHOES_AND_CLOTHING": "Oblečení a obuv – Obuv a oblečení obecně",
						"HOBBY_ARTICLES": "Volný čas, sport a koníčky – Zboží pro koníčky",
						"HOUSEHOLD_ELECTRONICS": "Elektronika – Domácí elektronika",
						"JEWELRY_AND_WATCHES": "Šperky a doplňky – Šperky a hodinky",
						"KITCHENWARE": "Dům a zahrada – Kuchyňské potřeby",
						"MARKETPLACES": "Nehmotné produkty – Tržnice",
						"MUSIC_AND_MOVIES": "Zábava – Hudba a filmy",
						"MUSICAL_INSTRUMENTS_AND_EQUIPMENT": "Volný čas, sport a koníčky – Hudební nástroje a vybavení",
						"NON_PRESCRIPTION_SUNGLASSES_AND_LENSES": "Šperky a doplňky – Sluneční brýle a čočky bez předpisu",
						"OFFICE_MACHINES_AND_RELATED_ACCESSORIES": "Elektronika – Kancelářské stroje a související příslušenství",
						"OTHER_SERVICES": "Nehmotné produkty – Ostatní služby",
						"PERSONAL_CARE_AND_BODY_IMPROVEMENT": "Zdraví a krása – Osobní péče a vylepšování těla",
						"PET_SUPPLIES": "Dům a zahrada – Potřeby pro domácí mazlíčky",
						"PHARMACEUTICAL_PRODUCTS": "Zdraví a krása – Farmaceutické produkty",
						"PLANTS_AND_FLOWERS": "Dům a zahrada – Rostliny a květiny",
						"PRESCRIPTION_OPTICS": "Zdraví a krása – Optika na předpis",
						"PRINTS_AND_PHOTOS": "Volný čas, sport a koníčky – Tisk a fotografie",
						"SAFETY_PRODUCTS": "Dům a zahrada – Bezpečnostní produkty",
						"SEX_TOYS": "Erotické materiály – Sexuální hračky",
						"SPORTS_GEAR_AND_OUTDOOR": "Volný čas, sport a koníčky – Sportovní a outdoorové vybavení",
						"TOBACCO": "Potraviny a nápoje – Tabák",
						"TOOLS_AND_HOME_IMPROVEMENT": "Dům a zahrada – Nářadí a domácí kutilství",
						"TRAVEL_SERVICES": "Nehmotné produkty – Cestovní služby",
						"UNDERWEAR": "Oblečení a obuv – Spodní prádlo",
						"VIDEO_GAMES_AND_RELATED_ACCESSORIES": "Zábava – Videohry a související příslušenství",
						"WHEELS_AND_TIRES": "Výrobky pro automobilový průmysl – Kola a pneumatiky",
						"WINE_BEER_AND_LIQUOR": "Potraviny a nápoje – Víno, pivo a likéry",
						"YOUTHFUL_SHOES_AND_CLOTHING": "Oblečení a obuv – Obuv a oblečení pro mladé"
					}
				},
				"currency": {
					"label": "Měna"
				},
				"account_type": {
					"label": "Typ bankovního účtu",
					"options": {
						"IBAN": "IBAN",
						"LOCAL_SE": "Místní švédský",
						"LOCAL_US": "Místní USA",
						"LOCAL_GENERIC": "Místní norský/dánský",
						"SPECIAL": "Speciální",
						"BANKGIRO": "Místní švédský Bankgiro",
						"PLUSGIRO": "Místní švédský Plusgiro"
					}
				},
				"person_role": {
					"label": "Role",
					"options": {
						"LEGAL_REPRESENTATIVE": "Zákonný zástupce",
						"ALTERNATIVE_BENEFICIAL_OWNER": "Alternativní příjemce požitků",
						"ULTIMATE_BENEFICIAL_OWNER": "Konečný skutečný vlastník",
						"OWNER": "Majitel"
					}
				},
				"business_size": {
					"label": "Velikost firmy",
					"options": {
						"LARGE": "velký",
						"MEDIUM": "střední",
						"small": "malý"
					}
				},
				"sensitive_good_category": {
					"label": "Nabízíte ve svém kamenném obchodě některý z následujících produktů nebo služeb?",
					"options": {
						"AGE_RESTRICTED_PRODUCTS": "Věkově omezené produkty",
						"LICENSED_WEAPONS": "Licencované zbraně",
						"PHARMA_AND_MEDICAL_SERVICES": "Farmaceutické a lékařské služby",
						"TRAVEL_TOURS_EVENTS": "Cestování, prohlídky a akce",
						"PEER_TO_PEER_MARKETPLACE": "Partnerský trh",
						"MEMBERSHIPS_SUBSCRIPTIONS_SERVICES": "Členství, předplatné a služby",
						"NONE": "Nabízím jiný typ produktu/služby"
					},
					"description": {
						"AGE_RESTRICTED_PRODUCTS": "Tabák, e-cigarety, náplně do e-cigaret, konopné produkty, alkohol, obsah pro dospělé",
						"LICENSED_WEAPONS": "Munice, bojové nože, lovecké vybavení, obušky, pepřové spreje",
						"PHARMA_AND_MEDICAL_SERVICES": "Distribuce léků na předpis, lékařské zákroky včetně estetických a tetování",
						"TRAVEL_TOURS_EVENTS": "Doprava, události, platforma pro prodej vstupenek, hotely nebo ubytování, pronájmy, cestovní kanceláře",
						"PEER_TO_PEER_MARKETPLACE": "Služby, které umožňují třetím stranám přeprodávat jejich zboží nebo nabízet služby prostřednictvím jejich online platformy",
						"MEMBERSHIPS_SUBSCRIPTIONS_SERVICES": "Předplatné fyzického zboží, digitální obsah, streamovací služby, seznamky atd.",
						"NONE": "Nabízím jiný typ produktu/služby"
					},
					"error_message": "Omlouváme se. Ve vaší žádosti nemůžeme pokračovat, protože v současné době nepodporujeme vybraný typ produktu nebo služby."
				}
			},
			"common": {
				"country": {
					"label": "Země"
				},
				"address": {
					"city": {
						"label": "Město"
					},
					"postal_code": {
						"label": "PSČ"
					},
					"region": {
						"label": "Stát/region"
					},
					"street_address": {
						"label": "Adresa fyzického obchodu"
					},
					"street_address2": {
						"label": "Řádek 2 adresy"
					}
				}
			},
			"payload": {
				"business_information": {
					"company_name": {
						"label": "Název společnosti"
					},
					"registration_authority": {
						"label": "Evidenční orgán"
					},
					"registration_id": {
						"label": "Registrační číslo"
					},
					"subject_to_vat": {
						"label": "Je vaše firma registrovaným plátcem DPH?"
					},
					"vat_id": {
						"label": "Daňové identifikační číslo"
					},
					"persons": {
						"date_of_birth": {
							"label": "Datum narození"
						},
						"first_name": {
							"label": "Jméno"
						},
						"last_name": {
							"label": "Příjmení"
						},
						"person_identity_document": {
							"label": "Doklad totožnosti"
						},
						"person_proof_of_address": {
							"label": "Doklad s adresou"
						},
						"personal_identifier": {
							"label": "Osobní ID"
						}
					},
					"should_auto_capture_orders": {
						"label": "Chcete automaticky zachytávat objednávky?",
						"tooltip": "Objednávky by měly být zaznamenány při předání v obchodě nebo při odeslání ze skladu. Výběrem možnosti automatického zaznamenání se objednávka automaticky zaznamená, jakmile spotřebitel potvrdí nákup."
					}
				},
				"contract_entity": {
					"label": "Smluvní subjekt"
				},
				"contract_onboarding_type": {
					"label": "Typ onboardingu obchodního partnera"
				},
				"underwriting_inquiry_email": {
					"label": "Upisovací e-mail"
				},
				"bank_accounts": {
					"account_holder": {
						"label": "Jméno vlastníka účtu"
					},
					"account_number": {
						"label": "Číslo účtu"
					},
					"bic": {
						"label": "Kód BIC"
					},
					"iban": {
						"label": "Číslo účtu (IBAN)"
					},
					"is_default": {
						"label": "Použijte tento účet pro nespecifikované měny"
					},
					"routing_number": {
						"label": "Směrovací číslo"
					}
				},
				"in_stores": {
					"contact_email": {
						"label": "Kontaktní e-mail"
					},
					"name": {
						"label": "Název obchodu"
					},
					"support_email": {
						"label": "E-mail zákaznické podpory"
					},
					"support_phone": {
						"label": "Telefonní číslo podpory"
					},
					"business_concepts": {
						"options": {
							"TRADITIONAL_SALE_OF_GOODS": "Tradiční prodej zboží",
							"VOUCHER": "Poukaz",
							"MEMBERSHIP": "Členství",
							"SUBSCRIPTION": "Předplatné",
							"PHARMACIES": "Lékárny",
							"US_PHARMACIES": "Lékárny v USA",
							"MEDICAL_SERVICES": "Zdravotnické služby",
							"MARKETPLACES": "Trhy",
							"FIREARM_DEALERS": "Prodejci střelných zbraní",
							"AUCTIONS": "Aukce",
							"ALCOHOL": "Alkohol",
							"TOBACCO": "Tabák",
							"HEMP_CBD_THC": "Konopí, CBD nebo THC",
							"DONATIONS_CHARITY": "Dary a charita",
							"TRAVEL": "Cestování",
							"EVENTS": "Události",
							"COURSES": "Kurzy",
							"EDUCATIONAL_COURSES": "Vzdělávací kurzy",
							"FOOD_DELIVERY": "Rozvoz potravin",
							"CUSTOMISED_PRE_ORDER_FURNITURE": "Předobjednávka na míru/nábytek",
							"DIGITAL_CONTENT": "Digitální obsah",
							"GAMING_INDUSTRY": "Herní průmysl (hazardní hry, sázky, kasina, loterie)"
						}
					}
				},
				"terms_and_conditions": {
					"default": "Smluvní podmínky",
					"UPSELL_WEBSTORE_TO_KPOS": "Podmínky Klarna V obchodě"
				},
				"pricing_terms": {
					"default": "Cenové podmínky",
					"UPSELL_WEBSTORE_TO_KPOS": "Ceny pro Klarna V obchodě"
				}
			}
		},
		"group": {
			"title": {
				"additional_data": "Další informace",
				"bank_account": "Jaké jsou podrobnosti o vašem bankovním účtu?",
				"business_size": "Jaký je váš očekávaný roční objem prodeje prostřednictvím prodejního místa Klarna?",
				"in_store_get_started": "Začněte podnikat s Klarnou.",
				"in_store_legal_form": "Jaký typ podnikání máte?",
				"in_store_registered_address": "Jaká je vaše registrovaná adresa?",
				"in_store_registration": "Je vaše firma registrovanou společností?",
				"in_store_stakeholder": "Kdo řídí společnost?",
				"in_store_stores": "Jaké jsou údaje o vašem obchodě pro prodejní místo Klarna?",
				"in_store_vat": "Je vaše firma registrovaným plátcem DPH?",
				"product_channel": "Jak plánuje vaše firma používat prodejní místo Klarna?",
				"sensitive_goods": "Jakou kategorii produktů budete prodávat pomocí prodejního místa Klarna.",
				"ads_manager_get_started": "Téměř hotovo.",
				"content_store_get_started": "Téměř hotovo."
			},
			"subtitle": {
				"additional_data": "Prověřujeme vaši žádost a k dalšímu postupu potřebujeme další informace.",
				"bank_account": "Na tento bankovní účet se budou převádět transakce Klarna.",
				"business_size": "Ke zpracování vaší žádosti potřebujeme základní informace o vaší firmě.",
				"in_store_get_started": "Potřebujeme několik základních informací, abychom vás dostali na správné místo.",
				"in_store_legal_form": "Na základě typu vašeho podnikání jsme povinni položit několik specifických otázek.",
				"in_store_registered_address": "Je to místo, kde je vaše firma právně registrována a bude se zobrazovat na fakturách zákazníků klarny.",
				"in_store_registration": "K ověření vašich obchodních údajů potřebujeme vaše registrační číslo společnosti.",
				"in_store_stakeholder": "Jako finanční instituce jsme povinni tyto informace shromažďovat.",
				"in_store_stores": "Tyto informace použijeme k nastavení vašeho nového účtu prodejního místa Klarna.",
				"in_store_vat": "Pokud máte DIČ, můžeme snadněji ověřit údaje o vaší společnosti.",
				"product_channel": "Vyberte si svůj primární prodejní kanál. Budete moci používat prodejní místo Klarna pro oba kanály.",
				"sensitive_goods": "Samoobslužný onboarding pro prodejní místo Klarna neumožňuje prodávat položky, které jsou společností Klarna definovány jako omezené.",
				"ads_manager_get_started": "Uveďte prosím fakturační e-mail, na který budou zasílány faktury za kampaň. Pro aktivaci účtu musíte být uživatelem s oprávněním správce. Správce pak může přidělovat oprávnění ostatním uživatelům.",
				"content_store_get_started": "Před získáním přístupu ke Správci obsahu si prosím přečtěte a přijměte naše smluvní podmínky."
			},
			"summary": {
				"title": "Před odesláním žádosti si zkontrolujte své údaje"
			},
			"status": {
				"UNDERWRITING_INITIATED": {
					"title": {
						"default": "Vaši žádost zpracováváme. Může to chvíli trvat.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Vydržte prosím...",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Vydržte prosím..."
					},
					"paragraphs": {
						"default": [
							{
								"text": "Vaše žádost se zpracovává a my vytváříme vaše nové ID obchodníka."
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Připravujeme vše pro váš účet Ads Manager."
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Připravujeme vše pro váš účet Správce obsahu."
							}
						]
					}
				},
				"ONBOARDING_COMPLETED": {
					"title": {
						"default": "Gratulujeme! Vaše žádost byla schválena.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Vše je připraveno!",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Vše je připraveno!"
					},
					"paragraphs": {
						"default": [
							{
								"text": "Pojďme nyní integrovat Klarnu do vašeho internetového obchodu. Přejděte na kartu Produkty ve svém účtu na Portálu obchodníka, kde najdete své integrační přihlašovací údaje a pokyny k jejich použití."
							}
						],
						"UPSELL_WEBSTORE_TO_KPOS": [
							{
								"text": "Nyní nastavte svůj obchod tak, abyste mohli ihned začít přijímat platby."
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Přejděte do Správce reklam a začněte vytvářet svou první kampaň."
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Přejděte do Správce obsahu a zveřejněte svou první nabídku ještě dnes."
							}
						]
					},
					"second_title": {
						"default": "Další informace o integraci s Klarnou naleznete v dokumentaci ke Klarně.",
						"UPSELL_WEBSTORE_TO_KPOS": "Potřebujete pomoc s nastavením obchodu? Jsme tu, abychom vám pomohli",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Potřebujete pomoc s používáním Správce reklam? Podívejte se na naše nejčastější dotazy nebo se obraťte na naši obchodní podporu, rádi vám pomůžeme.",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Potřebujete pomoc s používáním Správce obsahu? Podívejte se na naše nejčastější dotazy nebo se obraťte na naši obchodní podporu, rádi vám pomůžeme."
					},
					"second_paragraphs": {
						"default": [
							{
								"text": "Naše pokyny k osvědčeným postupům vám pomohou získat z nové spolupráce s námi maximum."
							},
							{
								"text": "Pokladna Klarna",
								"link": "#"
							},
							{
								"text": "Platby Klarna",
								"link": "#"
							}
						],
						"UPSELL_WEBSTORE_TO_KPOS": [
							{
								"text": "Obraťte se na naši obchodní podporu, rádi vám pomůžeme."
							},
							{
								"text": "Kontaktovat podporu",
								"link": "https://www.klarna.com/se/foretag/butikssupport/"
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Navštivte nečastější dotazy.",
								"link": "https://portal.klarna.com/?help-page=topic%3Aads-manager"
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Navštivte nečastější dotazy.",
								"link": "https://portal.klarna.com/?help-page=topic%3Acontent-manager"
							}
						]
					},
					"button_text": {
						"default": "Jdeme na to.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Jdeme na to",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Jdeme na to",
						"UPSELL_WEBSTORE_TO_KPOS": "Zahájit prodej"
					}
				},
				"MANUAL_UNDERWRITING_INITIATED": {
					"title": "Děkujeme! Kontrolujeme vaši žádost.",
					"badge": "Přibližně 5–7 dní",
					"paragraphs": [
						{
							"text": "Po dokončení přezkumu nebo v případě potřeby dalších informací obdržíte e-mail."
						}
					],
					"second_title": "Mezitím zkontrolujte svou poštu",
					"second_paragraphs": [
						{
							"text": "Odeslali jsme vám e-mail s odkazem „Vítejte na Portálu obchodníka Klarny“. Přihlaste se a aktivujte svůj účet podle následujících kroků."
						}
					]
				},
				"SUSPENDED": {
					"title": "Vaše žádost bohužel nebyla schválena.",
					"paragraphs": [
						{
							"text": "Po přezkoumání vašich obchodních údajů nemůžeme s vaší žádostí o <strong>{businessName}</strong> dále pracovat."
						},
						{
							"text": "Toto jsou některé z nejčastějších důvodů:"
						},
						{
							"list": [
								{
									"text": "Váš obchod nesplňuje etické zásady společnosti Klarna."
								},
								{
									"text": "Váš zákaznický servis je nedostupný."
								},
								{
									"text": "Další administrativní faktory."
								}
							]
						},
						{
							"text": "Děkujeme vám za váš zájem o <strong>Klarna [In-store]</strong>. Doufáme, že budeme moci obchodovat i v budoucnu."
						}
					],
					"second_title": "Pokud máte další otázky",
					"second_paragraphs": [
						{
							"text": "Pokud jde o naše rozhodnutí nebo jakýkoli jiný produkt společnosti Klarna, kontaktujte nás, rádi vám pomůžeme."
						}
					]
				}
			},
			"stakeholders": {
				"LEGAL_REPRESENTATIVE": {
					"title": {
						"default": "Kdo podepisuje smlouvy za vaši společnost?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Vaše společnost se chystá uzavřít smlouvu se společností Klarna. Musíme ověřit, kdo je legálně oprávněn podepisovat smlouvy."
							}
						]
					}
				},
				"OWNER": {
					"title": {
						"default": "Vlastní někdo více než 25 % společnosti?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Jako finanční instituce jsme ze zákona povinni tyto informace shromažďovat."
							}
						],
						"default": [
							{
								"text": "Potřebujeme znát osoby, které vlastní více než 25 % akcií nebo hlasovacích práv společnosti nebo vykonávají podobnou kontrolu. Shromažďování těchto informací nám ukládá směrnice EU ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") o boji proti praní špinavých peněz."
							}
						]
					}
				},
				"ALTERNATIVE_BENEFICIAL_OWNER": {
					"title": {
						"default": "Kdo řídí společnost?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Shromažďování těchto informací nám ukládá směrnice EU ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") o boji proti praní špinavých peněz."
							}
						],
						"US": [
							{
								"text": "Jako finanční instituce jsme ze zákona povinni tyto informace shromažďovat."
							}
						],
						"CA": [
							{
								"text": "Jako finanční instituce jsme ze zákona povinni tyto informace shromažďovat."
							}
						],
						"AU": [
							{
								"text": "Jako finanční instituce jsme ze zákona povinni tyto informace shromažďovat."
							}
						]
					}
				},
				"ULTIMATE_BENEFICIAL_OWNER": {
					"title": {
						"default": "Vlastní někdo více než 25 % společnosti?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Jako finanční instituce jsme ze zákona povinni tyto informace shromažďovat."
							}
						],
						"default": [
							{
								"text": "Potřebujeme znát osoby, které vlastní více než 25 % akcií nebo hlasovacích práv společnosti nebo vykonávají podobnou kontrolu. Shromažďování těchto informací nám ukládá směrnice EU ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") o boji proti praní špinavých peněz."
							}
						]
					}
				}
			}
		},
		"product-selection-container": {
			"products": {
				"products_block": {
					"title_1": "Řešení",
					"title_2": "Způsoby platby",
					"note": "Všechny ceny jsou uvedeny za transakci.",
					"per_transaction": "Typ transakce",
					"cross_border_notice": "Mohou být účtovány další přeshraniční poplatky",
					"cross_border_notice_pricing_annex_suffix": {
						"before_link": "viz",
						"link_text": "příloha s cenami"
					},
					"not_available_for_business": "Není k dispozici pro vaše podnikání",
					"not_available_for_country": "Můžete prodávat pouze na jiné trhy",
					"not_compatible_with_platform": "Není k dispozici pro vaši platformu",
					"installed": "Instalováno"
				},
				"buttons": {
					"next": "Další"
				}
			}
		}
	}
};